<template>
  <div class="dem-edi-pro-doc">
    <div class="documento" :class="(cpntPDocNFEmitida === true && cpntPDocAcoes.danfe === '1') ? 'com-botao' : ''"  v-show="[ 'dev_cliente', 'dev_fornecedor', 'venda', 'compra' ].indexOf(cpntDemStatus) !== -1">
      <!-- SETA O CAMPO DOCUMENTO -->
      <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_tp"
        :cpntStatus='campos.p_doc_tp.status'
        :cpntId='campos.p_doc_tp.id'
        :cpntTabIndex='campos.p_doc_tp.tabIndex'
        :cpntNome='campos.p_doc_tp.nome'
        :cpntValue='campos.p_doc_tp.value'
        :cpntMensagem='campos.p_doc_tp.mensagem'
        :cpntMensagemTipo='campos.p_doc_tp.mensagemTipo'
        :cpntDisabled='[ "venda", "compra" ].indexOf(cpntDemStatus) === -1 || cpntPDocNFEmitida === true || campos.p_doc_tp.disabled'
        :cpntMostrar='campos.p_doc_tp.mostrar'
        :cpntExplica='campos.p_doc_tp.explica'
        :cpntPlaceholder='campos.p_doc_tp.placeholder'
        :cpntValueRef='campos.p_doc_tp.valueRef'
        :cpntRouter='campos.p_doc_tp.router'
        :cpntField='campos.p_doc_tp.field'
        :cpntWhere='campos.p_doc_tp.where'
        :cpntAddButForm='campos.p_doc_tp.addButForm'
        :cpntKeyMostra='campos.p_doc_tp.keyMostra'
        :cpntTipoOrder='campos.p_doc_tp.tipoOrder'
        :cpntOrder='campos.p_doc_tp.order'
        :cpntOptions='campos.p_doc_tp.options'
        :cpntKeyValue='campos.p_doc_tp.keyValue'
        :cpntSearchMinimo='campos.p_doc_tp.searchMinimo'
        :cpntMask='campos.p_doc_tp.mask'
        :cpntOptionInicialNome='campos.p_doc_tp.optionInicialNome'
        :cpntOptionInicialValue='campos.p_doc_tp.optionInicialValue'

        :cpntOnChange='campos.p_doc_tp.onChange'
        :cpntOnBlur='campos.p_doc_tp.onBlur'
        :cpntOnKeyPressEnter='campos.p_doc_tp.onKeyPressEnter'
        ref="p_doc_tp"
      ></App-Select>
      
      <!-- SETA O BOTÃO PARA MOSTRAR DETALHES -->
      <App-Button v-if="cpntPDocNFEmitida === true && cpntPDocAcoes.danfe === '1'" @onClick="() => { mostrarDetalhes = !mostrarDetalhes }">
        <template v-if="mostrarDetalhes === true">
          Ocultar Detalhes
        </template>
        <template v-else>
          Mostrar Detalhes
        </template>
      </App-Button>
    </div>

    <div class="campos">
      <div v-if="[ 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(cpntPDocTp) !== -1" class="dem-edi-doc-fornecedor">
        <template v-if="cpntPDocTp === 'NFeFornecedor'">
          NF-e de Fornecedor
        </template>
        <template v-else-if="cpntPDocTp === 'NFCeFornecedor'">
          NFC-e de Fornecedor
        </template>
      </div>

      <template v-if="demEdiProDocVerificarNotaFiscal === true">
        <div class="dem-edi-doc-df" v-if="[ '', null, undefined ].indexOf(cpntPDocFiscal.DocNumero) === -1">
          <div>
            <div>Ambiente: </div>
            <b v-html='cpntPDocFiscal.tpAmb === "2" ? "Homologação" : "Produção"'></b>
          </div>
          <div>
            <div>Número: </div>
            <b v-html='cpntPDocFiscal.DocNumero'></b>
          </div>
          <div>
            <div>Série: </div>
            <span v-html='cpntPDocFiscal.DocSerie'></span>
          </div>
          <div>
            <div>Data/Hora Emissão: </div>
            <span v-html='cpntPDocFiscal.DocDhAut'></span>
          </div>
          <template v-if="cpntPDocNFEmitida === true && cpntPDocAcoes.danfe === '1'">
            <div v-if="cpntDemanda !== 'dev_fornecedor' && cpntPDV === false && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
              <div>Pagamentos: </div>
              <App-Button @onClick="() => { demEdiProDocMostrarFormularioPagamento() }">Abrir pagamentos</App-Button>
            </div>
            <div v-if="cpntPDocTp === 'NFe'">
              <div>Carta de Correção: </div>
              <App-Button @onClick="() => { demEdiProDocMostrarFormularioCartaCorrecao() }">Emitir CC-e</App-Button>
            </div>
          </template>
        </div>

        <template v-if="mostrarDetalhes === true || (cpntPDocNFEmitida === false || cpntPDocAcoes.danfe !== '1')">
          <div v-if="[ 'NFCe' ].indexOf(cpntPDocTp) !== -1">
            <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--cnpj_cpf"
              :cpntStatus='campos.cnpj_cpf.status'
              :cpntId='campos.cnpj_cpf.id'
              :cpntClassDivField='campos.cnpj_cpf.classDivField'
              :cpntTabIndex='campos.cnpj_cpf.tabIndex'
              :cpntNome='campos.cnpj_cpf.nome'
              :cpntValue='campos.cnpj_cpf.value'
              :cpntAutoComplete='campos.cnpj_cpf.autocomplete'
              :cpntMask='campos.cnpj_cpf.mask'
              :cpntOptionInicialNome='campos.cnpj_cpf.optionInicialNome'
              :cpntOptionInicialValue='campos.cnpj_cpf.optionInicialValue'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.cnpj_cpf.disabled === true'
              :cpntMostrar='campos.cnpj_cpf.mostrar'
              :cpntAutoFocus='campos.cnpj_cpf.autofocus'
              :cpntMensagem='campos.cnpj_cpf.mensagem'
              :cpntMensagemTipo='campos.cnpj_cpf.mensagemTipo'
              :cpntPlaceholder='campos.cnpj_cpf.placeholder'
              :cpntPosicionar='campos.cnpj_cpf.posicionar'
              :cpntOnChange='campos.cnpj_cpf.onChange'
              :cpntOnBlur='campos.cnpj_cpf.onBlur'
              ref='cnpj_cpf'
            ></App-Input>    
          </div>

          <div class="p_doc_ope" v-if="cpntDemanda !== 'compra'">
            <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_ope"
              :cpntStatus='campos.p_doc_ope.status'
              :cpntId='campos.p_doc_ope.id'
              :cpntTabIndex='campos.p_doc_ope.tabIndex'
              :cpntNome='campos.p_doc_ope.nome'
              :cpntValue='campos.p_doc_ope.value'
              :cpntMensagem='campos.p_doc_ope.mensagem'
              :cpntMensagemTipo='campos.p_doc_ope.mensagemTipo'
              :cpntDisabled='[ "dev_cliente", "dev_fornecedor" ].indexOf(cpntDemanda) !== -1 || [ "NFCe" ].indexOf(cpntPDocTp) !== -1 || cpntPDocNFEmitida === true || campos.p_doc_ope.disabled'
              :cpntMostrar='campos.p_doc_ope.mostrar'
              :cpntExplica='campos.p_doc_ope.explica'
              :cpntPlaceholder='campos.p_doc_ope.placeholder'
              :cpntValueRef='campos.p_doc_ope.valueRef'
              :cpntRouter='campos.p_doc_ope.router'
              :cpntField='campos.p_doc_ope.field'
              :cpntWhere='campos.p_doc_ope.where'
              :cpntAddButForm='campos.p_doc_ope.addButForm'
              :cpntKeyMostra='campos.p_doc_ope.keyMostra'
              :cpntTipoOrder='campos.p_doc_ope.tipoOrder'
              :cpntOrder='campos.p_doc_ope.order'
              :cpntOptions='campos.p_doc_ope.options'
              :cpntKeyValue='campos.p_doc_ope.keyValue'
              :cpntSearchMinimo='campos.p_doc_ope.searchMinimo'
              :cpntMask='campos.p_doc_ope.mask'
              :cpntOptionInicialNome='campos.p_doc_ope.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_ope.optionInicialValue'

              :cpntOnChange='campos.p_doc_ope.onChange'
              :cpntOnBlur='campos.p_doc_ope.onBlur'
              :cpntOnRealizaBusca='campos.p_doc_ope.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_doc_ope.onKeyPressEnter'
              ref="p_doc_ope"
            ></App-Select>
          </div>

          <div class="p_doc_nat_ope" :class="cpntPDocNFEmitida !== false ? 'ocultar-bt-sugerir' : ''">
            <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_nat_ope"
              :cpntStatus='campos.p_doc_nat_ope.status'
              :cpntId='campos.p_doc_nat_ope.id'
              :cpntTabIndex='campos.p_doc_nat_ope.tabIndex'
              :cpntClassDivField='campos.p_doc_nat_ope.classDivField'
              :cpntNome='campos.p_doc_nat_ope.nome'
              :cpntValue='campos.p_doc_nat_ope.value'
              :cpntAutoComplete='campos.p_doc_nat_ope.autocomplete'
              :cpntMask='campos.p_doc_nat_ope.mask'
              :cpntOptionInicialNome='campos.p_doc_nat_ope.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_nat_ope.optionInicialValue'
              :cpntDisabled='[ "NFCe" ].indexOf(cpntPDocTp) !== -1 || cpntPDocNFEmitida === true || campos.p_doc_nat_ope.disabled === true'
              :cpntMostrar='campos.p_doc_nat_ope.mostrar'
              :cpntAutoFocus='campos.p_doc_nat_ope.autofocus'
              :cpntMensagem='campos.p_doc_nat_ope.mensagem'
              :cpntMensagemTipo='campos.p_doc_nat_ope.mensagemTipo'
              :cpntPlaceholder='campos.p_doc_nat_ope.placeholder'
              :cpntPosicionar='campos.p_doc_nat_ope.posicionar'
              :cpntOnChange='campos.p_doc_nat_ope.onChange'
              :cpntOnBlur='campos.p_doc_nat_ope.onBlur'
              ref='p_doc_nat_ope'
            ></App-Input>

            <App-Button :data-time='time' class="app-cpnt-field dem-edi-pro-doc--sugerirBT" v-if='cpntPDocNFEmitida === false'
              :cpntStatus='campos.sugerirBT.status' 
              :cpntId='campos.sugerirBT.id' 
              :cpntTexto='campos.sugerirBT.texto' 
              :cpntClass='campos.sugerirBT.class'
              :cpntMostrar='campos.sugerirBT.mostrar'
              :cpntDisabled='[ "NFCe" ].indexOf(cpntPDocTp) !== -1'
              :cpntExplica='campos.sugerirBT.explica'
              :cpntTabIndex='campos.sugerirBT.tabIndex'
              @onClick='campos.sugerirBT.onClick'
            ></App-Button>
          </div>

          <div class="p_doc_icms_aa" v-if="[ 'venda', 'compra' ].indexOf(cpntDemanda) !== -1 && [ 'NFe' ].indexOf(cpntPDocTp) !== -1 && ((cpntPDocNFEmitida === false && $store.state.licenca.rt_id !== '3') || (cpntPDocNFEmitida === true && [ '', null, undefined, '0', '0,0', '0,00' ].indexOf(cpntDocIcmsAa) === -1))">
            Alíquota Aplicável: <div class="valor" v-html="cpntDocIcmsAa + '%'"></div>
            <App-Button :data-time='time' :cpntClass="'btn btn-sm btn-default'" @onClick="demEdiProAtualizarAliquotaAplicavel" v-if="cpntPDocNFEmitida === false">
              Atualizar
            </App-Button>
          </div>

          <template v-if="cpntDemanda !== 'compra'">
            <div class="p_doc_fin" :class="(demEdiProDocMostarReferenciar === true ? 'mostrar-referenciar' : '') + ' ' + (demEdiProDocMontarValorReferenciar === true ? '' : '')"> <!-- mostrar-adicionar -->
              <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_fin"
                :cpntStatus='campos.p_doc_fin.status'
                :cpntId='campos.p_doc_fin.id'
                :cpntTabIndex='campos.p_doc_fin.tabIndex'
                :cpntNome='campos.p_doc_fin.nome'
                :cpntValue='campos.p_doc_fin.value'
                :cpntMensagem='campos.p_doc_fin.mensagem'
                :cpntMensagemTipo='campos.p_doc_fin.mensagemTipo'
                :cpntDisabled='[ "dev_cliente", "dev_fornecedor" ].indexOf(cpntDemanda) !== -1 || [ "NFCe" ].indexOf(cpntPDocTp) !== -1 || cpntPDocNFEmitida === true || campos.p_doc_fin.disabled'
                :cpntMostrar='campos.p_doc_fin.mostrar'
                :cpntExplica='campos.p_doc_fin.explica'
                :cpntPlaceholder='campos.p_doc_fin.placeholder'
                :cpntValueRef='campos.p_doc_fin.valueRef'
                :cpntRouter='campos.p_doc_fin.router'
                :cpntField='campos.p_doc_fin.field'
                :cpntWhere='campos.p_doc_fin.where'
                :cpntAddButForm='campos.p_doc_fin.addButForm'
                :cpntKeyMostra='campos.p_doc_fin.keyMostra'
                :cpntTipoOrder='campos.p_doc_fin.tipoOrder'
                :cpntOrder='campos.p_doc_fin.order'
                :cpntOptions='campos.p_doc_fin.options'
                :cpntKeyValue='campos.p_doc_fin.keyValue'
                :cpntSearchMinimo='campos.p_doc_fin.searchMinimo'
                :cpntMask='campos.p_doc_fin.mask'
                :cpntOptionInicialNome='campos.p_doc_fin.optionInicialNome'
                :cpntOptionInicialValue='campos.p_doc_fin.optionInicialValue'

                :cpntOnChange='campos.p_doc_fin.onChange'
                :cpntOnBlur='campos.p_doc_fin.onBlur'
                :cpntOnRealizaBusca='campos.p_doc_fin.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_doc_fin.onKeyPressEnter'
                ref="p_doc_fin"
              ></App-Select>

              <App-Toggles :data-time="time" class="app-cpnt-field dem-edi-pro-doc--referenciar_j_p_doc_ref_ca"
                :cpntStatus='campos.referenciar_j_p_doc_ref_ca.status'
                :cpntId='campos.referenciar_j_p_doc_ref_ca.id'
                :cpntClassDivField='campos.referenciar_j_p_doc_ref_ca.classDivField'
                :cpntNome='campos.referenciar_j_p_doc_ref_ca.nome'
                :cpntValue='campos.referenciar_j_p_doc_ref_ca.value'
                :cpntDisabled='[ "dev_cliente", "dev_fornecedor" ].indexOf(cpntDemanda) !== -1 || [ "NFCe" ].indexOf(cpntPDocTp) !== -1 || cpntPDocNFEmitida === true || campos.referenciar_j_p_doc_ref_ca.disabled'
                :cpntMostrar='campos.referenciar_j_p_doc_ref_ca.mostrar'
                :cpntMensagem='campos.referenciar_j_p_doc_ref_ca.mensagem'
                :cpntMensagemTipo='campos.referenciar_j_p_doc_ref_ca.mensagemTipo'
                :cpntOn='campos.referenciar_j_p_doc_ref_ca.on'
                :cpntOff='campos.referenciar_j_p_doc_ref_ca.off'
                :cpntExplica='campos.referenciar_j_p_doc_ref_ca.explica'
                :cpntWidth='campos.referenciar_j_p_doc_ref_ca.width'
                :cpntTabIndex='campos.referenciar_j_p_doc_ref_ca.tabIndex'

                :cpntOnChange='campos.referenciar_j_p_doc_ref_ca.onChange'
                :cpntOnBlur='campos.referenciar_j_p_doc_ref_ca.onBlur'
                ref='referenciar_j_p_doc_ref_ca'
              ></App-Toggles>

              <!-- <App-Button :data-time='time' class="app-cpnt-field dem-edi-pro-doc--referenciarNovaChave"
                :cpntStatus='campos.referenciarNovaChave.status' 
                :cpntId='campos.referenciarNovaChave.id' 
                :cpntTipo='campos.referenciarNovaChave.tipo' 
                :cpntIcone='campos.referenciarNovaChave.icone' 
                :cpntTexto='campos.referenciarNovaChave.texto' 
                :cpntClass='campos.referenciarNovaChave.class'
                :cpntMostrar='campos.referenciarNovaChave.mostrar'
                :cpntExplica='campos.referenciarNovaChave.explica'
                :cpntTabIndex='campos.referenciarNovaChave.tabIndex'
                @onClick='campos.referenciarNovaChave.onClick'
              ></App-Button> -->
            </div>

            <template v-if="demEdiProDocMontarValorReferenciar === true">
              <div v-for="(valor, indexV, indexI) in campos.j_p_doc_ref_ca.value" :key="'j_p_doc_ref_ca' + indexV" class="j_p_doc_ref_ca dem-edi-pro-doc--j_p_doc_ref_ca">
                <App-Input :data-time="time" class="app-cpnt-field"
                  :cpntStatus='campos.j_p_doc_ref_ca.status'
                  :cpntId='campos.j_p_doc_ref_ca.id + indexV'
                  :cpntClassDivField='campos.j_p_doc_ref_ca.classDivField'
                  :cpntNome='"Chave referenciada " + (indexI + 1)'
                  :cpntValue='valor'
                  :cpntAutoComplete='campos.j_p_doc_ref_ca.autocomplete'
                  :cpntType='campos.j_p_doc_ref_ca.type'
                  :cpntMaxLength='campos.j_p_doc_ref_ca.maxLength'
                  :cpntMask='campos.j_p_doc_ref_ca.mask'
                  :cpntOptionInicialNome='campos.j_p_doc_ref_ca.optionInicialNome'
                  :cpntOptionInicialValue='campos.j_p_doc_ref_ca.optionInicialValue'
                  :cpntDisabled='[ "dev_cliente", "dev_fornecedor" ].indexOf(cpntDemanda) !== -1 || cpntPDocNFEmitida === true || campos.j_p_doc_ref_ca.disabled'
                  :cpntMostrar='campos.j_p_doc_ref_ca.mostrar'
                  :cpntAutoFocus='campos.j_p_doc_ref_ca.autofocus'
                  :cpntMensagem='campos.j_p_doc_ref_ca.mensagem'
                  :cpntMensagemTipo='campos.j_p_doc_ref_ca.mensagemTipo'
                  :cpntPlaceholder='campos.j_p_doc_ref_ca.placeholder'
                  :cpntPosicionar='campos.j_p_doc_ref_ca.posicionar'
                  :cpntOnChange='campos.j_p_doc_ref_ca.onChange'
                  :cpntOnBlur='campos.j_p_doc_ref_ca.onBlur'
                  ref='j_p_doc_ref_ca'
                ></App-Input>

                <!-- CONSULTAR -->
                <button class="app-cpnt-field btn btn-default btn-sm" title="Clique aqui para consultar a chave de acesso" @click="demEdiProDocConsultarChaveReferenciada(valor)">
                  <svg class="fas fa-external-link-alt"></svg>
                </button>

                <!-- EXCLUIR -->
                <!-- <button class="app-cpnt-field btn btn-danger btn-sm" title="Clique aqui para remover esta chave de acesso" v-show="[ '4' ].indexOf(campos.p_doc_fin.value.id) === -1" @click="demEdiProDocRemoverChaveReferenciada(indexV)" :disabled="demEdiProDocDisabilitarExclusaoReferencia">
                  <svg class="fa fa-trash"></svg>
                </button> -->
              </div>
            </template>
          </template>

          <div class="p_doc_ind_pres">
            <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_ind_pres"
              :cpntStatus='campos.p_doc_ind_pres.status'
              :cpntId='campos.p_doc_ind_pres.id'
              :cpntTabIndex='campos.p_doc_ind_pres.tabIndex'
              :cpntNome='campos.p_doc_ind_pres.nome'
              :cpntValue='campos.p_doc_ind_pres.value'
              :cpntMensagem='campos.p_doc_ind_pres.mensagem'
              :cpntMensagemTipo='campos.p_doc_ind_pres.mensagemTipo'
              :cpntDisabled='[ "dev_cliente", "dev_fornecedor" ].indexOf(cpntDemanda) !== -1 || cpntPDocNFEmitida === true || campos.p_doc_ind_pres.disabled'
              :cpntMostrar='campos.p_doc_ind_pres.mostrar'
              :cpntExplica='campos.p_doc_ind_pres.explica'
              :cpntPlaceholder='campos.p_doc_ind_pres.placeholder'
              :cpntValueRef='campos.p_doc_ind_pres.valueRef'
              :cpntRouter='campos.p_doc_ind_pres.router'
              :cpntField='campos.p_doc_ind_pres.field'
              :cpntWhere='campos.p_doc_ind_pres.where'
              :cpntAddButForm='campos.p_doc_ind_pres.addButForm'
              :cpntKeyMostra='campos.p_doc_ind_pres.keyMostra'
              :cpntTipoOrder='campos.p_doc_ind_pres.tipoOrder'
              :cpntOrder='campos.p_doc_ind_pres.order'
              :cpntOptions='campos.p_doc_ind_pres.options'
              :cpntKeyValue='campos.p_doc_ind_pres.keyValue'
              :cpntSearchMinimo='campos.p_doc_ind_pres.searchMinimo'
              :cpntMask='campos.p_doc_ind_pres.mask'
              :cpntOptionInicialNome='campos.p_doc_ind_pres.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_ind_pres.optionInicialValue'

              :cpntOnChange='campos.p_doc_ind_pres.onChange'
              :cpntOnBlur='campos.p_doc_ind_pres.onBlur'
              :cpntOnRealizaBusca='campos.p_doc_ind_pres.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_doc_ind_pres.onKeyPressEnter'
              ref="p_doc_ind_pres"
            ></App-Select>
          </div>

          <div v-if="demEdiProDocMostarIntermediador === true" class="dem-edi-pro-doc--p_id_ven_cfg_intermediador">
            <App-Select :data-time="time" class="app-cpnt-field"
              :cpntStatus='campos.p_id_ven_cfg_intermediador.status'
              :cpntId='campos.p_id_ven_cfg_intermediador.id'
              :cpntTabIndex='campos.p_id_ven_cfg_intermediador.tabIndex'
              :cpntNome='campos.p_id_ven_cfg_intermediador.nome'
              :cpntValue='campos.p_id_ven_cfg_intermediador.value'
              :cpntMensagem='campos.p_id_ven_cfg_intermediador.mensagem'
              :cpntMensagemTipo='campos.p_id_ven_cfg_intermediador.mensagemTipo'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.p_id_ven_cfg_intermediador.disabled'
              :cpntMostrar='campos.p_id_ven_cfg_intermediador.mostrar'
              :cpntExplica='campos.p_id_ven_cfg_intermediador.explica'
              :cpntPlaceholder='campos.p_id_ven_cfg_intermediador.placeholder'
              :cpntValueRef='campos.p_id_ven_cfg_intermediador.valueRef'
              :cpntRouter='campos.p_id_ven_cfg_intermediador.router'
              :cpntField='campos.p_id_ven_cfg_intermediador.field'
              :cpntWhere='campos.p_id_ven_cfg_intermediador.where'
              :cpntAddButForm='campos.p_id_ven_cfg_intermediador.addButForm'
              :cpntKeyMostra='campos.p_id_ven_cfg_intermediador.keyMostra'
              :cpntTipoOrder='campos.p_id_ven_cfg_intermediador.tipoOrder'
              :cpntOrder='campos.p_id_ven_cfg_intermediador.order'
              :cpntOptions='campos.p_id_ven_cfg_intermediador.options'
              :cpntKeyValue='campos.p_id_ven_cfg_intermediador.keyValue'
              :cpntSearchMinimo='campos.p_id_ven_cfg_intermediador.searchMinimo'
              :cpntMask='campos.p_id_ven_cfg_intermediador.mask'
              :cpntOptionInicialNome='campos.p_id_ven_cfg_intermediador.optionInicialNome'
              :cpntOptionInicialValue='campos.p_id_ven_cfg_intermediador.optionInicialValue'

              :cpntOnBuscarOptions='campos.p_id_ven_cfg_intermediador.onBuscarOptions'
              :cpntOnChange='campos.p_id_ven_cfg_intermediador.onChange'
              :cpntOnBlur='campos.p_id_ven_cfg_intermediador.onBlur'
              :cpntOnRealizaBusca='campos.p_id_ven_cfg_intermediador.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_id_ven_cfg_intermediador.onKeyPressEnter'
              ref="p_id_ven_cfg_intermediador"
            ></App-Select>
          </div>

          <div class="p_doc_fre_tp">
            <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_fre_tp"
              :cpntStatus='campos.p_doc_fre_tp.status'
              :cpntId='campos.p_doc_fre_tp.id'
              :cpntTabIndex='campos.p_doc_fre_tp.tabIndex'
              :cpntNome='campos.p_doc_fre_tp.nome'
              :cpntValue='campos.p_doc_fre_tp.value'
              :cpntMensagem='campos.p_doc_fre_tp.mensagem'
              :cpntMensagemTipo='campos.p_doc_fre_tp.mensagemTipo'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_fre_tp.disabled'
              :cpntMostrar='campos.p_doc_fre_tp.mostrar'
              :cpntExplica='campos.p_doc_fre_tp.explica'
              :cpntPlaceholder='campos.p_doc_fre_tp.placeholder'
              :cpntValueRef='campos.p_doc_fre_tp.valueRef'
              :cpntRouter='campos.p_doc_fre_tp.router'
              :cpntField='campos.p_doc_fre_tp.field'
              :cpntWhere='campos.p_doc_fre_tp.where'
              :cpntAddButForm='campos.p_doc_fre_tp.addButForm'
              :cpntKeyMostra='campos.p_doc_fre_tp.keyMostra'
              :cpntTipoOrder='campos.p_doc_fre_tp.tipoOrder'
              :cpntOrder='campos.p_doc_fre_tp.order'
              :cpntOptions='campos.p_doc_fre_tp.options'
              :cpntKeyValue='campos.p_doc_fre_tp.keyValue'
              :cpntSearchMinimo='campos.p_doc_fre_tp.searchMinimo'
              :cpntMask='campos.p_doc_fre_tp.mask'
              :cpntOptionInicialNome='campos.p_doc_fre_tp.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_fre_tp.optionInicialValue'

              :cpntOnChange='campos.p_doc_fre_tp.onChange'
              :cpntOnBlur='campos.p_doc_fre_tp.onBlur'
              :cpntOnRealizaBusca='campos.p_doc_fre_tp.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_doc_fre_tp.onKeyPressEnter'
              ref="p_doc_fre_tp"
            ></App-Select>
          </div>

          <template v-if="demEdiProDocMostarTransportadora === true">
            <div class="dem-edi-pro-form--p_doc_fre_id">
              <App-Autocompletar :data-time="time" class="app-cpnt-field"
                :cpntStatus='campos.p_doc_fre_id.status'
                :cpntId='campos.p_doc_fre_id.id'
                :cpntTabIndex='campos.p_doc_fre_id.tabIndex'
                :cpntNome='campos.p_doc_fre_id.nome'
                :cpntValue='campos.p_doc_fre_id.value'
                :cpntMensagem='campos.p_doc_fre_id.mensagem'
                :cpntMensagemTipo='campos.p_doc_fre_id.mensagemTipo'
                :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_fre_id.disabled'
                :cpntMostrar='campos.p_doc_fre_id.mostrar'
                :cpntExplica='campos.p_doc_fre_id.explica'
                :cpntPlaceholder='campos.p_doc_fre_id.placeholder'
                :cpntValueRef='campos.p_doc_fre_id.valueRef'
                :cpntRouter='campos.p_doc_fre_id.router'
                :cpntMethod='campos.p_doc_fre_id.method'
                :cpntField='campos.p_doc_fre_id.field'
                :cpntWhere='campos.p_doc_fre_id.where'
                :cpntAddButForm='campos.p_doc_fre_id.addButForm'
                :cpntKeyMostra='campos.p_doc_fre_id.keyMostra'
                :cpntTipoOrder='campos.p_doc_fre_id.tipoOrder'
                :cpntOrder='campos.p_doc_fre_id.order'
                :cpntOptions='campos.p_doc_fre_id.options'
                :cpntKeyValue='campos.p_doc_fre_id.keyValue'
                :cpntSearchMinimo='campos.p_doc_fre_id.searchMinimo'
                :cpntMask='campos.p_doc_fre_id.mask'
                :cpntOptionInicialNome='campos.p_doc_fre_id.optionInicialNome'
                :cpntOptionInicialValue='campos.p_doc_fre_id.optionInicialValue'
                :cpntNewOption='campos.p_doc_fre_id.newOption'

                :cpntOnChange='campos.p_doc_fre_id.onChange'
                :cpntOnBlur='campos.p_doc_fre_id.onBlur'
                :cpntOnRealizaBusca='campos.p_doc_fre_id.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_doc_fre_id.onKeyPressEnter'
                ref="item"
              ></App-Autocompletar>
            </div>

            <div class="dem-edi-pro-form--veiculo_transp" :class="(demEdiProDocMostarPlacaTransporte === true ? 'mostrar-placa-transporte' : '')">
              <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_fre_placa_uf"
                :cpntStatus='campos.p_doc_fre_placa_uf.status'
                :cpntId='campos.p_doc_fre_placa_uf.id'
                :cpntTabIndex='campos.p_doc_fre_placa_uf.tabIndex'
                :cpntNome='campos.p_doc_fre_placa_uf.nome'
                :cpntValue='campos.p_doc_fre_placa_uf.value'
                :cpntMensagem='campos.p_doc_fre_placa_uf.mensagem'
                :cpntMensagemTipo='campos.p_doc_fre_placa_uf.mensagemTipo'
                :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_fre_placa_uf.disabled'
                :cpntMostrar='campos.p_doc_fre_placa_uf.mostrar'
                :cpntExplica='campos.p_doc_fre_placa_uf.explica'
                :cpntPlaceholder='campos.p_doc_fre_placa_uf.placeholder'
                :cpntValueRef='campos.p_doc_fre_placa_uf.valueRef'
                :cpntRouter='campos.p_doc_fre_placa_uf.router'
                :cpntField='campos.p_doc_fre_placa_uf.field'
                :cpntWhere='campos.p_doc_fre_placa_uf.where'
                :cpntAddButForm='campos.p_doc_fre_placa_uf.addButForm'
                :cpntKeyMostra='campos.p_doc_fre_placa_uf.keyMostra'
                :cpntTipoOrder='campos.p_doc_fre_placa_uf.tipoOrder'
                :cpntOrder='campos.p_doc_fre_placa_uf.order'
                :cpntOptions='campos.p_doc_fre_placa_uf.options'
                :cpntKeyValue='campos.p_doc_fre_placa_uf.keyValue'
                :cpntSearchMinimo='campos.p_doc_fre_placa_uf.searchMinimo'
                :cpntMask='campos.p_doc_fre_placa_uf.mask'
                :cpntOptionInicialNome='campos.p_doc_fre_placa_uf.optionInicialNome'
                :cpntOptionInicialValue='campos.p_doc_fre_placa_uf.optionInicialValue'

                :cpntOnChange='campos.p_doc_fre_placa_uf.onChange'
                :cpntOnBlur='campos.p_doc_fre_placa_uf.onBlur'
                :cpntOnRealizaBusca='campos.p_doc_fre_placa_uf.onRealizaBusca'
                :cpntOnKeyPressEnter='campos.p_doc_fre_placa_uf.onKeyPressEnter'
                ref="p_doc_fre_placa_uf"
              ></App-Select>

              <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_fre_placa"
                :cpntStatus='campos.p_doc_fre_placa.status'
                :cpntId='campos.p_doc_fre_placa.id'
                :cpntClassDivField='campos.p_doc_fre_placa.classDivField'
                :cpntNome='campos.p_doc_fre_placa.nome'
                :cpntValue='campos.p_doc_fre_placa.value'
                :cpntAutoComplete='campos.p_doc_fre_placa.autocomplete'
                :cpntMask='campos.p_doc_fre_placa.mask'
                :cpntOptionInicialNome='campos.p_doc_fre_placa.optionInicialNome'
                :cpntOptionInicialValue='campos.p_doc_fre_placa.optionInicialValue'
                :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_fre_placa.disabled'
                :cpntMostrar='campos.p_doc_fre_placa.mostrar'
                :cpntAutoFocus='campos.p_doc_fre_placa.autofocus'
                :cpntMensagem='campos.p_doc_fre_placa.mensagem'
                :cpntMensagemTipo='campos.p_doc_fre_placa.mensagemTipo'
                :cpntPlaceholder='campos.p_doc_fre_placa.placeholder'
                :cpntPosicionar='campos.p_doc_fre_placa.posicionar'
                :cpntOnChange='campos.p_doc_fre_placa.onChange'
                :cpntOnBlur='campos.p_doc_fre_placa.onBlur'
                ref='p_doc_fre_placa'
              ></App-Input>
            </div>

            <div>
              <App-Toggles :data-time="time" class="app-cpnt-field dem-edi-pro-doc--informar_p_doc_fre_volumes"
                :cpntStatus='campos.informar_p_doc_fre_volumes.status'
                :cpntId='campos.informar_p_doc_fre_volumes.id'
                :cpntClassDivField='campos.informar_p_doc_fre_volumes.classDivField'
                :cpntNome='campos.informar_p_doc_fre_volumes.nome'
                :cpntValue='campos.informar_p_doc_fre_volumes.value'
                :cpntDisabled='cpntPDocNFEmitida === true || campos.informar_p_doc_fre_volumes.disabled'
                :cpntMostrar='campos.informar_p_doc_fre_volumes.mostrar'
                :cpntMensagem='campos.informar_p_doc_fre_volumes.mensagem'
                :cpntMensagemTipo='campos.informar_p_doc_fre_volumes.mensagemTipo'
                :cpntOn='campos.informar_p_doc_fre_volumes.on'
                :cpntOff='campos.informar_p_doc_fre_volumes.off'
                :cpntExplica='campos.informar_p_doc_fre_volumes.explica'
                :cpntWidth='campos.informar_p_doc_fre_volumes.width'
                :cpntTabIndex='campos.informar_p_doc_fre_volumes.tabIndex'

                :cpntOnChange='campos.informar_p_doc_fre_volumes.onChange'
                :cpntOnBlur='campos.informar_p_doc_fre_volumes.onBlur'
                ref='informar_p_doc_fre_volumes'
              ></App-Toggles>

              <App-Button :data-time='time' class="app-cpnt-field dem-edi-pro-doc--p_doc_fre_volumes" v-if="campos.p_doc_fre_volumes.value.length >= 1"
              :cpntStatus='campos.p_doc_fre_volumes.status' 
              :cpntId='campos.p_doc_fre_volumes.id' 
              :cpntTipo='campos.p_doc_fre_volumes.tipo' 
              :cpntIcone='campos.p_doc_fre_volumes.icone' 
              :cpntTexto='campos.p_doc_fre_volumes.texto' 
              :cpntClass='campos.p_doc_fre_volumes.class'
              :cpntMostrar='campos.p_doc_fre_volumes.mostrar'
              :cpntExplica='campos.p_doc_fre_volumes.explica'
              :cpntTabIndex='campos.p_doc_fre_volumes.tabIndex'
              @onClick='campos.p_doc_fre_volumes.onClick'>
                {{ campos.p_doc_fre_volumes.value.length }} - Volume{{ campos.p_doc_fre_volumes.value.length >= 2 ? 's' : '' }} informado{{ campos.p_doc_fre_volumes.value.length >= 2 ? 's' : '' }}
              </App-Button>

              <!-- SETA A PAGINA QUE DEVE ABRIR AO CLICAR NO BOTÃO DE VOLUMES -->
              <Demanda-Editar-Produtos-Documento-Volumes v-if="campos.informar_p_doc_fre_volumes.dialog === true" 
              :cpntDemanda="cpntDemanda"
              :cpntDemandaId="cpntDemandaId"
              :cpntVolumes="campos.p_doc_fre_volumes.value"
              :cpntFecharFormulario="demEdiProDocAlterarVolumes"
              ></Demanda-Editar-Produtos-Documento-Volumes>
            </div>
          </template>

          <div class="p_doc_ret_prev_a" :class="campos.informar_p_doc_ret_prev_a.value === true ? 'mostrar-retencao-prev' : ''" v-if="demEdiProDocVerificarCampoNFe === true && [ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1">
            <App-Toggles :data-time="time" class="app-cpnt-field dem-edi-pro-doc--informar_p_doc_ret_prev_a"
              :cpntStatus='campos.informar_p_doc_ret_prev_a.status'
              :cpntId='campos.informar_p_doc_ret_prev_a.id'
              :cpntClassDivField='campos.informar_p_doc_ret_prev_a.classDivField'
              :cpntNome='campos.informar_p_doc_ret_prev_a.nome'
              :cpntValue='campos.informar_p_doc_ret_prev_a.value'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.informar_p_doc_ret_prev_a.disabled'
              :cpntMostrar='campos.informar_p_doc_ret_prev_a.mostrar'
              :cpntMensagem='campos.informar_p_doc_ret_prev_a.mensagem'
              :cpntMensagemTipo='campos.informar_p_doc_ret_prev_a.mensagemTipo'
              :cpntOn='campos.informar_p_doc_ret_prev_a.on'
              :cpntOff='campos.informar_p_doc_ret_prev_a.off'
              :cpntExplica='campos.informar_p_doc_ret_prev_a.explica'
              :cpntWidth='campos.informar_p_doc_ret_prev_a.width'
              :cpntTabIndex='campos.informar_p_doc_ret_prev_a.tabIndex'

              :cpntOnChange='campos.informar_p_doc_ret_prev_a.onChange'
              :cpntOnBlur='campos.informar_p_doc_ret_prev_a.onBlur'
              ref='informar_p_doc_ret_prev_a'
            ></App-Toggles>

            <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_ret_prev_a" v-if="campos.informar_p_doc_ret_prev_a.value === true"
              :cpntStatus='campos.p_doc_ret_prev_a.status'
              :cpntId='campos.p_doc_ret_prev_a.id'
              :cpntClassDivField='campos.p_doc_ret_prev_a.classDivField'
              :cpntNome='campos.p_doc_ret_prev_a.nome'
              :cpntValue='campos.p_doc_ret_prev_a.value'
              :cpntAutoComplete='campos.p_doc_ret_prev_a.autocomplete'
              :cpntMask='campos.p_doc_ret_prev_a.mask'
              :cpntOptionInicialNome='campos.p_doc_ret_prev_a.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_ret_prev_a.optionInicialValue'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_ret_prev_a.disabled'
              :cpntMostrar='campos.p_doc_ret_prev_a.mostrar'
              :cpntAutoFocus='campos.p_doc_ret_prev_a.autofocus'
              :cpntMensagem='campos.p_doc_ret_prev_a.mensagem'
              :cpntMensagemTipo='campos.p_doc_ret_prev_a.mensagemTipo'
              :cpntPlaceholder='campos.p_doc_ret_prev_a.placeholder'
              :cpntPosicionar='campos.p_doc_ret_prev_a.posicionar'
              :cpntOnChange='campos.p_doc_ret_prev_a.onChange'
              :cpntOnBlur='campos.p_doc_ret_prev_a.onBlur'
              ref='p_doc_ret_prev_a'
            ></App-Input>
          </div>

          <div class="p_doc_dh_sai_ent" :class="campos.informar_p_doc_dh_sai_ent.value === true ? 'mostrar-data-hora' : ''"  v-if="demEdiProDocVerificarCampoNFe === true && [ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1">
            <App-Toggles :data-time="time" class="app-cpnt-field dem-edi-pro-doc--informar_p_doc_dh_sai_ent"
              :cpntStatus='campos.informar_p_doc_dh_sai_ent.status'
              :cpntId='campos.informar_p_doc_dh_sai_ent.id'
              :cpntClassDivField='campos.informar_p_doc_dh_sai_ent.classDivField'
              :cpntNome='campos.informar_p_doc_dh_sai_ent.nome'
              :cpntValue='campos.informar_p_doc_dh_sai_ent.value'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.informar_p_doc_dh_sai_ent.disabled'
              :cpntMostrar='campos.informar_p_doc_dh_sai_ent.mostrar'
              :cpntMensagem='campos.informar_p_doc_dh_sai_ent.mensagem'
              :cpntMensagemTipo='campos.informar_p_doc_dh_sai_ent.mensagemTipo'
              :cpntOn='campos.informar_p_doc_dh_sai_ent.on'
              :cpntOff='campos.informar_p_doc_dh_sai_ent.off'
              :cpntExplica='campos.informar_p_doc_dh_sai_ent.explica'
              :cpntWidth='campos.informar_p_doc_dh_sai_ent.width'
              :cpntTabIndex='campos.informar_p_doc_dh_sai_ent.tabIndex'
              :cpntMask='campos.informar_p_doc_dh_sai_ent.mask'
              :cpntConfig='campos.informar_p_doc_dh_sai_ent.config'

              :cpntOnChange='campos.informar_p_doc_dh_sai_ent.onChange'
              :cpntOnBlur='campos.informar_p_doc_dh_sai_ent.onBlur'
              ref='informar_p_doc_dh_sai_ent'
            ></App-Toggles>

            <App-Calendario :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_dh_sai_ent" v-if="campos.informar_p_doc_dh_sai_ent.value === true"
              :cpntStatus='campos.p_doc_dh_sai_ent.status'
              :cpntId='campos.p_doc_dh_sai_ent.id'
              :cpntClassDivField='campos.p_doc_dh_sai_ent.classDivField'
              :cpntNome='campos.p_doc_dh_sai_ent.nome'
              :cpntValue='campos.p_doc_dh_sai_ent.value'
              :cpntAutoComplete='campos.p_doc_dh_sai_ent.autocomplete'
              :cpntMask='campos.p_doc_dh_sai_ent.mask'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_dh_sai_ent.disabled'
              :cpntMostrar='campos.p_doc_dh_sai_ent.mostrar'
              :cpntAutoFocus='campos.p_doc_dh_sai_ent.autofocus'
              :cpntMensagem='campos.p_doc_dh_sai_ent.mensagem'
              :cpntMensagemTipo='campos.p_doc_dh_sai_ent.mensagemTipo'
              :cpntPlaceholder='campos.p_doc_dh_sai_ent.placeholder'
              :cpntExplica='campos.p_doc_dh_sai_ent.explica'
              :cpntConfig='campos.p_doc_dh_sai_ent.config'
              :cpntPosicionar='campos.p_doc_dh_sai_ent.posicionar'
              :cpntTabIndex='campos.p_doc_dh_sai_ent.tabIndex'

              :cpntOnChange='campos.p_doc_dh_sai_ent.onChange'
              ref='p_doc_dh_sai_ent'
            ></App-Calendario>
            
            <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_dh_sai_ent_hora"
              :cpntStatus='campos.p_doc_dh_sai_ent_hora.status'
              :cpntId='campos.p_doc_dh_sai_ent_hora.id'
              :cpntTabIndex='campos.p_doc_dh_sai_ent_hora.tabIndex'
              :cpntNome='campos.p_doc_dh_sai_ent_hora.nome'
              :cpntValue='campos.p_doc_dh_sai_ent_hora.value'
              :cpntMensagem='campos.p_doc_dh_sai_ent_hora.mensagem'
              :cpntMensagemTipo='campos.p_doc_dh_sai_ent_hora.mensagemTipo'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_dh_sai_ent_hora.disabled'
              :cpntMostrar='campos.p_doc_dh_sai_ent_hora.mostrar'
              :cpntExplica='campos.p_doc_dh_sai_ent_hora.explica'
              :cpntPlaceholder='campos.p_doc_dh_sai_ent_hora.placeholder'
              :cpntValueRef='campos.p_doc_dh_sai_ent_hora.valueRef'
              :cpntRouter='campos.p_doc_dh_sai_ent_hora.router'
              :cpntField='campos.p_doc_dh_sai_ent_hora.field'
              :cpntWhere='campos.p_doc_dh_sai_ent_hora.where'
              :cpntAddButForm='campos.p_doc_dh_sai_ent_hora.addButForm'
              :cpntKeyMostra='campos.p_doc_dh_sai_ent_hora.keyMostra'
              :cpntTipoOrder='campos.p_doc_dh_sai_ent_hora.tipoOrder'
              :cpntOrder='campos.p_doc_dh_sai_ent_hora.order'
              :cpntOptions='campos.p_doc_dh_sai_ent_hora.options'
              :cpntKeyValue='campos.p_doc_dh_sai_ent_hora.keyValue'
              :cpntSearchMinimo='campos.p_doc_dh_sai_ent_hora.searchMinimo'
              :cpntMask='campos.p_doc_dh_sai_ent_hora.mask'
              :cpntOptionInicialNome='campos.p_doc_dh_sai_ent_hora.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_dh_sai_ent_hora.optionInicialValue'

              :cpntOnChange='campos.p_doc_dh_sai_ent_hora.onChange'
              :cpntOnBlur='campos.p_doc_dh_sai_ent_hora.onBlur'
              :cpntOnRealizaBusca='campos.p_doc_dh_sai_ent_hora.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_doc_dh_sai_ent_hora.onKeyPressEnter'
              ref="p_doc_dh_sai_ent_hora"
            ></App-Select>

            <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_dh_sai_ent_minuto"
              :cpntStatus='campos.p_doc_dh_sai_ent_minuto.status'
              :cpntId='campos.p_doc_dh_sai_ent_minuto.id'
              :cpntTabIndex='campos.p_doc_dh_sai_ent_minuto.tabIndex'
              :cpntNome='campos.p_doc_dh_sai_ent_minuto.nome'
              :cpntValue='campos.p_doc_dh_sai_ent_minuto.value'
              :cpntMensagem='campos.p_doc_dh_sai_ent_minuto.mensagem'
              :cpntMensagemTipo='campos.p_doc_dh_sai_ent_minuto.mensagemTipo'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_dh_sai_ent_minuto.disabled'
              :cpntMostrar='campos.p_doc_dh_sai_ent_minuto.mostrar'
              :cpntExplica='campos.p_doc_dh_sai_ent_minuto.explica'
              :cpntPlaceholder='campos.p_doc_dh_sai_ent_minuto.placeholder'
              :cpntValueRef='campos.p_doc_dh_sai_ent_minuto.valueRef'
              :cpntRouter='campos.p_doc_dh_sai_ent_minuto.router'
              :cpntField='campos.p_doc_dh_sai_ent_minuto.field'
              :cpntWhere='campos.p_doc_dh_sai_ent_minuto.where'
              :cpntAddButForm='campos.p_doc_dh_sai_ent_minuto.addButForm'
              :cpntKeyMostra='campos.p_doc_dh_sai_ent_minuto.keyMostra'
              :cpntTipoOrder='campos.p_doc_dh_sai_ent_minuto.tipoOrder'
              :cpntOrder='campos.p_doc_dh_sai_ent_minuto.order'
              :cpntOptions='campos.p_doc_dh_sai_ent_minuto.options'
              :cpntKeyValue='campos.p_doc_dh_sai_ent_minuto.keyValue'
              :cpntSearchMinimo='campos.p_doc_dh_sai_ent_minuto.searchMinimo'
              :cpntMask='campos.p_doc_dh_sai_ent_minuto.mask'
              :cpntOptionInicialNome='campos.p_doc_dh_sai_ent_minuto.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_dh_sai_ent_minuto.optionInicialValue'

              :cpntOnChange='campos.p_doc_dh_sai_ent_minuto.onChange'
              :cpntOnBlur='campos.p_doc_dh_sai_ent_minuto.onBlur'
              :cpntOnRealizaBusca='campos.p_doc_dh_sai_ent_minuto.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_doc_dh_sai_ent_minuto.onKeyPressEnter'
              ref="p_doc_dh_sai_ent_minuto"
            ></App-Select>
          </div>

          <div class="p_doc_loc_embarque" v-if="cpntDemanda === 'venda' && cpntIdConPessoa === 'e' && [ 'NFe' ].indexOf(cpntPDocTp) !== -1">
            <App-Toggles :data-time="time" class="app-cpnt-field dem-edi-pro-doc--informar_p_doc_loc_embarque"
              :cpntStatus='campos.informar_p_doc_loc_embarque.status'
              :cpntId='campos.informar_p_doc_loc_embarque.id'
              :cpntClassDivField='campos.informar_p_doc_loc_embarque.classDivField'
              :cpntNome='campos.informar_p_doc_loc_embarque.nome'
              :cpntValue='campos.informar_p_doc_loc_embarque.value'
              :cpntDisabled='cpntPDocNFEmitida === true || campos.informar_p_doc_loc_embarque.disabled'
              :cpntMostrar='campos.informar_p_doc_loc_embarque.mostrar'
              :cpntMensagem='campos.informar_p_doc_loc_embarque.mensagem'
              :cpntMensagemTipo='campos.informar_p_doc_loc_embarque.mensagemTipo'
              :cpntOn='campos.informar_p_doc_loc_embarque.on'
              :cpntOff='campos.informar_p_doc_loc_embarque.off'
              :cpntExplica='campos.informar_p_doc_loc_embarque.explica'
              :cpntWidth='campos.informar_p_doc_loc_embarque.width'
              :cpntTabIndex='campos.informar_p_doc_loc_embarque.tabIndex'

              :cpntOnChange='campos.informar_p_doc_loc_embarque.onChange'
              :cpntOnBlur='campos.informar_p_doc_loc_embarque.onBlur'
              ref='informar_p_doc_loc_embarque'
            ></App-Toggles>

            <div v-if="campos.informar_p_doc_loc_embarque.value === true" class="campos">
              <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_loc_embarque_uf_saida_pais" :class="campos.p_doc_loc_embarque_uf_saida_pais.class"
              :cpntStatus='campos.p_doc_loc_embarque_uf_saida_pais.status'
              :cpntId='campos.p_doc_loc_embarque_uf_saida_pais.id'
              :cpntTabIndex='campos.p_doc_loc_embarque_uf_saida_pais.tabIndex'
              :cpntNome='campos.p_doc_loc_embarque_uf_saida_pais.nome'
              :cpntValue='campos.p_doc_loc_embarque_uf_saida_pais.value'
              :cpntMensagem='campos.p_doc_loc_embarque_uf_saida_pais.mensagem'
              :cpntMensagemTipo='campos.p_doc_loc_embarque_uf_saida_pais.mensagemTipo'
              :cpntDisabled='campos.p_doc_loc_embarque_uf_saida_pais.disabled'
              :cpntMostrar='campos.p_doc_loc_embarque_uf_saida_pais.mostrar'
              :cpntExplica='campos.p_doc_loc_embarque_uf_saida_pais.explica'
              :cpntPlaceholder='campos.p_doc_loc_embarque_uf_saida_pais.placeholder'
              :cpntValueRef='campos.p_doc_loc_embarque_uf_saida_pais.valueRef'
              :cpntRouter='campos.p_doc_loc_embarque_uf_saida_pais.router'
              :cpntMethod='campos.p_doc_loc_embarque_uf_saida_pais.method'
              :cpntField='campos.p_doc_loc_embarque_uf_saida_pais.field'
              :cpntWhere='campos.p_doc_loc_embarque_uf_saida_pais.where'
              :cpntAddButForm='campos.p_doc_loc_embarque_uf_saida_pais.addButForm'
              :cpntKeyMostra='campos.p_doc_loc_embarque_uf_saida_pais.keyMostra'
              :cpntTipoOrder='campos.p_doc_loc_embarque_uf_saida_pais.tipoOrder'
              :cpntOrder='campos.p_doc_loc_embarque_uf_saida_pais.order'
              :cpntOptions='campos.p_doc_loc_embarque_uf_saida_pais.options'
              :cpntKeyValue='campos.p_doc_loc_embarque_uf_saida_pais.keyValue'
              :cpntSearchMinimo='campos.p_doc_loc_embarque_uf_saida_pais.searchMinimo'
              :cpntMask='campos.p_doc_loc_embarque_uf_saida_pais.mask'
              :cpntOptionInicialNome='campos.p_doc_loc_embarque_uf_saida_pais.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_loc_embarque_uf_saida_pais.optionInicialValue'
              
              :cpntOnBuscarOptions='campos.p_doc_loc_embarque_uf_saida_pais.onBuscarOptions'
              :cpntOnChange='campos.p_doc_loc_embarque_uf_saida_pais.onChange'
              :cpntOnBlur='campos.p_doc_loc_embarque_uf_saida_pais.onBlur'
              :cpntOnRealizaBusca='campos.p_doc_loc_embarque_uf_saida_pais.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_doc_loc_embarque_uf_saida_pais.onKeyPressEnter'
              ref="p_doc_loc_embarque_uf_saida_pais"
              ></App-Select>

              <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_loc_embarque_cidade" :class="campos.p_doc_loc_embarque_cidade.class"
              :cpntStatus='campos.p_doc_loc_embarque_cidade.status'
              :cpntId='campos.p_doc_loc_embarque_cidade.id'
              :cpntTabIndex='campos.p_doc_loc_embarque_cidade.tabIndex'
              :cpntNome='campos.p_doc_loc_embarque_cidade.nome'
              :cpntValue='campos.p_doc_loc_embarque_cidade.value'
              :cpntMensagem='campos.p_doc_loc_embarque_cidade.mensagem'
              :cpntMensagemTipo='campos.p_doc_loc_embarque_cidade.mensagemTipo'
              :cpntDisabled='campos.p_doc_loc_embarque_cidade.disabled'
              :cpntMostrar='campos.p_doc_loc_embarque_cidade.mostrar'
              :cpntExplica='campos.p_doc_loc_embarque_cidade.explica'
              :cpntPlaceholder='campos.p_doc_loc_embarque_cidade.placeholder'
              :cpntValueRef='campos.p_doc_loc_embarque_cidade.valueRef'
              :cpntRouter='campos.p_doc_loc_embarque_cidade.router'
              :cpntMethod='campos.p_doc_loc_embarque_cidade.method'
              :cpntField='campos.p_doc_loc_embarque_cidade.field'
              :cpntWhere='campos.p_doc_loc_embarque_cidade.where'
              :cpntAddButForm='campos.p_doc_loc_embarque_cidade.addButForm'
              :cpntKeyMostra='campos.p_doc_loc_embarque_cidade.keyMostra'
              :cpntTipoOrder='campos.p_doc_loc_embarque_cidade.tipoOrder'
              :cpntOrder='campos.p_doc_loc_embarque_cidade.order'
              :cpntOptions='campos.p_doc_loc_embarque_cidade.options'
              :cpntKeyValue='campos.p_doc_loc_embarque_cidade.keyValue'
              :cpntSearchMinimo='campos.p_doc_loc_embarque_cidade.searchMinimo'
              :cpntMask='campos.p_doc_loc_embarque_cidade.mask'
              :cpntOptionInicialNome='campos.p_doc_loc_embarque_cidade.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_loc_embarque_cidade.optionInicialValue'
              
              :cpntOnBuscarOptions='campos.p_doc_loc_embarque_cidade.onBuscarOptions'
              :cpntOnChange='campos.p_doc_loc_embarque_cidade.onChange'
              :cpntOnBlur='campos.p_doc_loc_embarque_cidade.onBlur'
              :cpntOnRealizaBusca='campos.p_doc_loc_embarque_cidade.onRealizaBusca'
              :cpntOnKeyPressEnter='campos.p_doc_loc_embarque_cidade.onKeyPressEnter'
              ref="p_doc_loc_embarque_cidade"
              ></App-Select>

              <App-Textarea :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_loc_embarque_despacho" :class="campos.p_doc_loc_embarque_despacho.class"
              :cpntStatus='campos.p_doc_loc_embarque_despacho.status'
              :cpntId='campos.p_doc_loc_embarque_despacho.id'
              :cpntTabIndex='campos.p_doc_loc_embarque_despacho.tabIndex'
              :cpntClassDivField='campos.p_doc_loc_embarque_despacho.classDivField'
              :cpntNome='campos.p_doc_loc_embarque_despacho.nome'
              :cpntValue='campos.p_doc_loc_embarque_despacho.value'
              :cpntAutoComplete='campos.p_doc_loc_embarque_despacho.autocomplete'
              :cpntMask='campos.p_doc_loc_embarque_despacho.mask'
              :cpntOptionInicialNome='campos.p_doc_loc_embarque_despacho.optionInicialNome'
              :cpntOptionInicialValue='campos.p_doc_loc_embarque_despacho.optionInicialValue'
              :cpntDisabled='campos.p_doc_loc_embarque_despacho.disabled'
              :cpntMostrar='campos.p_doc_loc_embarque_despacho.mostrar'
              :cpntAutoFocus='campos.p_doc_loc_embarque_despacho.autofocus'
              :cpntMensagem='campos.p_doc_loc_embarque_despacho.mensagem'
              :cpntExplica='campos.p_doc_loc_embarque_despacho.explica'
              :cpntMensagemTipo='campos.p_doc_loc_embarque_despacho.mensagemTipo'
              :cpntPlaceholder='campos.p_doc_loc_embarque_despacho.placeholder'
              :cpntPosicionar='campos.p_doc_loc_embarque_despacho.posicionar'
              :cpntOnChange='campos.p_doc_loc_embarque_despacho.onChange'
              :cpntOnBlur='campos.p_doc_loc_embarque_despacho.onBlur'
              ref='p_doc_loc_embarque_despacho'
              ></App-Textarea>
            </div>
          </div>

          <!-- SETA O BOTÃO PARA CONSULTAR OS DADOS DA NOTA FISCAL -->
          <div v-if="cpntPDocNFEmitida === true && cpntPDocAcoes.danfe === '1' && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true" style="padding-top: 10px;">
            <App-Button title="Clique aqui para consultar a chave de acesso" @onClick="demEdiProDocConsultarChaveReferenciada(cpntPDocFiscal.DocChaAcesso)" style="width: 100%;">
              Consultar Chave de Acesso
              <br/>
              <span v-html="cpntPDocFiscal.DocChaAcesso"></span>
            </App-Button>
          </div>

          <div class="campos" v-if="[ 'dev_fornecedor', 'dev_cliente' ].indexOf(cpntDemanda) === -1 || [ 'dev_fornecedor_numero', 'dev_cliente_numero', 'compra_numero', 'venda_numero' ].indexOf($route.name) !== -1">
            <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_des_t" :class="campos.p_doc_des_t.class" :title="Number(cpntDemandaTotal.produto.item) === 0 ? 'Insira ao menos um item para poder incluir desconto' : ''"
            :cpntStatus='campos.p_doc_des_t.status'
            :cpntId='campos.p_doc_des_t.id'
            :cpntTabIndex='campos.p_doc_des_t.tabIndex'
            :cpntNome='campos.p_doc_des_t.nome'
            :cpntValue='campos.p_doc_des_t.value'
            :cpntMensagem='campos.p_doc_des_t.mensagem'
            :cpntMensagemTipo='campos.p_doc_des_t.mensagemTipo'
            :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_des_t.disabled || Number(cpntDemandaTotal.produto.item) === 0'
            :cpntMostrar='campos.p_doc_des_t.mostrar'
            :cpntExplica='campos.p_doc_des_t.explica'
            :cpntPlaceholder='campos.p_doc_des_t.placeholder'
            :cpntValueRef='campos.p_doc_des_t.valueRef'
            :cpntRouter='campos.p_doc_des_t.router'
            :cpntMethod='campos.p_doc_des_t.method'
            :cpntField='campos.p_doc_des_t.field'
            :cpntWhere='campos.p_doc_des_t.where'
            :cpntAddButForm='campos.p_doc_des_t.addButForm'
            :cpntKeyMostra='campos.p_doc_des_t.keyMostra'
            :cpntTipoOrder='campos.p_doc_des_t.tipoOrder'
            :cpntOrder='campos.p_doc_des_t.order'
            :cpntOptions='campos.p_doc_des_t.options'
            :cpntKeyValue='campos.p_doc_des_t.keyValue'
            :cpntSearchMinimo='campos.p_doc_des_t.searchMinimo'
            :cpntMask='campos.p_doc_des_t.mask'
            :cpntOptionInicialNome='campos.p_doc_des_t.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_des_t.optionInicialValue'
            
            :cpntOnBuscarOptions='campos.p_doc_des_t.onBuscarOptions'
            :cpntOnChange='campos.p_doc_des_t.onChange'
            :cpntOnBlur='campos.p_doc_des_t.onBlur'
            :cpntOnRealizaBusca='campos.p_doc_des_t.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.p_doc_des_t.onKeyPressEnter'
            ref="p_doc_des_t"
            ></App-Select>

            <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_des_p" :class="campos.p_doc_des_p.class" v-show="demEdiProDocValorTipoDesconto === '%'"  :title="Number(cpntDemandaTotal.produto.item) === 0 ? 'Insira ao menos um item para poder incluir desconto' : ''"
            :cpntStatus='campos.p_doc_des_p.status'
            :cpntId='campos.p_doc_des_p.id'
            :cpntClassDivField='campos.p_doc_des_p.classDivField'
            :cpntNome='campos.p_doc_des_p.nome'
            :cpntValue='campos.p_doc_des_p.value'
            :cpntAutoComplete='campos.p_doc_des_p.autocomplete'
            :cpntMask='campos.p_doc_des_p.mask'
            :cpntOptionInicialNome='campos.p_doc_des_p.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_des_p.optionInicialValue'
            :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_des_p.disabled || Number(cpntDemandaTotal.produto.item) === 0'
            :cpntMostrar='campos.p_doc_des_p.mostrar'
            :cpntAutoFocus='campos.p_doc_des_p.autofocus'
            :cpntMensagem='campos.p_doc_des_p.mensagem'
            :cpntMensagemTipo='campos.p_doc_des_p.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_des_p.placeholder'
            :cpntPosicionar='campos.p_doc_des_p.posicionar'
            :cpntOnChange='campos.p_doc_des_p.onChange'
            :cpntOnBlur='campos.p_doc_des_p.onBlur'
            ref='p_doc_des_p'
            ></App-Input>

            <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_des_v" :class="campos.p_doc_des_v.class" v-show="demEdiProDocValorTipoDesconto === 'R$'"  :title="Number(cpntDemandaTotal.produto.item) === 0 ? 'Insira ao menos um item para poder incluir desconto' : ''"
            :cpntStatus='campos.p_doc_des_v.status'
            :cpntId='campos.p_doc_des_v.id'
            :cpntClassDivField='campos.p_doc_des_v.classDivField'
            :cpntNome='campos.p_doc_des_v.nome'
            :cpntValue='campos.p_doc_des_v.value'
            :cpntAutoComplete='campos.p_doc_des_v.autocomplete'
            :cpntMask='campos.p_doc_des_v.mask'
            :cpntOptionInicialNome='campos.p_doc_des_v.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_des_v.optionInicialValue'
            :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_des_v.disabled || Number(cpntDemandaTotal.produto.item) === 0'
            :cpntMostrar='campos.p_doc_des_v.mostrar'
            :cpntAutoFocus='campos.p_doc_des_v.autofocus'
            :cpntMensagem='campos.p_doc_des_v.mensagem'
            :cpntMensagemTipo='campos.p_doc_des_v.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_des_v.placeholder'
            :cpntPosicionar='campos.p_doc_des_v.posicionar'
            :cpntOnChange='campos.p_doc_des_v.onChange'
            :cpntOnBlur='campos.p_doc_des_v.onBlur'
            ref='p_doc_des_v'
            ></App-Input>
          </div>
        </template>

        <div class="acoes" v-if="cpntPDocAcoes.danfe !== '0' && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true">
          <!-- SETA A TABELA DO DANFE -->
          <table class="danfe" v-if="mostrarDesvincular === null">
            <tr>
              <td colspan="3">
                <div>
                  <!-- RADIO ABRIR -->
                  <div>
                    <input :id='"dem-edi-pro-doc--abrir"' type="radio" class="app-checkbox" v-model="danfeAcao" :value="'abrir'">
                    <label :for='"dem-edi-pro-doc--abrir"' v-html="'Abrir'"></label>
                  </div>

                  <!-- RADIO IMPRIMIR -->
                  <div>
                    <input :id='"dem-edi-pro-doc--imprimir"' type="radio" class="app-checkbox" v-model="danfeAcao" :value="'imprimir'">
                    <label :for='"dem-edi-pro-doc--imprimir"' v-html="'Imprimir'"></label>
                  </div>

                  <!-- BOTÃO REENVIAR -->
                  <div>
                    <App-Button @onClick="demEdiProDocOnReenviarNota" :style="[ 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(cpntPDocTp) !== -1 ? 'visibility: hidden;' : ''">
                      <template v-if="[ 'venda', 'dev_cliente' ].indexOf(cpntDemanda) !== -1">
                        Reenviar Cliente
                      </template>
                      <template v-else-if="[ 'dev_fornecedor' ].indexOf(cpntDemanda) !== -1">
                        Reenviar For.
                      </template>
                      <template v-else-if="[ 'compra' ].indexOf(cpntDemanda) !== -1">
                        Enviar e-mail
                      </template>
                    </App-Button>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="danfe">
                <div>
                  <div :class="[ '', null, undefined ].indexOf(cpntPDocCCe) === -1 ? 'com-cce' : ''">
                    <App-Button :cpntStatus="botoes.danfe" :cpntClass="'btn btn-default'" @onClick="() => { demEdiProDocOnAbrirDocumentoFiscal(cpntPDocFiscal.id) }">
                        <!-- SETA O ICONE A SER UTILIZADO -->
                      <template v-if="[ '', null, undefined ].indexOf(cpntPDocCCe) !== -1">
                        <App-Icone :cpntTipo="'danfe-icon'"></App-Icone>
                        <br/>
                      </template>
                      DANFE
                    </App-Button>

                    <App-Button v-if="[ '', null, undefined ].indexOf(cpntPDocCCe) === -1" :cpntStatus="botoes.cce" :cpntClass="'btn btn-default'" @onClick="() => { demEdiProDocOnAbrirDocumentoFiscal(cpntPDocCCe.id, 'cce') }">
                      CC-e <span style="font-size: calc(100% - 2px);">(Seq. {{ cpntPDocCCe.DocEvenSeq }})</span>
                    </App-Button>
                  </div>
                </div>
              </td>
              <td class="xml">
                <div>
                  <div>
                    <App-Button :cpntStatus="botoes.xml" :cpntClass="'btn btn-default'" @onClick="() => { demEdiProDocOnAbrirDocumentoFiscal(cpntPDocFiscal.id, 'xml') }">
                      <!-- SETA O ICONE A SER UTILIZADO -->
                      <App-Icone :cpntTipo="'xml-icon'"></App-Icone>
                      <br/>
                      XML
                    </App-Button>
                  </div>
                </div>
              </td>
              <td class="cancelar">
                <div v-if="cpntPDocAcoes.cancelar !== '0'">
                  <div>
                    <App-Button :cpntClass="'btn btn-default'" @onClick="demEdiProDocAlterarDesvinculacao('')">
                      <!-- SETA O ICONE A SER UTILIZADO -->
                      <App-Icone :cpntTipo="'alerta'"></App-Icone>
                      <br/>
                      Cancelar
                    </App-Button>
                  </div>
                </div>
              </td>
            </tr>
          </table>          
        </div>
      </template>

      <template v-else>
        <div v-if="[ 'NFe(m)', 'NFAvulsa' ].indexOf(cpntPDocTp) !== -1">
          <!-- SETA O CAMPO PARA CHAVE DE ACESSO -->
          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_ca"
            :cpntStatus='campos.p_doc_ca.status'
            :cpntId='campos.p_doc_ca.id'
            :cpntClassDivField='campos.p_doc_ca.classDivField'
            :cpntNome='campos.p_doc_ca.nome'
            :cpntValue='campos.p_doc_ca.value'
            :cpntAutoComplete='campos.p_doc_ca.autocomplete'
            :cpntMask='campos.p_doc_ca.mask'
            :cpntOptionInicialNome='campos.p_doc_ca.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_ca.optionInicialValue'
            :cpntDisabled='campos.p_doc_ca.disabled'
            :cpntMostrar='campos.p_doc_ca.mostrar'
            :cpntAutoFocus='campos.p_doc_ca.autofocus'
            :cpntMensagem='campos.p_doc_ca.mensagem'
            :cpntMensagemTipo='campos.p_doc_ca.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_ca.placeholder'
            :cpntPosicionar='campos.p_doc_ca.posicionar'
            :cpntOnChange='campos.p_doc_ca.onChange'
            :cpntOnBlur='campos.p_doc_ca.onBlur'
            ref='p_doc_ca'
          ></App-Input>

          <!-- CONSULTAR -->
          <button class="app-cpnt-field btn btn-default btn-sm" title="Clique aqui para consultar a chave de acesso" @click="demEdiProDocConsultarChaveReferenciada(campos.p_doc_ca.value)">
            <svg class="fas fa-external-link-alt"></svg>
          </button>
        </div>

        <div v-if="[ 'NFe(m)', 'NFAvulsa', 'NFModelo02', 'NFProdutor' ].indexOf(cpntPDocTp) !== -1">
          <App-Calendario :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_emi"
            :cpntStatus='campos.p_doc_emi.status'
            :cpntId='campos.p_doc_emi.id'
            :cpntClassDivField='campos.p_doc_emi.classDivField'
            :cpntNome='campos.p_doc_emi.nome'
            :cpntValue='campos.p_doc_emi.value'
            :cpntAutoComplete='campos.p_doc_emi.autocomplete'
            :cpntMask='campos.p_doc_emi.mask'
            :cpntDisabled='campos.p_doc_emi.disabled'
            :cpntMostrar='campos.p_doc_emi.mostrar'
            :cpntAutoFocus='campos.p_doc_emi.autofocus'
            :cpntMensagem='campos.p_doc_emi.mensagem'
            :cpntMensagemTipo='campos.p_doc_emi.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_emi.placeholder'
            :cpntPosicionar='campos.p_doc_emi.posicionar'
            :cpntOnChange='campos.p_doc_emi.onChange'
            ref='p_doc_emi'
          ></App-Calendario>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_n"
            :cpntStatus='campos.p_doc_n.status'
            :cpntId='campos.p_doc_n.id'
            :cpntClassDivField='campos.p_doc_n.classDivField'
            :cpntNome='campos.p_doc_n.nome'
            :cpntValue='campos.p_doc_n.value'
            :cpntAutoComplete='campos.p_doc_n.autocomplete'
            :cpntMask='campos.p_doc_n.mask'
            :cpntOptionInicialNome='campos.p_doc_n.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_n.optionInicialValue'
            :cpntDisabled='campos.p_doc_n.disabled'
            :cpntMostrar='campos.p_doc_n.mostrar'
            :cpntAutoFocus='campos.p_doc_n.autofocus'
            :cpntMensagem='campos.p_doc_n.mensagem'
            :cpntMensagemTipo='campos.p_doc_n.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_n.placeholder'
            :cpntPosicionar='campos.p_doc_n.posicionar'
            :cpntOnChange='campos.p_doc_n.onChange'
            :cpntOnBlur='campos.p_doc_n.onBlur'
            ref='p_doc_n'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_s"
            :cpntStatus='campos.p_doc_s.status'
            :cpntId='campos.p_doc_s.id'
            :cpntClassDivField='campos.p_doc_s.classDivField'
            :cpntNome='campos.p_doc_s.nome'
            :cpntValue='campos.p_doc_s.value'
            :cpntAutoComplete='campos.p_doc_s.autocomplete'
            :cpntMask='campos.p_doc_s.mask'
            :cpntOptionInicialNome='campos.p_doc_s.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_s.optionInicialValue'
            :cpntDisabled='campos.p_doc_s.disabled'
            :cpntMostrar='campos.p_doc_s.mostrar'
            :cpntAutoFocus='campos.p_doc_s.autofocus'
            :cpntMensagem='campos.p_doc_s.mensagem'
            :cpntMensagemTipo='campos.p_doc_s.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_s.placeholder'
            :cpntPosicionar='campos.p_doc_s.posicionar'
            :cpntOnChange='campos.p_doc_s.onChange'
            :cpntOnBlur='campos.p_doc_s.onBlur'
            ref='p_doc_s'
          ></App-Input>
        </div>

        <div v-if="[ 'NFe(m)', 'NFAvulsa', 'NFModelo02', 'NFProdutor' ].indexOf(cpntPDocTp) !== -1">
          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_vf"
            :cpntStatus='campos.p_doc_vf.status'
            :cpntId='campos.p_doc_vf.id'
            :cpntClassDivField='campos.p_doc_vf.classDivField'
            :cpntNome='campos.p_doc_vf.nome'
            :cpntValue='campos.p_doc_vf.value'
            :cpntAutoComplete='campos.p_doc_vf.autocomplete'
            :cpntMask='campos.p_doc_vf.mask'
            :cpntOptionInicialNome='campos.p_doc_vf.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_vf.optionInicialValue'
            :cpntDisabled='campos.p_doc_vf.disabled'
            :cpntMostrar='campos.p_doc_vf.mostrar'
            :cpntAutoFocus='campos.p_doc_vf.autofocus'
            :cpntMensagem='campos.p_doc_vf.mensagem'
            :cpntMensagemTipo='campos.p_doc_vf.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_vf.placeholder'
            :cpntPosicionar='campos.p_doc_vf.posicionar'
            :cpntOnChange='campos.p_doc_vf.onChange'
            :cpntOnBlur='campos.p_doc_vf.onBlur'
            ref='p_doc_vf'
          ></App-Input>

          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_vs"
            :cpntStatus='campos.p_doc_vs.status'
            :cpntId='campos.p_doc_vs.id'
            :cpntClassDivField='campos.p_doc_vs.classDivField'
            :cpntNome='campos.p_doc_vs.nome'
            :cpntValue='campos.p_doc_vs.value'
            :cpntAutoComplete='campos.p_doc_vs.autocomplete'
            :cpntMask='campos.p_doc_vs.mask'
            :cpntOptionInicialNome='campos.p_doc_vs.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_vs.optionInicialValue'
            :cpntDisabled='campos.p_doc_vs.disabled'
            :cpntMostrar='campos.p_doc_vs.mostrar'
            :cpntAutoFocus='campos.p_doc_vs.autofocus'
            :cpntMensagem='campos.p_doc_vs.mensagem'
            :cpntMensagemTipo='campos.p_doc_vs.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_vs.placeholder'
            :cpntExplica='campos.p_doc_vs.explica'
            :cpntPosicionar='campos.p_doc_vs.posicionar'
            :cpntOnChange='campos.p_doc_vs.onChange'
            :cpntOnBlur='campos.p_doc_vs.onBlur'
            ref='p_doc_vs'
          ></App-Input>
        </div>

        <div v-if="cpntDemanda === 'compra'">
          <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_od" v-if="[ 'NFe(m)', 'NFAvulsa', 'NFModelo02', 'NFProdutor' ].indexOf(cpntPDocTp) !== -1"
            :cpntStatus='campos.p_doc_od.status'
            :cpntId='campos.p_doc_od.id'
            :cpntClassDivField='campos.p_doc_od.classDivField'
            :cpntNome='campos.p_doc_od.nome'
            :cpntValue='campos.p_doc_od.value'
            :cpntAutoComplete='campos.p_doc_od.autocomplete'
            :cpntMask='campos.p_doc_od.mask'
            :cpntOptionInicialNome='campos.p_doc_od.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_od.optionInicialValue'
            :cpntDisabled='campos.p_doc_od.disabled'
            :cpntMostrar='campos.p_doc_od.mostrar'
            :cpntAutoFocus='campos.p_doc_od.autofocus'
            :cpntMensagem='campos.p_doc_od.mensagem'
            :cpntMensagemTipo='campos.p_doc_od.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_od.placeholder'
            :cpntExplica='campos.p_doc_od.explica'
            :cpntPosicionar='campos.p_doc_od.posicionar'
            :cpntOnChange='campos.p_doc_od.onChange'
            :cpntOnBlur='campos.p_doc_od.onBlur'
            ref='p_doc_od'
          ></App-Input>
        </div>

        <div class="campos">
          <App-Select :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_des_t" :class="campos.p_doc_des_t.class" :title="Number(cpntDemandaTotal.produto.item) === 0 ? 'Insira ao menos um item para poder incluir desconto' : ''"
            :cpntStatus='campos.p_doc_des_t.status'
            :cpntId='campos.p_doc_des_t.id'
            :cpntTabIndex='campos.p_doc_des_t.tabIndex'
            :cpntNome='campos.p_doc_des_t.nome'
            :cpntValue='campos.p_doc_des_t.value'
            :cpntMensagem='campos.p_doc_des_t.mensagem'
            :cpntMensagemTipo='campos.p_doc_des_t.mensagemTipo'
            :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_des_t.disabled || Number(cpntDemandaTotal.produto.item) === 0'
            :cpntMostrar='campos.p_doc_des_t.mostrar'
            :cpntExplica='campos.p_doc_des_t.explica'
            :cpntPlaceholder='campos.p_doc_des_t.placeholder'
            :cpntValueRef='campos.p_doc_des_t.valueRef'
            :cpntRouter='campos.p_doc_des_t.router'
            :cpntMethod='campos.p_doc_des_t.method'
            :cpntField='campos.p_doc_des_t.field'
            :cpntWhere='campos.p_doc_des_t.where'
            :cpntAddButForm='campos.p_doc_des_t.addButForm'
            :cpntKeyMostra='campos.p_doc_des_t.keyMostra'
            :cpntTipoOrder='campos.p_doc_des_t.tipoOrder'
            :cpntOrder='campos.p_doc_des_t.order'
            :cpntOptions='campos.p_doc_des_t.options'
            :cpntKeyValue='campos.p_doc_des_t.keyValue'
            :cpntSearchMinimo='campos.p_doc_des_t.searchMinimo'
            :cpntMask='campos.p_doc_des_t.mask'
            :cpntOptionInicialNome='campos.p_doc_des_t.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_des_t.optionInicialValue'
            
            :cpntOnBuscarOptions='campos.p_doc_des_t.onBuscarOptions'
            :cpntOnChange='campos.p_doc_des_t.onChange'
            :cpntOnBlur='campos.p_doc_des_t.onBlur'
            :cpntOnRealizaBusca='campos.p_doc_des_t.onRealizaBusca'
            :cpntOnKeyPressEnter='campos.p_doc_des_t.onKeyPressEnter'
            ref="p_doc_des_t"
            ></App-Select>

            <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_des_p" :class="campos.p_doc_des_p.class" v-show="demEdiProDocValorTipoDesconto === '%'"  :title="Number(cpntDemandaTotal.produto.item) === 0 ? 'Insira ao menos um item para poder incluir desconto' : ''"
            :cpntStatus='campos.p_doc_des_p.status'
            :cpntId='campos.p_doc_des_p.id'
            :cpntClassDivField='campos.p_doc_des_p.classDivField'
            :cpntNome='campos.p_doc_des_p.nome'
            :cpntValue='campos.p_doc_des_p.value'
            :cpntAutoComplete='campos.p_doc_des_p.autocomplete'
            :cpntMask='campos.p_doc_des_p.mask'
            :cpntOptionInicialNome='campos.p_doc_des_p.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_des_p.optionInicialValue'
            :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_des_p.disabled || Number(cpntDemandaTotal.produto.item) === 0'
            :cpntMostrar='campos.p_doc_des_p.mostrar'
            :cpntAutoFocus='campos.p_doc_des_p.autofocus'
            :cpntMensagem='campos.p_doc_des_p.mensagem'
            :cpntMensagemTipo='campos.p_doc_des_p.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_des_p.placeholder'
            :cpntPosicionar='campos.p_doc_des_p.posicionar'
            :cpntOnChange='campos.p_doc_des_p.onChange'
            :cpntOnBlur='campos.p_doc_des_p.onBlur'
            ref='p_doc_des_p'
            ></App-Input>

            <App-Input :data-time="time" class="app-cpnt-field dem-edi-pro-doc--p_doc_des_v" :class="campos.p_doc_des_v.class" v-show="demEdiProDocValorTipoDesconto === 'R$'"  :title="Number(cpntDemandaTotal.produto.item) === 0 ? 'Insira ao menos um item para poder incluir desconto' : ''"
            :cpntStatus='campos.p_doc_des_v.status'
            :cpntId='campos.p_doc_des_v.id'
            :cpntClassDivField='campos.p_doc_des_v.classDivField'
            :cpntNome='campos.p_doc_des_v.nome'
            :cpntValue='campos.p_doc_des_v.value'
            :cpntAutoComplete='campos.p_doc_des_v.autocomplete'
            :cpntMask='campos.p_doc_des_v.mask'
            :cpntOptionInicialNome='campos.p_doc_des_v.optionInicialNome'
            :cpntOptionInicialValue='campos.p_doc_des_v.optionInicialValue'
            :cpntDisabled='cpntPDocNFEmitida === true || campos.p_doc_des_v.disabled || Number(cpntDemandaTotal.produto.item) === 0'
            :cpntMostrar='campos.p_doc_des_v.mostrar'
            :cpntAutoFocus='campos.p_doc_des_v.autofocus'
            :cpntMensagem='campos.p_doc_des_v.mensagem'
            :cpntMensagemTipo='campos.p_doc_des_v.mensagemTipo'
            :cpntPlaceholder='campos.p_doc_des_v.placeholder'
            :cpntPosicionar='campos.p_doc_des_v.posicionar'
            :cpntOnChange='campos.p_doc_des_v.onChange'
            :cpntOnBlur='campos.p_doc_des_v.onBlur'
            ref='p_doc_des_v'
            ></App-Input>
        </div>
      </template>
    </div>

    <template v-if="(cpntDemanda === 'compra' && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 45 ], null, false) === true) || (cpntDemanda === 'venda' && $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 17 ], null, [ 10 ], null, [ 40 ], null, false) === true || [ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) !== -1)">
      <div class="botoes" v-if="mostrarDesvincular === null && (cpntPDocAcoes.emitir === '1' || cpntPDocAcoes.salvar === '1' || cpntPDocAcoes.consultar === '1')">
        <!-- SETA O BOTÃO SALVAR E EMITIR -->
        <div class="iniciais">
          <!-- BOTÃO SALVAR -->
          <App-Button v-if="cpntPDocAcoes.salvar === '1'" :cpntStatus="botoes.salvar" :cpntClass='[ "btn", "btn-default" ]' @onClick='demEdiProDocSalvar' :cpntTabIndex="17021040">
            <!-- SETA O ICONE A SER UTILIZADO -->
            <App-Icone :cpntTipo="'salvar'"></App-Icone>

            <!-- SETA A QUEBRA DE LINHA -->
            <br/>

            <!-- SETA O TEXTO DO BOTÃO -->
            <span>Salvar</span>
          </App-Button>

          <!-- BOTÃO EMITIR -->
          <App-Button v-if="(cpntPDocAcoes.emitir === '1' || cpntPDocAcoes.emitir === '2' || cpntPDocAcoes.reemitir === '1' || cpntPDocAcoes.consultar === '1')" :cpntStatus="botoes.emitir" :cpntClass='[ "btn", "btn-default" ]' @onClick='() => { demEdiProDocMostrarFormularioPagamento() }' :cpntTabIndex="17021041">
            <template v-if="cpntPDocAcoes.emitir === '1'">
              <!-- SETA O ICONE A SER UTILIZADO -->
              <App-Icone :cpntTipo="'emitir'"></App-Icone>

              <!-- SETA A QUEBRA DE LINHA -->
              <br/>

              <!-- SETA O TEXTO DO BOTÃO -->
              <span>Emitir</span>

              <!-- VERIFICA SE A EMISSÃO ESTÁ PENDENTE -->
              <span v-if="cpntPDocAcoes.emitir === '2'"><b style="color: red; font-size: var(--font-base-soma-11);"><br/>[Pendente]</b></span>
            </template>
            <template v-else-if="cpntPDocAcoes.reemitir === '1'">
              <!-- SETA O ICONE A SER UTILIZADO -->
              <App-Icone :cpntTipo="'reemitir'"></App-Icone>

              <!-- SETA A QUEBRA DE LINHA -->
              <br/>

              <!-- SETA O TEXTO DO BOTÃO -->
              <span>Reemitir</span>
            </template>
            <template v-else-if="cpntPDocAcoes.consultar === '1'">
              <span>Consultar<br/>Situações</span>
            </template>
          </App-Button>

          <!-- BOTÃO EMITIR -->
          <App-Button v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) !== -1 && $store.state.licenca.NFe_emissor !== 'mi' && (cpntPDocAcoes.emitir === '1' || cpntPDocAcoes.emitir === '2' || cpntPDocAcoes.reemitir === '1' || cpntPDocAcoes.consultar === '1')" :cpntStatus="botoes.emitir" :cpntClass='[ "btn", "btn-default" ]' @onClick='() => { demEdiProDocPreVisualizar() }' :cpntTabIndex="17021041">
            <!-- SETA O ICONE A SER UTILIZADO -->
            <App-Icone :cpntTipo="'emitir'"></App-Icone>

            <!-- SETA A QUEBRA DE LINHA -->
            <br/>

            <!-- SETA O TEXTO DO BOTÃO -->
            <span>Pré-visualização</span>
          </App-Button>

          <!-- BOTÃO EMITIR -->
          <template v-if="cpntPDocAcoes.inutilizar === '1'">
            <App-Button :cpntStatus="mostrarDesvincular === null ? '' : mostrarDesvincular" @onClick="() => { demEdiProDocAlterarDesvinculacao('') }">
              <!-- SETA O ICONE A SER UTILIZADO -->
              <App-Icone :cpntTipo="'alerta'"></App-Icone>

              <!-- SETA A QUEBRA DE LINHA -->
              <br/>

              <!-- SETA O TEXTO DO BOTÃO -->
              <span>Inutilizar</span>
            </App-Button>
          </template>
        </div>
      </div>
    </template>

    <!-- SETA A PARTE DE CANCELAMENTO DA NF -->
    <div class="desvincular" v-if="mostrarDesvincular !== null">
      <table>
        <tr>
          <td class="campo">
            <App-Textarea :data-time="time" class="app-cpnt-field dem-edi-pro-doc--motivo"
              :cpntStatus='campos.motivo.status'
              :cpntId='campos.motivo.id'
              :cpntClassDivField='campos.motivo.classDivField'
              :cpntNome='campos.motivo.nome'
              :cpntValue='campos.motivo.value'
              :cpntAutoComplete='campos.motivo.autocomplete'
              :cpntMask='campos.motivo.mask'
              :cpntOptionInicialNome='campos.motivo.optionInicialNome'
              :cpntOptionInicialValue='campos.motivo.optionInicialValue'
              :cpntDisabled='campos.motivo.disabled'
              :cpntMostrar='campos.motivo.mostrar'
              :cpntAutoFocus='campos.motivo.autofocus'
              :cpntMensagem='campos.motivo.mensagem'
              :cpntMensagemTipo='campos.motivo.mensagemTipo'
              :cpntPlaceholder='campos.motivo.placeholder'
              :cpntPosicionar='campos.motivo.posicionar'
              :cpntOnChange='campos.motivo.onChange'
              :cpntOnBlur='campos.motivo.onBlur'
              ref='motivo'
            ></App-Textarea>
          </td>

          <td rowspan="2" class="botoes">
            <!-- SETA O BOTÃO DA AÇÃO DE DESVINULAR -->
            <App-Button :cpntStatus="mostrarDesvincular" @onClick="() => { demEdiProDocRealizarDesvinculacao() }">
              <template v-if="cpntPDocAcoes.cancelar !== '0'">
                <App-Icone :cpntTipo="'alerta'"></App-Icone>
                <br/>
                Cancelar
              </template>
              <template v-else>
                <App-Icone :cpntTipo="'alerta'"></App-Icone>
                <br/>
                Inutilizar
              </template>
            </App-Button>

            <!-- SETA O BOTÃO DA AÇÃO DE VOLTAR -->
            <App-Button @onClick="() => { demEdiProDocAlterarDesvinculacao(null) }">
              Voltar
            </App-Button>
          </td>
        </tr>
        <tr>
          <td class="mensagem">
            Este processo irá <b>desvincular</b> a venda desta {{ cpntPDocTp === 'NFCe' ? 'NFC-e [65]' : 'NF-e [55]'}}. Somente será possível consultar esta {{ cpntPDocTp === 'NFCe' ? 'NFC-e [65]' : 'NF-e [55]'}} através de Docs. Fiscais -> Gerenciar.
          </td>
        </tr>
      </table>
    </div>

    <!-- SETA OS BOTOES DE LOG DE COMUNICAÇÃO -->
    <div class="logs" v-if="[ 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(cpntPDocTp) === -1 && (cpntPDocNFEmitida === true || cpntPDocAcoes.rejeicao !== '0' || cpntPDocAcoes.consultar !== '0')" :key="('df-' + cpntPDocNFEmitida)">
      <table>
        <tr>
          <td>
            <DF-Log
            :cpntDfId="Number(cpntPDocFiscal.id)"
            :cpntDfLogTipo="'comunicacao'"
            :cpntDados="cpntPDocFiscal"
            :cpntMostrarBT="true"
            :cpntMostrarTab="false"
            ref='log_comunicacao'
            ></DF-Log>
          </td>
          <td v-if="cpntPDocNFEmitida === true">
            <DF-Log
            :cpntDfId="Number(cpntPDocFiscal.id)"
            :cpntDfLogTipo="'email'"
            :cpntDados="cpntPDocFiscal"
            :cpntMostrarBT="true"
            :cpntMostrarTab="false"
            ref='log_email'
            ></DF-Log>
          </td>
        </tr>
      </table>
    </div>

    <Demanda-Editar-Produtos-Documento-Dialog-Pagamento :data-time="time" v-if="mostrarPagamentos === true"
    :cpntDemanda="cpntDemanda"
    :cpntDemandaId="cpntDemandaId"
    :cpntPDocNFEmitida="cpntPDocNFEmitida"
    :cpntPDocTp="cpntPDocTp"
    :cpntDemData="cpntDemData"
    :cpntPDocFiscal="cpntPDocFiscal"
    :cpntPDocDocs="cpntPDocDocs"
    :cpntDemandaTotal="cpntDemandaTotal"
    :cpntPDocAcoes="cpntPDocAcoes"
    :cpntFecharFormulario="(atualizar) => { demEdiProDocMostrarFormularioPagamento(atualizar) }"

    @DEMANDA_ATUALIZAR_FINANCEIRO="demEdiProDocAtualizarFinanceiro"
    ></Demanda-Editar-Produtos-Documento-Dialog-Pagamento>

    <!-- MOSTRA A TELA PARA CRIAR CARTA DE CORREÇÃO ELETRONICA -->
    <RF-Dialog v-if='mostrarCartaCorrecao === true'
    :cpntStatus='""'
    :cpntLargura='"760px"'
    :cpntTitulo="'Carta de Correção da NF-e [55]'"
    :cpntOnFecharDialog='demEdiProDocMostrarFormularioCartaCorrecao'>
    <template slot='conteudo'>
      <RF-Carta-Correcao-Eletronica
        :cpntDocNumero="cpntPDocFiscal.DocNumero"
        :cpntDocSerie="cpntPDocFiscal.DocSerie"

        :cpntOnFecharDialog='demEdiProDocMostrarFormularioCartaCorrecao'        
      ></RF-Carta-Correcao-Eletronica>
    </template>
    </RF-Dialog>

    <!-- ABRE A TELA DE AVISO -->
    <RF-Dialog v-if="[ 'dev_cliente', 'dev_fornecedor' ].indexOf(cpntDemanda) === -1 && confirmacao === true"
    :cpntStatus='""'
    :cpntLargura='"545px"'
    :cpntTitulo="'Aviso importante'"
    :cpntOnFecharDialog='() => { demEdiProDocConfirmaAlteracaoDoc(false) }'>
    <template slot='conteudo'>
      <div class="dem-edi-pro-doc--p_doc_tp-confirm">
        Este procedimento irá limpar todos os dados do documento digitado.
        <br><br>
        Deseja prosseguir?
        <br><br>
        <App-Button @onClick="() => { demEdiProDocConfirmaAlteracaoDoc(true) }">Sim</App-Button>
        <App-Button @onClick="() => { demEdiProDocConfirmaAlteracaoDoc(false) }">Não</App-Button>
      </div>
    </template>
    </RF-Dialog>

    <RF-Dialog v-if="[ '', null, undefined ].indexOf(previsualizar) === -1"
    :cpntStatus='(previsualizar === "carregando" || (previsualizar !== "carregando" && typeof previsualizar !== "string")) ? previsualizar : ""'
    :cpntLargura='"900px"'
    :cpntTitulo="'Pré-visualização da NF-e'"
    :cpntOnFecharDialog='() => { previsualizar = "" }'>
      <template slot='conteudo'>
        <embed :src="'data:application/pdf;base64, ' + previsualizar" width="100%" height="100%" style="height: 100vh;" type="application/pdf">
      </template>
    </RF-Dialog>
  </div>
</template>

<style scoped>
.dem-edi-pro-doc {
  vertical-align: top;
  width: 370px;
  max-width: 370px;
  min-width: 370px;
  border-radius: 6px;
  border-collapse: collapse;
  border-style: hidden;
  box-shadow: 0 0 0 1px #c6c4c4;
  background-color: #fff;
}

.dem-edi-pro-doc > .documento {
  padding: 23px 10px 15px 10px;
  background: #f1f1f1;
  border-bottom: 1px solid #c6c4c4;
}
  .dem-edi-pro-doc > .documento > div {
    width: 100%;
  }
  .dem-edi-pro-doc > .com-botao > div {
    width: calc(100% - 115px - 10px);
    margin-right: 10px;
  }
  .dem-edi-pro-doc > .com-botao > button {
    width: 115px;
  }

.dem-edi-pro-doc > .campos {
  padding: 23px 10px 15px 10px;
}
  .dem-edi-pro-doc > .campos > div,
  .dem-edi-pro-doc > .campos > div > div {
    width: 100%;
  }
  .dem-edi-pro-doc > .campos > div:not(:first-child) {
    padding-top: 22px;
  }
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_nat_ope {
    max-width: calc(100% - 75px - 10px);
    margin-right: 10px;
  }
  .dem-edi-pro-doc > .campos > div.ocultar-bt-sugerir > .dem-edi-pro-doc--p_doc_nat_ope {
    max-width: 100%;
    margin-right: 10px;
  }
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--sugerirBT {
    width: 75px;
    margin-top: -3px;
  }
/* mostrar-adicionar */
.dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--referenciar_j_p_doc_ref_ca,
.dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--referenciarNovaChave {
  display: none !important;
}
.dem-edi-pro-doc > .campos > .p_doc_icms_aa {
  padding-top: 10px !important;
  margin-bottom: -2px !important;
  margin-top: 0px !important;
  padding-right: 0;
}
  .dem-edi-pro-doc > .campos > .p_doc_icms_aa > .valor {
    width: 157px;
    display: inline-block;
    text-align: left;
    padding-left: 5px;
    padding-right: 0;
  }
  .dem-edi-pro-doc > .campos > .p_doc_icms_aa > button {
    width: 75px;
  }
.dem-edi-pro-doc > .campos > .mostrar-referenciar > .dem-edi-pro-doc--p_doc_fin {
  max-width: calc(100% - 115px - 10px);
  margin-right: 10px;
}
.dem-edi-pro-doc > .campos > .mostrar-adicionar > .dem-edi-pro-doc--p_doc_fin {
  max-width: calc(100% - 35px - 10px);
}
.dem-edi-pro-doc > .campos > .mostrar-referenciar.mostrar-adicionar > .dem-edi-pro-doc--p_doc_fin {
  max-width: calc(100% - 115px - 10px - 35px - 10px);
}
.dem-edi-pro-doc > .campos > .mostrar-referenciar > .dem-edi-pro-doc--referenciar_j_p_doc_ref_ca {
  display: inline-block !important;
  width: 115px;
}
.dem-edi-pro-doc > .campos > .mostrar-adicionar > .dem-edi-pro-doc--referenciarNovaChave {
  display: inline-block !important;
  width: 35px;
  height: 30px;
  margin-left: 10px;
}
.dem-edi-pro-doc > .campos > .mostrar-referenciar > .dem-edi-pro-doc--referenciarNovaChave {
  margin-top: -1px;
}
.dem-edi-pro-doc > .campos > .dem-edi-pro-doc--j_p_doc_ref_ca,
.dem-edi-pro-doc > .campos > .dem-edi-pro-form--p_doc_fre_id,
.dem-edi-pro-doc > .campos > .dem-edi-pro-doc--p_id_ven_cfg_intermediador,
.dem-edi-pro-doc > .campos > .dem-edi-pro-form--veiculo_transp {
  padding-left: 20px;
}
  .dem-edi-pro-doc > .campos > .dem-edi-pro-doc--j_p_doc_ref_ca > div {
    max-width: calc(100% - 35px - 5px - 5px);
    /* max-width: calc(100% - 35px - 5px- 35px - 5px - 5px); */
    margin-right: 10px;
  }
  .dem-edi-pro-doc > .campos > .dem-edi-pro-doc--j_p_doc_ref_ca > button {
    display: inline-block;
    width: 35px;
    height: 30px;
    margin-top: -3px;
  }
  /* .dem-edi-pro-doc > .campos > .dem-edi-pro-doc--j_p_doc_ref_ca > button:not(:last-child) {
    margin-right: 5px;
  } */

  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_fre_placa_uf {
    max-width: 100%;
  }
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_fre_placa {
    display: none;
  }
  .dem-edi-pro-doc > .campos > .mostrar-placa-transporte > .dem-edi-pro-doc--p_doc_fre_placa_uf {
    max-width: calc(100% - 10px - 100px);
  }
  .dem-edi-pro-doc > .campos > .mostrar-placa-transporte > .dem-edi-pro-doc--p_doc_fre_placa {
    display: inline-block;
    width: 100px;
    margin-left: 10px;
  }

  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--informar_p_doc_fre_volumes,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--informar_p_doc_loc_embarque {
    margin-right: 10px;
  }
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_fre_volumes {
    width: calc(100% - 140px - 10px);
    margin-top: -3px;
  }

  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--informar_p_doc_fre_volumes,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--informar_p_doc_loc_embarque,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--informar_p_doc_ret_prev_a {
    max-width: 140px;
  }
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_ret_prev_a,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_dh_sai_ent,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_dh_sai_ent_hora,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_dh_sai_ent_minuto {
    display: none;
  }
  .dem-edi-pro-doc > .campos > .mostrar-retencao-prev > .dem-edi-pro-doc--p_doc_ret_prev_a {
    display: inline-block;
    width: calc(100% - 140px - 10px);
    margin-left: 10px;
  }
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--informar_p_doc_dh_sai_ent {
    width: 140px;
  }
  .dem-edi-pro-doc > .campos > .mostrar-data-hora > .dem-edi-pro-doc--p_doc_dh_sai_ent {
    display: inline-block;
    width: 85px;
    margin-left: 10px;
  }
  .dem-edi-pro-doc > .campos > .mostrar-data-hora > .dem-edi-pro-doc--p_doc_dh_sai_ent_hora,
  .dem-edi-pro-doc > .campos > .mostrar-data-hora > .dem-edi-pro-doc--p_doc_dh_sai_ent_minuto {
    display: inline-block;
    width: 52px;
    margin-left: 5px;
  }
/* 
  .dem-edi-pro-doc > .campos > div:not(.mostrar-local-embarque) > .dem-edi-pro-doc--p_doc_loc_embarque_uf_saida_pais,
  .dem-edi-pro-doc > .campos > div:not(.mostrar-local-embarque) > .dem-edi-pro-doc--p_doc_loc_embarque_cidade,
  .dem-edi-pro-doc > .campos > div:not(.mostrar-local-embarque) > .dem-edi-pro-doc--p_doc_loc_embarque_despacho {
    display: none !important;
  } */

  
  .dem-edi-pro-doc > .campos > div > .campos {
    margin-top: -25px;
    padding-left: 20px;
    padding-top: 22px;
  }
  .dem-edi-pro-doc > .campos > div > .campos > .dem-edi-pro-doc--p_doc_loc_embarque_uf_saida_pais,
  .dem-edi-pro-doc > .campos > div > .campos > .dem-edi-pro-doc--p_doc_loc_embarque_cidade {
    width: calc(50% - 5px);
  }
  .dem-edi-pro-doc > .campos > div > .campos > .dem-edi-pro-doc--p_doc_loc_embarque_cidade {
    margin-left: 10px;
  }  
  .dem-edi-pro-doc > .campos > div > .campos > .dem-edi-pro-doc--p_doc_loc_embarque_despacho {
    margin-top: 22px !important;
    width: 100%;
  }
  .dem-edi-pro-doc > .campos > .campos > .dem-edi-pro-doc--p_doc_des_t {
    width: 90px !important;
    margin-right: 10px;
  }
  .dem-edi-pro-doc > .campos > .campos > .dem-edi-pro-doc--p_doc_des_p {
    width: calc(100% - 100px) !important;
  }
  .dem-edi-pro-doc > .campos > .campos > .dem-edi-pro-doc--p_doc_des_v {
    width: calc(100% - 100px) !important;
  }


  .dem-edi-pro-doc > .botoes {
    text-align: center;
    padding-bottom: 10px;
  }
    .dem-edi-pro-doc > .botoes > .iniciais {
      padding-top: 5px;
    }
      .dem-edi-pro-doc > .botoes > .iniciais > button {
        padding: 8px 10px;
        min-width: 75px;
        min-height: 68px;
      }
      .dem-edi-pro-doc > .botoes > .iniciais > button:first-child {
        margin-right: 30px;
      }
      .dem-edi-pro-doc > .botoes > .iniciais > button:last-child {
        margin-left: 30px;
      }
.dem-edi-doc-fornecedor {
  color: #fff;
  background-color: #f0ad4e;
  border-color: #eea236;
  text-align: center;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid;
  margin-top: -15px;
}
.dem-edi-doc-df {
  margin-top: -10px;
  margin-bottom: -5px;
}
  .dem-edi-doc-df > div {
    margin-bottom: 8px;
  }
  .dem-edi-doc-df > div > div {
    width: 130px;
    display: inline-block;
  }
    .dem-edi-doc-df > div > button {
      width: 140px;
      padding: 4px 0px;
    }

  .dem-edi-pro-doc > .campos > .acoes {
    padding-top: 10px !important;
    margin-bottom: -10px !important;
  }
    .dem-edi-pro-doc > .campos > .acoes > table.danfe {
      width: 100%;
    }
      .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:first-child > td > div > div {
        display: inline-block;
        width: calc(100% / 3);
      }
      .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:first-child > td > div > div:last-child {
        text-align: right;
      }

      .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td.danfe {
        width: 100px;
        text-align: center;
      }
      .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td:not(.danfe) {
        width: calc(250px / 2);
        text-align: center;
      }

      .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:first-child > td > div,
      .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td.danfe > div {
        background-color: #e5e5e5;
        border-right: 1px solid #ccc;
        border-left: 1px solid #ccc;
        padding: 6px;
      }
      .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:first-child > td > div {
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-radius: 6px 6px 6px 0;
      }
      .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td.danfe > div {
        border-bottom: 1px solid #ccc;
        border-radius: 0 0 6px 6px;
      }
      .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td > div {
        padding: 6px;
        margin-top: -1px;
      }
        
        .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td > div > div.com-cce {

        }
          .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td > div > div.com-cce > button {
            margin: 2px 0px;
            padding: 4px 6px;
          }
        .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td > div > div:not(.com-cce) > button {
          height: 64px;
          min-height: 64px;
          padding: 8px 10px;
        }
        .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td > div > div > button {
          width: 75px;
          min-width: 75px;
        }
        .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td.danfe > div > div > button {
          width: 100%;
          min-width: 100%;
        }

  .dem-edi-pro-doc > .logs {
    width: 100%;
    border-top: 1px solid #ccc;
    margin-top: 10px;
  }
    .dem-edi-pro-doc > .logs > table,
    .dem-edi-pro-doc > .logs > table > tr {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    }
      .dem-edi-pro-doc > .logs > table > tr > td {
        width: 50%;
        min-width: 50%;
        max-width: 50%;
        padding: 5px;
        vertical-align: top;
      }
  .dem-edi-pro-doc > .desvincular {
    padding: 0px 10px 0px 10px;
  }
  .dem-edi-pro-doc > .desvincular > table {
    margin-top: 10px;
    width: 100%;
    min-width: 100%;
    max-width: 100%;
  }
    .dem-edi-pro-doc > .desvincular > table > tr > td {
      vertical-align: top;
      /* max-width: 100%;
      white-space: pre-wrap;
      word-break: break-word; */
    }
    
    .dem-edi-pro-doc > .desvincular > table > tr > td.mensagem {
      color: red;
      text-align: justify;
      padding: 0px;
      font-size: var(--font-base-soma-13);
    }
    .dem-edi-pro-doc > .desvincular > table > tr > td:not(.botoes) {
      width: calc(100% - 95px);
    }
    .dem-edi-pro-doc > .desvincular > table > tr > td.botoes {
      width: 95px;
      padding: 0px 5px;
    }
      .dem-edi-pro-doc > .desvincular > table > tr > td.botoes > button {
        width: 100%;
      }
      .dem-edi-pro-doc > .desvincular > table > tr > td.botoes > button:first-child {
        min-height: 52px;
      }
      .dem-edi-pro-doc > .desvincular > table > tr > td.botoes > button:last-child {
        margin-top: 5px;
      }

    .dem-edi-pro-doc > .desvincular > table > tr > td.campo {
      padding-bottom: 2px;
    }
      .dem-edi-pro-doc > .desvincular > table > tr > td.campo > div {
        width: 255px;
        min-width: 255px;
        max-width: 255px;
      }

  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_cv,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_n,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_emi,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_vf,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_des {
    margin-right: 10px;
  }
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_vf,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_vs,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_des,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_od {
    width: calc((100% / 2) - (10px / 2));
  }

  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_ca {
    width: calc((100% - 35px) - (10px / 2));
  }
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_emi,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_s,
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_n {
    width: calc((100% / 3) - (20px / 3));
  }

  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--p_doc_ca ~ button {
    display: inline-block;
    width: 35px;
    height: 30px;
    margin-top: -3px;
    margin-left: 5px;
  }

  .dem-edi-pro-doc--p_doc_tp-confirm {
    text-align: center;
  }
    .dem-edi-pro-doc--p_doc_tp-confirm > button {
      margin-right: 15px;
      min-width: 60px;
    }
</style>

<style>
  .dem-edi-pro-doc > .botoes > .iniciais > button > span > span > svg,
  .dem-edi-pro-doc > .desvincular > table > tr > td.botoes > button > span > span > svg,
  .dem-edi-pro-doc > .campos > .acoes > table.danfe > tr:last-child > td > div > div > button > span > span > svg {
    font-size: 18px;
    margin-bottom: 4px;
  }

  .dem-edi-pro-doc > div > div > input,
  .dem-edi-pro-doc > div > div > div > input,
  .dem-edi-pro-doc > div > .app-cpnt-field > div > input,
  .dem-edi-pro-doc > div > div > div > .select2 > span > span > span,
  .dem-edi-pro-doc > div > div > div > div > .select2 > span > span > span {
    text-align: left !important;
  }
  
  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--informar_p_doc_loc_embarque > .toggle {
    visibility: hidden !important;
  }

  .dem-edi-pro-doc > .campos > div > .dem-edi-pro-doc--informar_p_doc_dh_sai_ent > label {
    word-break: break-all;
    white-space: nowrap;
  }
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    props: {
      cpntDemanda: {
        required: true
      },
      cpntDemandaId: {
        required: true
      },
      cpntDemandaTotal: {
        required: true
      },
      cpntDemStatus: {
        required: true
      },
      cpntDemData: {
        required: true
      },
      cpntDemandaFlag: {
        required: false,
        default: function () {
          return ''
        }
      },
      cpntPDV: {
        required: false,
        default: function () {
          return false
        }
      },
      cpntIdConPessoa: {
        required: true
      },
      
      cpntIdConCnpjCpf: {
        required: true
      },
      cpntPDocNFEmitida: {
        required: true
      },
      cpntPDocDocs: {
        required: true
      },
      cpntPDocCCe: {
        required: true
      },
      cpntPDocFiscal: {
        required: true
      },
      cpntPDocTp: {
        required: true
      },
      cpntPDocTpOptions: {
        required: true
      },
      cpntPDocOpe: {
        required: true
      },
      cpntPDocNatOpe: {
        required: true
      },
      cpntDocIcmsAa: {
        required: true
      },
      cpntPDocFin: {
        required: true
      },
      cpntPDocRefChave: {
        required: true
      },
      cpntPDocIndPres: {
        required: true
      },
      cpntPDocIntermediador: {
        required: true
      },
      cpntPDocFreTp: {
        required: true
      },
      cpntPDocFrePlacaUf: {
        required: true
      },
      cpntPDocFrePlaca: {
        required: true
      },
      cpntPDocFreVolumes: {
        required: true
      },
      cpntPDocRetPrevA: {
        required: true
      },
      cpntPDocDataHoraSaiEnt: {
        required: true
      },
      cpntPDocTransportadora: {
        required: true
      },
      cpntPDocEstadoEmbarque: {
        required: true
      },
      cpntPDocCidadeEmbarque: {
        required: true
      },
      cpntPDocLocalDespacho: {
        required: true
      },
      cpntPDocAcoes: {
        required: true
      },
      cpntPDocManualChaveAcesso: {
        required: true
      },
      cpntPDocManualDataEmissao: {
        required: true
      },
      cpntPDocManualNumero: {
        required: true
      },
      cpntPDocManualSerie: {
        required: true
      },
      cpntPDocManualFrete: {
        required: true
      },
      cpntPDocManualSeguro: {
        required: true
      },
      cpntPDocDesconto: {
        required: true
      },
      cpntPDocManualOda: {
        required: true
      }
    },
    components: {
      'Demanda-Editar-Produtos-Documento-Dialog-Pagamento': () => import('@/components/demanda/Editar/Produto/Demanda-Editar-Produtos-Documento-Dialog-Pagamento.vue'),
      'Demanda-Editar-Produtos-Documento-Volumes': () => import('@/components/demanda/Editar/Produto/Demanda-Editar-Produtos-Documento-Volumes.vue'),

      'RF-Carta-Correcao-Eletronica': () => import('@/components/df/cce/Carta-Correcao-Eletronica.vue'),
      'DF-Log': () => import('@/components/_geral/DF-Log.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        original: {},
        confirmacao: false,
        previsualizar: '',
        campos: {
          p_doc_des_v: {
            id: 'dem-edi-pro-doc--p_doc_des_v',
            status: '',
            tabIndex: 17021101,
            nome: 'Valor desconto',
            value: '',
            mask: 'valorMoeda',
            apiEnv: 'global_produto_valor_des_fixo',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_des_p: {
            id: 'dem-edi-pro-doc--p_doc_des_p',
            status: '',
            tabIndex: 17021101,
            nome: '% do desconto',
            value: '',
            mask: 'valorDecimalNovo',
            apiEnv: 'global_produto_valor_des_por',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_des_t: {
            id: 'dem-edi-pro-doc--p_doc_des_t',
            status: '',
            tabIndex: 17021100,
            options: [
              { id: 'R$', api: 'valor' },
              { id: '%', api: 'porcentagem' }
            ],
            keyMostra: [ 'id' ],
            keyValue: 'id',
            nome: 'Tipo desconto',
            value: '',
            mask: '',
            onChange: this.demEdiProDocOnChangeValue
          },

          p_doc_tp: {
            id: 'dem-edi-pro-doc--p_doc_tp',
            status: '',
            tabIndex: 17021001,
            nome: 'Documento',
            keyValue: 'id',
            keyMostra: [ 'desc' ],
            options: [],
            apiEnv: 'p_doc_tp',
            mostrar: true,
            searchMinimo: 4,
            optionInicialNome: 'Selecione',
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          cnpj_cpf: {
            id: 'dem-edi-cab--cnpj_cpf',
            status: '',
            tabIndex: 17021002,
            nome: 'CPF/CNPJ',
            value: '',
            mask: 'cnpj_cpf',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_ope: {
            id: 'dem-edi-pro-doc--p_doc_ope',
            status: '',
            tabIndex: 17021003,
            nome: 'Operação',
            keyValue: 'id',
            keyMostra: [ 'id', ' - ', 'nome' ],
            options: [],
            apiEnv: 'p_doc_ope',
            mostrar: true,
            searchMinimo: 4,
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_nat_ope: {
            id: 'dem-edi-cab--p_doc_nat_ope',
            status: '',
            tabIndex: 17021004,
            nome: 'Natureza da operação',
            apiEnv: 'p_doc_nat_ope',
            explica: { mensagem: 'Ao clicar em Sugerir o Rotina Fácil irá se basear nos CFOPs utilizados indicando assim a melhor Natureza da Operação para o caso.<br/><br/>Se nenhum CFOP for encontrado o sistema emitirá uma alerta e não será alterado o campo.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          sugerirBT: {
            status: '',
            tabIndex: 17021005,
            texto: 'Sugerir',
            mostrar: true,
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            onClick: this.demEdiProDocSugerirNatOpe
          },
          p_doc_fin: {
            id: 'dem-edi-pro-doc--p_doc_fin',
            status: '',
            tabIndex: 17021006,
            nome: 'Finalidade de emissão',
            keyValue: 'id',
            keyMostra: [ 'id', ' - ', 'nome' ],
            options: [
              { id: '1', nome: 'NF-e normal' },
              { id: '4', nome: 'Devolução/Retorno' }
            ],
            apiEnv: 'p_doc_fin',
            mostrar: true,
            searchMinimo: 4,
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          referenciar_j_p_doc_ref_ca: {
            id: 'dem-edi-pro-doc--referenciar_j_p_doc_ref_ca',
            status: '',
            tabIndex: 17021007,
            nome: 'Referência nota',
            on: 'Sim',
            off: 'Não',
            explica: { mensagem: 'Marque como sim caso precise referenciar uma nota nesta NF-e.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          referenciarNovaChave: {
            status: '',
            tabIndex: 17021008,
            tipo: 'icone',
            icone: 'ico-mais',
            mostrar: true,
            class: [ 'btn', 'btn-primary', 'btn-sm' ],
            explica: { titulo: '', mensagem: 'Clique aqui para adicionar mais uma chave de acesso referenciada nesta nota.', posicaoMy: 'top right', posicaoAt: 'bottom left' },
            onClick: this.demEdiProDocAdicionarChaveReferenciada
          },
          j_p_doc_ref_ca: {
            id: 'dem-edi-pro-doc--j_p_doc_ref_ca--',
            status: '',
            tabIndex: 17021009,
            type: 'number-text',
            maxLength: 44,
            tipo: 'toggles',
            apiRec: 'cpntPDocRefChave',
            nome: 'Chave de Acesso',
            mask: 'chave_acesso',
            value: {},
            apiEnv: 'j_p_doc_fin_ref_manual',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_ind_pres: {
            id: 'dem-edi-pro-doc--p_doc_ind_pres',
            status: '',
            tabIndex: 17021010,
            nome: 'Indicador presença',
            keyValue: 'id',
            keyMostra: [ 'id', ' - ', 'nome' ],
            options: [
              { id: '0', nome: 'Não se aplica (por exemplo, Nota Fiscal complementar ou de ajuste)' },
              { id: '1', nome: 'Operação presencial' },
              { id: '2', nome: 'Operação não presencial, pela Internet' },
              { id: '3', nome: 'Operação não presencial, Teleatendimento' },
              { id: '4', nome: 'NFC-e em operação com entrega a domicílio' },
              { id: '5', nome: 'Operação presencial, fora do estabelecimento' },
              { id: '9', nome: 'Operação não presencial, outros.' }
            ],
            apiEnv: 'p_doc_ind_pres',
            mostrar: true,
            searchMinimo: 4,
            optionInicialNome: 'Selecione',
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_id_ven_cfg_intermediador: {
            id: 'dem-edi-pro-doc--p_id_ven_cfg_intermediador',
            status: '',
            tabIndex: 17021011,
            nome: 'Intermediador',
            keyValue: 'id',
            keyMostra: [ 'nome', ' | ', '_cnpj', ' | ', 'usu_intermediador' ],
            options: [],
            apiEnv: 'p_id_ven_cfg_intermediador',
            mostrar: true,
            searchMinimo: 4,
            optionInicialNome: '0 - Operação sem intermediador (em site ou plataforma própria)',
            optionInicialValue: '0',
            value: '',
            explica: { mensagem: 'Indicador de intermediador/marketplace<br/><br/>* Considera-se intermediador/marketplace os prestadores de serviços e de negócios referentes às transações comerciais ou de prestação de serviços intermediadas, realizadas por pessoas jurídicas inscritas no Cadastro Nacional de Pessoa Jurídica - CNPJ, ainda que não inscritas no cadastro de contribuintes do ICMS<br/><br/>* Considera-se site/plataforma própria as vendas que não foram intermediadas (por marketplace), como venda em site próprio, teleatendimento.' },
            onBuscarOptions: this.demEdiProDocOnBuscarIntermediador,
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_fre_tp: {
            id: 'dem-edi-pro-doc--p_doc_fre_tp',
            status: '',
            tabIndex: 17021012,
            nome: 'Frete por conta',
            keyValue: 'id',
            keyMostra: [ 'id', ' - ', 'nome' ],
            options: [
              { id: '0', nome: 'Contratação do Frete por conta do Remetente (CIF)' },
              { id: '1', nome: 'Contratação do Frete por conta do Destinatário (FOB)' },
              { id: '2', nome: 'Contratação do Frete por conta de Terceiros' },
              { id: '3', nome: 'Transporte Próprio por conta do Remetente' },
              { id: '4', nome: 'Transporte Próprio por conta do Destinatário' },
              { id: '9', nome: 'Sem Ocorrência de Transporte.' }
            ],
            apiEnv: 'p_doc_fre_tp',
            mostrar: true,
            searchMinimo: 4,
            optionInicialNome: 'Selecione',
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_fre_id: {
            id: 'dem-edi-pro-doc--p_doc_fre_id',
            status: '',
            tabIndex: 17021012,
            nome: 'Transportadora',
            router: '/contato/get',
            method: 'POST',
            field: { id: null, nome: null, empresa: null, cnpj_cpf: null },
            where: { aAnd: [ { f: 'status', o: '=', v: '1' }, { o: 's.ft', v: '#BUSCA#' } ] },
            keyValue: 'id',
            keyMostra: [ 'nome', ' | ', 'empresa', ' | ', 'cnpj_cpf' ],
            newOption: {
              tipo: 'icone',
              icone: { tipo: 'ico-mais' },
              explica: { titulo: '', mensagem: 'Adicionar nova transportadora' },
              class: [ 'btn', 'btn-primary', 'btn-sm' ],
              onClick: this.demEdiProDocOnNovaTransportadora
            },
            valueRef: '',
            mostrar: true,
            apiEnv: 'p_doc_fre_id',
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_fre_placa_uf: {
            id: 'dem-edi-pro-doc--p_doc_fre_placa_uf',
            status: '',
            tabIndex: 17021013,
            nome: 'UF Veículo de transporte',
            keyValue: 'uf',
            keyMostra: [ 'uf', ' - ', 'estado' ],
            options: this.$store.state.UFs,
            apiEnv: 'p_doc_fre_placa_uf',
            mostrar: true,
            searchMinimo: 4,
            optionInicialNome: 'Sem informar',
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_fre_placa: {
            id: 'dem-edi-pro-doc--p_doc_fre_placa',
            status: '',
            tabIndex: 17021014,
            nome: 'Placa',
            mask: 'placa',
            apiEnv: 'p_doc_fre_placa',
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          informar_p_doc_fre_volumes: {
            id: 'dem-edi-pro-doc--informar_p_doc_fre_volumes',
            status: '',
            tabIndex: 17021015,
            nome: 'Informar volume',
            on: 'Sim',
            off: 'Não',
            value: '',
            dialog: false,
            apiEnv: 'p_doc_fre_vol',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_fre_volumes: {
            status: '',
            tabIndex: 17021016,
            mostrar: true,
            class: [ 'btn', 'btn-default', 'btn-sm' ],
            value: [],
            onClick: () => {
              // MANDA ABRIR A DIALOG
              this.$set(this.campos.informar_p_doc_fre_volumes, 'dialog', true)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            }
          },
          informar_p_doc_ret_prev_a: {
            id: 'dem-edi-pro-doc--informar_p_doc_ret_prev_a',
            status: '',
            tabIndex: 17021017,
            nome: 'Ret. previdenciária',
            on: 'Sim',
            off: 'Não',
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_ret_prev_a: {
            id: 'dem-edi-pro-doc--p_doc_ret_prev_a',
            status: '',
            tabIndex: 17021018,
            nome: 'Alíquota retenção',
            mask: 'valorMoeda',
            apiEnv: 'p_doc_ret_prev_a',
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          informar_p_doc_dh_sai_ent: {
            id: 'dem-edi-pro-doc--informar_p_doc_dh_sai_ent',
            status: '',
            tabIndex: 17021019,
            nome: ('Inf. data de ' + ([ 'venda', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1 ? 'saída' : 'entrada')),
            on: 'Sim',
            off: 'Não',
            value: '',
            mask: 'data-time',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_dh_sai_ent: {
            id: 'dem-edi-pro-doc--p_doc_dh_sai_ent',
            status: '',
            tabIndex: 17021020,
            nome: 'Data',
            config: {
              dateFormat: 'dd/mm/yyyy',
              minDate: moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY')
            },
            apiEnv: 'p_doc_dh_sai_ent',
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_dh_sai_ent_hora: {
            id: 'dem-edi-pro-doc--p_doc_dh_sai_ent_hora',
            status: '',
            tabIndex: 17021021,
            nome: 'Hora',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            options: [
              { id: '00' },
              { id: '01' },
              { id: '02' }
            ],
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_dh_sai_ent_minuto: {
            id: 'dem-edi-pro-doc--p_doc_dh_sai_ent_minuto',
            status: '',
            tabIndex: 17021022,
            nome: 'Minuto',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            options: [
              { id: '00' },
              { id: '01' },
              { id: '02' }
            ],
            value: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          motivo: {
            id: 'dem-edi-pro-doc--motivo',
            status: '',
            nome: 'Motivo',
            mostrar: true,
            value: '',
            valueIni: '',
            onChange: this.demEdiProDocOnChangeValue
          },
          informar_p_doc_loc_embarque: {
            id: 'dem-edi-pro-doc--informar_p_doc_loc_embarque',
            status: '',
            tabIndex: 17021040,
            nome: 'Inf. Local de Embarque',
            on: 'Sim',
            off: 'Não',
            value: '',
            dialog: false,
            // apiEnv: 'p_doc_fre_vol',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_loc_embarque_uf_saida_pais: {
            id: 'dem-edi-pro-doc--p_doc_loc_embarque_uf_saida_pais',
            status: '',
            nome: 'Estado',
            keyValue: 'uf',
            keyMostra: [ 'uf', ' - ', 'estado' ],
            options: [],
            // apiEnv: 'p_doc_loc_embarque_uf_saida_pais',
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            explica: { mensagem: 'UF de Embarque ou de transposição de fronteira' },
            onBuscarOptions: this.demEdiProDocOnBuscarEmbarqueEstado,
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_loc_embarque_cidade: {
            id: 'dem-edi-pro-doc--p_doc_loc_embarque_cidade',
            status: '',
            nome: 'Cidade',
            keyValue: 'id',
            keyMostra: [ 'cidade' ],
            options: [],
            apiEnv: 'p_doc_exp_xLocExporta_id_cidade',
            mostrar: true,
            optionInicialNome: 'Selecione',
            value: '',
            disabled: false,
            explica: { mensagem: 'Descrição do Local de Embarque ou de transposição de fronteira' },
            onBuscarOptions: this.demEdiProDocOnBuscarEmbarqueCidade,
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_loc_embarque_despacho: {
            id: 'dem-edi-pro-doc--p_doc_loc_embarque_despacho',
            status: '',
            nome: 'Local de Despacho',
            value: '',
            valueIni: '',
            apiEnv: 'p_doc_exp_xLocDespacho',
            explica: { mensagem: 'Informação do Recinto Alfandegado' },
            onChange: this.demEdiProDocOnChangeValue
          },
          // p_doc_loc_embarque: {
          //   status: '',
          //   tabIndex: 17021041,
          //   mostrar: true,
          //   class: [ 'btn', 'btn-default', 'btn-sm' ],
          //   value: {},
          //   onClick: () => {
          //     // MANDA ABRIR A DIALOG
          //     this.$set(this.campos.informar_p_doc_loc_embarque, 'dialog', true)

          //     // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          //     this.time = new Date().getTime()
          //   }
          // },

          // CAMPOS PARA UTILIZAÇÃO SEM NFS-E
          // 4121 0824 6984 8700 0196 5500 1000 0003 8319 0010 2081
          p_doc_ca: {
            id: 'dem-edi-pro-doc--p_doc_ca',
            status: '',
            tabIndex: 17021023,
            nome: 'Chave de Acesso',
            mask: 'chave_acesso',
            value: '',
            apiEnv: 'p_doc_ca',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_emi: {
            id: 'dem-edi-pro-doc--p_doc_emi',
            status: '',
            tabIndex: 17021024,
            nome: 'Data da Emissão',
            value: '',
            apiEnv: 'p_doc_emi',
            explica: { mensagem: 'Data da emissão do documento.' },
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_n: {
            id: 'dem-edi-pro-doc--p_doc_n',
            status: '',
            tabIndex: 17021025,
            nome: 'Número',
            value: '',
            apiEnv: 'p_doc_n',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_s: {
            id: 'dem-edi-pro-doc--p_doc_s',
            status: '',
            tabIndex: 17021026,
            nome: 'Série',
            value: '',
            apiEnv: 'p_doc_s',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_vf: {
            id: 'dem-edi-pro-doc--p_doc_vf',
            status: '',
            tabIndex: 17021027,
            nome: 'Valor do Frete',
            mask: 'valorMoeda',
            value: '',
            apiEnv: 'p_doc_vf',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_vs: {
            id: 'dem-edi-pro-doc--p_doc_vs',
            status: '',
            tabIndex: 17021028,
            nome: 'Valor do Seguro',
            mask: 'valorMoeda',
            value: '',
            apiEnv: 'p_doc_vs',
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_des: {
            id: 'dem-edi-pro-doc--p_doc_des',
            status: '',
            tabIndex: 17021029,
            nome: 'Valor do Desconto',
            mask: 'valorMoeda',
            value: '0,00',
            apiEnv: 'p_doc_des',
            explica: { mensagem: 'Desconto total em R$.' },
            onChange: this.demEdiProDocOnChangeValue
          },
          p_doc_od: {
            id: 'dem-edi-pro-doc--p_doc_od',
            status: '',
            tabIndex: 17021030,
            nome: 'Valor do ODA',
            mask: 'valorMoeda',
            value: '',
            apiEnv: 'p_doc_od',
            explica: { mensagem: 'Outras Despesas Acessórias' },
            onChange: this.demEdiProDocOnChangeValue
          }
        },
        mostrarPagamentos: false,
        mostrarCartaCorrecao: false,
        mostrarDetalhes: false,
        mostrarDesvincular: null,
        danfeAcao: 'imprimir',
        botoes: {
          salvar: '',
          emitir: '',
          danfe: '',
          cce: '',
          xml: ''
        }
      }
    },
    mounted: function () {
      this.demEdiProDocIniciar()
    },
    methods: {
      demEdiProDocIniciar: function () {
        // SETA O STATUS DA TELA
        this.demEdiProDocSetarStatusGeral('carregando')

        // PEGA O NOME DE CADA CHAVE QUE DEVE SETAR O VALOR
        var chaves = Object.keys(this.campos)

        // RODA O VETOR DOS CAMPOS
        for (var indexC in chaves) {
          // SETA O NOME DA CHAVE QUE SERÁ TRABALHADA
          var chave = chaves[indexC]

          // SETA OS VALORES DO CAMPO
          this.demEdiProDocSetarValorCampo(chave, true, true)

          // // SETA O VALOR INICIAL DO CAMPO
          // this.campos[chave].valueIni = JSON.parse(JSON.stringify(this.campos[chave].value))
        }

        // VERIFICA SE TEM QUE ATUALIZAR A TELA
        if (this.cpntPDocNFEmitida !== true && [ '', null, undefined ].indexOf(this.$route.params) === -1 && this.$route.params.demProDocPag === true) {
          // REALIZA A EMISSÃO DA NOTA
          this.demEdiProDocMostrarFormularioPagamento(true)

          // SETA O PARAMETRO PRA FALSO
          this.$route.params.demProDocPag = false
        }

        // SETA O STATUS DA TELA
        this.demEdiProDocSetarStatusGeral('')
      },
      demEdiProDocSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocSetarValorCampo: function (chave, ini = false, setValueIni = false) {
        // INICIA A VARIAVEL DE VALOR
        var value = ''
        var valueRef = ''
        var options = []

        // VERIFICA SE TEM ALGUM VALOR PREENCHIDO
        var dataSaidaEntrada = [ '', null, undefined ].indexOf(this.cpntPDocDataHoraSaiEnt) === -1 ? this.cpntPDocDataHoraSaiEnt : moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD HH:mm:ss').add('10', 'minutes').format('DD/MM/YYYY HH:mm:ss')

        // VERIFICA O VALOR QUE DEVE SELECIONAR
        switch (chave) {
          case 'cnpj_cpf':
            value = this.cpntIdConCnpjCpf
            break

          case 'p_doc_tp':
            value = this.cpntPDocTp
            options = this.cpntPDocTpOptions
            break

          case 'p_doc_ope':
            value = this.cpntPDocOpe
            if ([ 'compra', 'dev_cliente' ].indexOf(this.cpntDemanda) !== -1) {
              options = [ { id: '0', nome: 'Entrada' } ]
            } else if (['dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1) {
              options = [ { id: '1', nome: 'Saída' } ]
            } else {
              options = (this.$store.state.cluNfEntrada === false || this.cpntPDocTp !== 'NFe') ? [ { id: '1', nome: 'Saída' } ] : [ { id: '1', nome: 'Saída' }, { id: '0', nome: 'Entrada' } ]
            }
            break

          case 'p_doc_nat_ope':
            value = this.cpntPDocNatOpe
            break

          case 'p_doc_fin':
            value = this.cpntPDocFin
            options = this.campos.p_doc_fin.options
            break

          case 'p_doc_ind_pres':
            value = this.cpntPDocIndPres
            options = this.campos.p_doc_ind_pres.options
            break

          case 'p_id_ven_cfg_intermediador':
            if ([ '', null, undefined ].indexOf(this.cpntPDocIntermediador) === -1 && [ '', null, undefined ].indexOf(this.cpntPDocIntermediador.id) === -1) {
              value = this.cpntPDocIntermediador
            }
            break

          case 'p_doc_fre_tp':
            value = this.cpntPDocFreTp
            options = this.campos.p_doc_fre_tp.options
            break

          case 'p_doc_fre_id':
            if ([ '', null, undefined ].indexOf(this.cpntPDocTransportadora) === -1) {
              value = { id: this.cpntPDocTransportadora.id_con, nome: this.cpntPDocTransportadora.id_con_nome, empresa: this.cpntPDocTransportadora.id_con_empresa, cnpj_cpf: this.cpntPDocTransportadora.id_con_cnpj_cpf, status: this.cpntPDocTransportadora.id_con_status }
            }
            break

          case 'p_doc_fre_placa_uf':
            value = this.cpntPDocFrePlacaUf
            options = this.$store.state.UFs
            break

          case 'p_doc_fre_placa':
            value = this.cpntPDocFrePlaca
            options = this.$store.state.UFs
            break

          case 'informar_p_doc_ret_prev_a':
            value = [ '', null, undefined ].indexOf(this.cpntPDocRetPrevA) !== -1 ? false : true
            break

          case 'p_doc_ret_prev_a':
            value = [ '', null, undefined ].indexOf(this.cpntPDocRetPrevA) !== -1 ? [] : this.cpntPDocRetPrevA
            break
            
          case 'informar_p_doc_dh_sai_ent':
            value = [ '', null, undefined ].indexOf(this.cpntPDocDataHoraSaiEnt) !== -1 ? false : true
            break

          case 'p_doc_dh_sai_ent':
            if (ini === false || (ini === true && [ '', null, undefined ].indexOf(this.cpntPDocDataHoraSaiEnt) === -1)) {
              // REMOVE A PALAVRA AS
              value = JSON.parse(JSON.stringify(dataSaidaEntrada)).replace(' às ', ' ')
  
              // FORMATA O VALOR
              if (value !== '') {
                value = moment(value, 'DD/MM/YYYY HH:mm:ss').format('DD/MM/YYYY')
              }
            }
            break

          case 'p_doc_dh_sai_ent_hora':
            if (ini === false || (ini === true && [ '', null, undefined ].indexOf(this.cpntPDocDataHoraSaiEnt) === -1)) {
              // SETA OS OPTIONS DO CAMPO
              options = [ { id: '00' }, { id: '01' }, { id: '02' }, { id: '03' }, { id: '04' }, { id: '05' }, { id: '06' }, { id: '07' }, { id: '08' }, { id: '09' }, { id: '10' }, { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' }, { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' }, { id: '21' }, { id: '22' }, { id: '23' } ]

              // REMOVE A PALAVRA AS
              value = JSON.parse(JSON.stringify(dataSaidaEntrada)).replace(' às ', ' ')

              // FORMATA O VALOR
              if (value !== '') {
                value = moment(value, 'DD/MM/YYYY HH:mm:ss').format('HH')
              }
            }
            break

          case 'p_doc_dh_sai_ent_minuto':
            if (ini === false || (ini === true && [ '', null, undefined ].indexOf(this.cpntPDocDataHoraSaiEnt) === -1)) {
              // SETA OS OPTIONS DO CAMPO
              options = [ { id: '00' }, { id: '01' }, { id: '02' }, { id: '03' }, { id: '04' }, { id: '05' }, { id: '06' }, { id: '07' }, { id: '08' }, { id: '09' }, { id: '10' }, { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' }, { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' }, { id: '21' }, { id: '22' }, { id: '23' }, { id: '24' }, { id: '25' }, { id: '26' }, { id: '27' }, { id: '28' }, { id: '29' }, { id: '30' }, { id: '31' }, { id: '32' }, { id: '33' }, { id: '34' }, { id: '35' }, { id: '36' }, { id: '37' }, { id: '38' }, { id: '39' }, { id: '40' }, { id: '41' }, { id: '42' }, { id: '43' }, { id: '44' }, { id: '45' }, { id: '46' }, { id: '47' }, { id: '48' }, { id: '49' }, { id: '50' }, { id: '51' }, { id: '52' }, { id: '53' }, { id: '54' }, { id: '55' }, { id: '56' }, { id: '57' }, { id: '58' }, { id: '59' } ]

              // REMOVE A PALAVRA AS
              value = JSON.parse(JSON.stringify(dataSaidaEntrada)).replace(' às ', ' ')

              // FORMATA O VALOR
              if (value !== '') {
                value = moment(value, 'DD/MM/YYYY HH:mm:ss').format('mm')
              }
            }
            break

          case 'informar_p_doc_fre_volumes':
            value = [ '', null, undefined ].indexOf(this.cpntPDocFreVolumes) !== -1 || Array.isArray(this.cpntPDocFreVolumes) === false || this.cpntPDocFreVolumes.length === 0 ? false : true
            break

          case 'p_doc_fre_volumes':
            value = [ '', null, undefined ].indexOf(this.cpntPDocFreVolumes) !== -1 || Array.isArray(this.cpntPDocFreVolumes) === false || this.cpntPDocFreVolumes.length === 0 ? [] : this.cpntPDocFreVolumes
            break

          case 'informar_p_doc_loc_embarque':
            value = this.cpntDemanda === 'venda' && this.cpntIdConPessoa === 'e' && [ 'NFe' ].indexOf(this.cpntPDocTp) !== -1
            break

          case 'p_doc_loc_embarque_uf_saida_pais':
            value = this.cpntPDocEstadoEmbarque
            break

          case 'p_doc_loc_embarque_cidade':
            value = this.cpntPDocCidadeEmbarque
            break

          case 'p_doc_loc_embarque_despacho':
            value = this.cpntPDocLocalDespacho
            break

          case 'referenciar_j_p_doc_ref_ca':
            value = ([ '', null, undefined ].indexOf(this.cpntPDocRefChave) !== -1 || Array.isArray(this.cpntPDocRefChave) === true || this.cpntPDocRefChave.length === 0) ? false : true
            break
          
          case 'j_p_doc_ref_ca':
            // INICIA O VETOR QUE SERÁ SETADO
            value = {}

            // VERIFICA SE TEM VALOR PARA SETAR
            if (this.cpntPDocRefChave !== null) {
              // PEGA O VALOR RECEBIDO
              var ref = JSON.parse(JSON.stringify(this.cpntPDocRefChave))

              // CONVERTE O VALOR RECEBIDO
              if ([ '', null, undefined ].indexOf(ref.mod) === -1 && [ '', null, undefined ].indexOf(ref.ca) === -1) {
                ref = [ ref.ca ]
              }

              // INICIA O VETOR
              if (ref.length === 0) {
                ref.push('')
              }
  
              // CONVERTE TODAS AS CHAVES EXISTENTES
              for (var indexR in ref) {
                value['_' + indexR] = ref[indexR]
              }
            }
            break

          case 'referenciarNovaChave':
          case 'sugerirBT':
          case 'motivo':
            break

          case 'p_doc_emi':
            value = this.cpntPDocManualDataEmissao
            break
          
          case 'p_doc_ca':
            value = this.cpntPDocManualChaveAcesso
            break

          case 'p_doc_n':
            value = this.cpntPDocManualNumero
            break

          case 'p_doc_s':
            value = this.cpntPDocManualSerie
            break

          case 'p_doc_vf':
            value = this.cpntPDocManualFrete
            break

          case 'p_doc_vs':
            value = this.cpntPDocManualSeguro
            break
          
          case 'p_doc_des_t':
            options = this.campos.p_doc_des_t.options
            value = this.campos.p_doc_des_t.options.filter(item => item.api === this.cpntPDocDesconto.global_select)

            value = value.length >= 1 ? value[0] : ''
            break

          case 'p_doc_des_p':
            // SETA O VALOR FORMATADO
            value = [ '', null, undefined ].indexOf(this.cpntPDocDesconto.global_porcentagem) !== -1 ? '' : this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', JSON.parse(JSON.stringify(this.cpntPDocDesconto.global_porcentagem)))

            // VERIFICA SE TEM PORCENTAGEM DE DESCONTO
            if ([ '', null, undefined ].indexOf(this.$refs.p_doc_des_p) === -1) {
              // FAZ A SEPARAÇÃO PARA SABER QUANTAS CASAS DECIMAIS TERÁ
              var valueD = value.split(',')
              
              // VERIFICA SE DEVE ATIVAR A CASA DECIMAL OU NÃO
              this.$refs.p_doc_des_p.usarDecimal = (valueD.length === 2 && valueD[1].length >= 3)
            }
            break
            
          case 'p_doc_des_v':
            value = [ '', null, undefined ].indexOf(this.cpntPDocDesconto.global_valor) !== -1 ? '' : (Number(this.cpntPDocDesconto.global_valor) * 100).toFixed(0)
            break

          case 'p_doc_od':
            value = this.cpntPDocManualOda
            break
        }

        // VERIFICA SE TEM ALGUM VALOR VALIDO PARA O CAMPO
        if ([ '', null, undefined, NaN ].indexOf(value) !== -1 || (typeof value === 'string' && Object.is(NaN, value) === true)) {
          value = ''
        }

        // QUEBRA A LIGAÇÃO DO VUE
        value = JSON.parse(JSON.stringify(value))

        // VERIFICA SE TEM OPTION E O VALOR SELECIONADO É UM STRING
        if (options.length >= 1 && typeof value === 'string') {
          // PEGA O VALOR DO CAMPO
          var valor = options.filter((option) => { return option[this.campos[chave].keyValue] === value })

          // SETA O VALOR ENCONTRADO
          value = valor.length === 1 ? valor[0] : value
        }

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos[chave], 'value', value)
        this.$set(this.campos[chave], 'options', options)
        this.$set(this.campos[chave], 'valueRef', valueRef)

        // SETA O VALOR INICIAL DO CAMPO
        if (setValueIni === true) {
          this.campos[chave].valueIni = JSON.parse(JSON.stringify(value))
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocOnChangeValue: function (value, id) {
        // PEGA O NOME DO CAMPO QUE ESTÁ SENDO ALTERADO
        var indexF = id.split('--')

        // VERIFICA A AÇÃO QUE DEVE REALIZAR NO CAMPO
        if ([ 'j_p_doc_ref_ca', 'informar_p_doc_fre_volumes', 'informar_p_doc_loc_embarque' ].indexOf(indexF[1]) === -1) {
          // SETA O VALOR RECEBIDO
          this.$set(this.campos[indexF[1]], 'value', value)
  
          // LIMPA O CAMPO DE MENSAGEM DE ERRO
          this.$set(this.campos[indexF[1]], 'mensagem', '')
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }

        // VERIFICA A AÇÃO DO CAMPO
        switch (indexF[1]) {
          case 'p_doc_tp':
            if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) === -1) {
              // PEGA O VALOR SELECIONADO
              var _value = typeof value === 'string' ? value : value.id
              
              // VERIFICA SE DEVE ALTERAR O DOCUMENTO
              if (_value !== this.cpntPDocTp) {
                if ([ 'NFCe', 'NFe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.cpntPDocTp) !== -1) {
                  this.demEdiProDocConfirmaAlteracaoDoc(false)
                } else {
                  this.demEdiProDocAlterarDocumento()
                }
              }
            }
            break

          case 'j_p_doc_ref_ca':
            // SETA O VALOR ATUALIZADO DO CAMPO
            this.$set(this.campos[indexF[1]].value, indexF[2], value)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break

          case 'referenciar_j_p_doc_ref_ca':
            if (value === true) {
              if (Object.keys(this.campos.j_p_doc_ref_ca.value).length === 0) {
                this.demEdiProDocAdicionarChaveReferenciada()
              }
            } else {
              this.campos.j_p_doc_ref_ca.value = {}
            }
            break
          
          case 'p_doc_fin':
            // PEGA O VALOR SELECIONADO NO CAMPO
            var pDocFin = typeof value === 'string' ? value : value.id

            // VERIFICA SE TEM QUE INSERIR O CAMPO DE CHAVE DE ACESSO
            if ([ '4' ].indexOf(pDocFin) !== -1 && Object.keys(this.campos.j_p_doc_ref_ca.value).length === 0) {
              this.demEdiProDocAdicionarChaveReferenciada()
            }
            break

          case 'informar_p_doc_fre_volumes':
            // LIMPA O CAMPO DE MENSAGEM DE ERRO
            this.$set(this.campos[indexF[1]], 'mensagem', '')

            // MANDA ABRIR A DIALOG
            if (value === true) {
              // SETA PARA ABRIR A TELA DE VOLUMES
              this.$set(this.campos.informar_p_doc_fre_volumes, 'dialog', true)

              // SETA O VALOR RECEBIDO
              this.$set(this.campos[indexF[1]], 'value', true)
            } else {
              this.$set(this.campos[indexF[1]], 'value', false)
            }

            // SETA O VALOR ATUALIZADO DO CAMPO
            this.$set(this.campos.p_doc_fre_volumes, 'value', [])

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break

          case 'informar_p_doc_loc_embarque':
            // LIMPA O CAMPO DE MENSAGEM DE ERRO
            this.$set(this.campos[indexF[1]], 'mensagem', '')

            // MANDA ABRIR A DIALOG
            if (value === true) {
              // SETA PARA ABRIR A TELA DE VOLUMES
              this.$set(this.campos.informar_p_doc_loc_embarque, 'dialog', true)

              // SETA O VALOR RECEBIDO
              this.$set(this.campos[indexF[1]], 'value', true)
            } else {
              this.$set(this.campos[indexF[1]], 'value', false)
            }

            // SETA O VALOR ATUALIZADO DO CAMPO
            this.$set(this.campos.p_doc_loc_embarque, 'value', {})

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break

          case 'p_doc_loc_embarque_uf_saida_pais':
            // VERIFICA SE DEVE DESATIVAR O CAMPO
            var disabled = [ '', null, undefined ].indexOf(typeof value === 'string' ? value : value.uf) !== -1

            // VERIFICA SE TEM QUE LIMPAR O VALOR DO CAMPO
            if (disabled === true) {
              this.campos.p_doc_loc_embarque_cidade.value = ''
            }

            // VERIFICA SE DEVE DESATIVAR O CAMPO
            this.campos.p_doc_loc_embarque_cidade.disabled = disabled

            // LIMPA OS OPTIONS DO SELETOR
            this.campos.p_doc_loc_embarque_cidade.options = []

            // SETA O FOCUS NO CAMPO
            if (disabled === false) {
              this.demEdiProDocRealizarFocusCampo('p_doc_loc_embarque_cidade')
            }
            break

          case 'informar_p_doc_ret_prev_a':
            // SETA O VALOR ATUALIZADO DO CAMPO
            this.$set(this.campos.p_doc_ret_prev_a, 'value', '')

            // SETA O FOCUS NO CAMPO
            this.demEdiProDocRealizarFocusCampo('p_doc_ret_prev_a')

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            break

          case 'informar_p_doc_dh_sai_ent':
            // SETA O VALOR ATUALIZADO DO CAMPO
            if (value === false) {
              this.$set(this.campos.p_doc_dh_sai_ent, 'value', '')
              this.$set(this.campos.p_doc_dh_sai_ent_hora, 'value', '')
              this.$set(this.campos.p_doc_dh_sai_ent_minuto, 'value', '')
            } else {
              // SETA O VALOR INICIAL DO CAMPO
              this.demEdiProDocSetarValorCampo('p_doc_dh_sai_ent')
              this.demEdiProDocSetarValorCampo('p_doc_dh_sai_ent_hora')
              this.demEdiProDocSetarValorCampo('p_doc_dh_sai_ent_minuto')

              // SETA O FOCUS NO CAMPO
              this.demEdiProDocRealizarFocusCampo('p_doc_dh_sai_ent')
            }

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
            // informar_p_doc_dh_sai_ent
            break

          case 'p_doc_des_t':
            if (this.demEdiProDocValorTipoDesconto === '%') {
              this.demEdiProDocRealizarFocusCampo('p_doc_des_p')
            } else {
              this.demEdiProDocRealizarFocusCampo('p_doc_des_v')
            }
            break
        }
      },
      demEdiProDocAlterarDocumento: function () {
        // PEGA OS VALORES PARA COMPARAÇÃO
        var value = typeof this.campos.p_doc_tp.value === 'string' ? this.campos.p_doc_tp.value : this.campos.p_doc_tp.value.id
        var valueIni = typeof this.campos.p_doc_tp.valueIni === 'string' ? this.campos.p_doc_tp.valueIni : this.campos.p_doc_tp.valueIni.id

        // VERIFICA SE DEVE ATUALIZAR O DOCUMENTO OU NÃO
        if (value !== valueIni) {
          // TRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)
  
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }
  
          // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
          const finalizacao = () => {
            // ATUALIZA OS DADOS E DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES')
  
            // DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }

          // INICIA A VARIAVEL DA ROTA
          var router = ''
  
          // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = { p_doc_tp: this.campos.p_doc_tp.value }
  
          // CONVERTE O VALOR RECEBIDO
          if (typeof formData.p_doc_tp === 'object') {
            formData.p_doc_tp = formData.p_doc_tp.id
          }

          // FAZ A VERIFICAÇÃO DA ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'venda':
              // REMOVE A CHAVE SE NÃO DEVE SER PREENCHIDA
              if (this.demEdiProDocValorTipoDesconto === '%' && formData.global_produto_valor_des_fixo !== undefined) {
                delete formData.global_produto_valor_des_fixo
              } 
              if (this.demEdiProDocValorTipoDesconto === 'R$' && formData.global_produto_valor_des_por !== undefined) {
                delete formData.global_produto_valor_des_por
              }

              // SETA O ID DA DEMANDA QUE DEVE ALTERAR
              formData.cod_venda = this.cpntDemandaId

              // SETA A ROTA QUE DEVE CHAMAR
              router = '/venda'
              break

            case 'compra':
              // REMOVE A CHAVE SE NÃO DEVE SER PREENCHIDA
              if (this.demEdiProDocValorTipoDesconto === '%' && formData.global_produto_valor_des_fixo !== undefined) {
                delete formData.global_produto_valor_des_fixo
              } 
              if (this.demEdiProDocValorTipoDesconto === 'R$' && formData.global_produto_valor_des_por !== undefined) {
                delete formData.global_produto_valor_des_por
              }

              
              // SETA O ID DA DEMANDA QUE DEVE ALTERAR
              formData.dem_compra = this.cpntDemandaId

              // SETA A ROTA QUE DEVE CHAMAR
              router = '/demanda/dem-compra/p-doc-tp'

              // CONVERTE O VALOR EM LOT
              formData = { lot: [ formData ] }
              break
          }
  
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI(router, 'PUT', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
  
            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEdiProDocTratarValidacao(retorno.message, retorno.code, finalizacao)
            } else {
              // MANDA ATUALIZAR AS INFORMAÇÕES DO MENU
              this.$store.commit('SET_INFO_MENU')

              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
  
              // SETA O STATUS DE CARREGANDO DO BOTÃO
              this.botoes.salvar = ''
              
              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              finalizacao()
            }
          }, (apiError) => {
            // SETA O ERRO RECEBIDO
            this.demEdiProDocSetarStatusGeral(apiError)
  
            // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
            finalizacao()
          }, (apiValid, apiStatus) => { this.demEdiProDocTratarValidacao(apiValid, apiStatus, finalizacao) })
        }
      },
      demEdiProDocAtualizarFinanceiro: function () {
        this.$parent.$emit('DEMANDA_ATUALIZAR_FINANCEIRO')
      },
      demEdiProDocErroAtualizacaoContato: function (mensagem = '') {
        // APRESETAN A MENSAGEM QUE A INFORMAÇÃO FOI GERADA
        if ([ '', null, undefined ].indexOf(mensagem) === -1) {
          this.$store.state.msgWarn(mensagem, 'danger')
        }

        // SETA O STATUS DE CARREGANDO DO BOTÃO
        this.botoes.salvar = ''
        this.botoes.emitir = ''

        // TRAVA A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

        // MANDA ATUALIZAR O CAMPO NOVAMENTE
        this.demEdiProDocSetarValorCampo('cnpj_cpf')
      },
      demEdiProDocAlterarContatoVenda: function (id_con, callback) {
        // INICIA O FORMULARIO QUE SERÁ ENVIADO
        var formData = { id_con: id_con, cod_venda: this.cpntDemandaId }

        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI('/venda', 'PUT', formData, (apiSuccess) => {
          // PEGA O RETORNO RECEBIDO 
          var retorno = [ '', null, undefined ].indexOf(apiSuccess.lot) === -1 ? apiSuccess.lot[0] : { code: '200', message: apiSuccess.message }

          // VERIFICA O RESULTADO DA OPERAÇÃO
          switch (retorno.code) {
            case '200':
              this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { callback(true) })
              break

            default:
              this.$store.state.FUN_API_RET_VALIDA(this, 'campos', retorno.message, retorno.code, {}, true, () => {
                this.demEdiProDocErroAtualizacaoContato('WEB [409]: 004 - Não foi possivel alterar o contato da venda.')
              })
              break
          }
        }, this.demEdiProDocSetarStatusGeral, (apiValid, apiStatus) => {
          this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, {}, true, () => {
            // CONVERTE VALORES DE FORMA DE ARRAYS
            if ([ '', null, undefined ].indexOf(apiValid.geralWeb) === -1) {
              if (typeof apiValid.geralWeb === 'object' && Array.isArray(apiValid.geralWeb) === true) {
                apiValid.geralWeb = apiValid.geralWeb.join(' ')
              }
              
              this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { callback(true) })
              // if (apiValid.geralWeb.indexOf('Situação Fiscal') !== -1) {
              //   this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { callback(true) })
              // } else {
              //   this.demEdiProDocErroAtualizacaoContato('WEB [409]: 003 - Não foi possivel alterar o contato da venda.')
              // }
            } else {
              this.demEdiProDocErroAtualizacaoContato('WEB [409]: 006 - Não foi possivel alterar o contato da venda.')
            }
          })
        })
      },
      demEdiProDocSalvarContatoNFCe: function (callback) {
        if ([ 'NFCe' ].indexOf(this.cpntPDocTp) !== -1 && this.cpntIdConCnpjCpf !== this.campos.cnpj_cpf.value) {
          // INICIA A QUERY A SER BUSCADA
          var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, field: { id: null } }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { aAnd: [
            { f: 'status', o: '=', v: '1' },
            { f: 'cnpj_cpf', o: '=', v: this.campos.cnpj_cpf.value }
          ] }
          
          // ORDENA OS VALORES PELO ID
          queryGet.order = { id: 'asc' }

          // FAZ A BUSCA NA API
          this.$store.state.comunicaAPI('/contato/get', 'POST', queryGet, (retorno) => {
            switch (retorno.data.length) {
              // case 1:
              //   this.demEdiProDocAlterarContatoVenda(retorno.data[0].id, callback)
              //   break

              case 0:
                // SETA OS PARAMETROS QUE SERÁ ENVIADO
                var params = { tipo: 'contato', editar: true, id: 0, nome: this.campos.cnpj_cpf.value, tpCon: '1', cadastroRapido: true }

                // SETA O CALLBACK QUE DEVE EXECUTAR
                params.callback = (atualizar, id) => {
                  if (atualizar === true) {
                    this.demEdiProDocAlterarContatoVenda(id, callback)
                  } else {
                    this.demEdiProDocErroAtualizacaoContato('WEB [409]: 005 - Erro ao criar novo contato.')
                  }
                }

                // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
                this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
                break

              default:
                this.demEdiProDocAlterarContatoVenda(retorno.data[0].id, callback)
                // this.demEdiProDocErroAtualizacaoContato('WEB [409]: 002 - Não foi possivel localizar o contato para alteração na venda.')
                break
            }
          }, this.demEdiProDocSetarStatusGeral, (apiValid, apiStatus) => {
            this.$store.state.FUN_API_RET_VALIDA(this, 'campos', apiValid, apiStatus, {}, true, () => {
              this.demEdiProDocErroAtualizacaoContato('WEB [409]: 001 - Não foi possivel localizar o contato para alteração na venda.')
            })
          })
        } else {
          callback()
        }
      },
      demEdiProDocDevolucaoPegarValorCampo: function (indexF) {
        // INICIA A VARIAVEL
        var vetor = {}

        // INICIA A VARIAVEL DA CHAVE
        var chave = this.campos[indexF].apiEnv
        var indexK = this.campos[indexF].keyValue

        // SETA O VALOR RECEBIDO NO CAMPO
        vetor[chave] = JSON.parse(JSON.stringify(this.campos[indexF].value))

        // CONVERTE O VALOR RECEBIDO
        if ([ 'string', 'number' ].indexOf(typeof vetor[chave]) === -1) {
          vetor[chave] = vetor[chave][indexK]
        }

        // RETORNA O VALOR MONTADO
        return vetor
      },
      demEdiProDocDemandaSalvar: function (callback, vetor = null, volume = false) {
        if (vetor === null) {
          // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
          const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API
  
          // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
          FUN_MONTAR_FORMDATA_API(this.campos, { disabled: false }).then((_vetor) => { this.demEdiProDocDemandaSalvar(callback, _vetor, volume) })
        } else {
          // QUEBRA SINCRONISMO VUE
          vetor = JSON.parse(JSON.stringify(vetor))

          // PEGA O NOME DA CHAVE
          var chave = Object.keys(vetor)

          // PEGA O VALOR DA CHAVE INFORMADA
          chave = chave.length >= 1 ? chave[0] : null

          // VERIFICA SE TEM VALOR PARA ATUALIZAR
          if (volume === false && this.campos.informar_p_doc_fre_volumes.value === false && ([ '', null, undefined ].indexOf(this.cpntPDocFreVolumes) !== -1 || Array.isArray(this.cpntPDocFreVolumes) === false || this.cpntPDocFreVolumes.length === 0) === false) {
            this.demEdiProDocExcluirTodosVolumes(() => { this.demEdiProDocDemandaSalvar(callback, vetor, true) })
          } else if ([ '', null, undefined ].indexOf(chave) !== -1) {
            // ATUALIZA OS DADOS E DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
              // DESTRAVA A TELA
              this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

              // EXECUTA O CALLBACK RECEBIDO
              if (callback !== null && typeof callback === 'function') {
                callback()
              } else {
                // SETA O STATUS DE CARREGANDO DO BOTÃO
                this.botoes.salvar = ''
                this.botoes.emitir = ''

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                this.time = new Date().getTime()
              }
            })
          } else if ([ 'p_doc_fre_vol', 'j_p_doc_fin_ref_manual' ].indexOf(chave) !== -1 || ([ 'compra' ].indexOf(this.cpntDemanda) !== -1 && [ 'p_id_ven_cfg_intermediador', 'p_doc_fin', 'j_p_doc_ref_ca' ].indexOf(chave) !== -1)) {
            // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
            delete vetor[chave]

            // MANDA ATUALIZAR OS DADOS DA DEMANDA
            this.demEdiProDocDemandaSalvar(callback, vetor, volume)
          } else {
            // INICIA A VARIAVEL DE ROTA
            var router = ''
            var method = 'PUT'

            // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
            var formData = {}

            // SETA O VALOR DO CAMPO QUE DEVE ATUALIZAR
            formData[chave] = vetor[chave]

            // VERIFICA O CAMPO QUE DEVE ATUALIZAR
            switch (this.cpntDemanda + '__' + chave) {
              case 'dev_cliente__p_doc_fre_tp':
                router = '/demanda/dem-dev-cliente/p-doc-fre-tp'
                break
              case 'dev_fornecedor__p_doc_fre_tp':
                router = '/demanda/dem-dev-fornecedor/p-doc-fre-tp'
                break

              case 'dev_cliente__p_doc_fre_id':
                router = '/demanda/dem-dev-cliente/p-doc-fre-id'
                break
              case 'dev_fornecedor__p_doc_fre_id':
                router = '/demanda/dem-dev-fornecedor/p-doc-fre-id'
                break

              case 'dev_cliente__p_doc_nat_ope':
                router = '/demanda/dem-dev-cliente/p-doc-nat-ope'
                break
              case 'dev_fornecedor__p_doc_nat_ope':
                router = '/demanda/dem-dev-fornecedor/p-doc-nat-ope'
                break

              case 'dev_cliente__p_doc_fre_placa':
              case 'dev_fornecedor__p_doc_fre_placa':
                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_fre_placa_uf'))

                // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
                delete vetor.p_doc_fre_placa
                delete vetor.p_doc_fre_placa_uf

                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                if (this.cpntDemanda === 'dev_cliente') {
                  router = '/demanda/dem-dev-cliente/p-doc-fre-placa'
                } else if (this.cpntDemanda === 'dev_fornecedor') {
                  router = '/demanda/dem-dev-fornecedor/p-doc-fre-placa'
                }
                break

              case 'dev_cliente__p_doc_fre_placa_uf':
              case 'dev_fornecedor__p_doc_fre_placa_uf':
                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_fre_placa'))

                // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
                delete vetor.p_doc_fre_placa
                delete vetor.p_doc_fre_placa_uf

                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                if (this.cpntDemanda === 'dev_cliente') {
                  router = '/demanda/dem-dev-cliente/p-doc-fre-placa'
                } else if (this.cpntDemanda === 'dev_fornecedor') {
                  router = '/demanda/dem-dev-fornecedor/p-doc-fre-placa'
                }
                break

              case 'dev_cliente__global_produto_valor_des_fixo':
              case 'dev_cliente__global_produto_valor_des_por':
                router = '/demanda/dem-dev-cliente/p-des-global'
                break

              case 'dev_fornecedor__global_produto_valor_des_fixo':
              case 'dev_fornecedor__global_produto_valor_des_por':
                router = '/demanda/dem-dev-fornecedor/p-des-global'
                break

              case 'compra__p_doc_nat_ope':
                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-compra/p-doc-nat-ope'

                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_nat_ope'))
                break

              case 'compra__p_doc_ind_pres':
                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-compra/p-doc-ind-pres'

                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_ind_pres'))
                break

              case 'compra__p_doc_fre_tp':
                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-compra/p-doc-fre-tp'

                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_fre_tp'))
                break

              case 'compra__p_doc_fre_id':
                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-compra/p-doc-fre-id'

                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_fre_id'))
                break

              case 'compra__p_doc_fre_placa':
              case 'compra__p_doc_fre_placa_uf':
                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-compra/p-doc-fre-placa'

                // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
                delete vetor.p_doc_fre_placa
                delete vetor.p_doc_fre_placa_uf

                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_fre_placa_uf'))
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_fre_placa'))
                break             

              case 'compra__p_doc_ret_prev_a':
                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-compra/p-doc-ret-prev-a'

                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_ret_prev_a'))
                break

              case 'compra__global_produto_valor_des_por':
              case 'compra__global_produto_valor_des_fixo':
                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-compra/p-des-global'
                break

              case 'compra__p_doc_dh_sai_ent':
                // SETA O NOME DA ROTA QUE DEVE CHAMAR
                router = '/demanda/dem-compra/p-doc-dh-sai-ent'

                // SETA OS CAMPOS QUE DEVE ATUALIZAR
                formData = Object.assign(formData, this.demEdiProDocDevolucaoPegarValorCampo('p_doc_dh_sai_ent'))

                // VERIFICA SE DEVE JUNTAS OS VALORES DE DATA E HORA
                if ([ '', null, undefined ].indexOf(formData.p_doc_dh_sai_ent) === -1) {
                  // PREPARA PARA COLOCAR A DATA E HORA
                  formData.p_doc_dh_sai_ent += ' '
                    
                  // ADICIONA A HORA NO CAMPO
                  formData.p_doc_dh_sai_ent += [ '', null, undefined, 'Invalid date' ].indexOf(this.campos.p_doc_dh_sai_ent_hora.value) !== -1 ? '00' : this.campos.p_doc_dh_sai_ent_hora.value.id
                  
                  // COLOCA A SEPARAÇÃO DA DATA
                  formData.p_doc_dh_sai_ent += ':'
      
                  // ADICIONA OS MINUTOS NO CAMPO
                  formData.p_doc_dh_sai_ent += [ '', null, undefined, 'Invalid date' ].indexOf(this.campos.p_doc_dh_sai_ent_minuto.value) !== -1 ? '00' : this.campos.p_doc_dh_sai_ent_minuto.value.id
      
                  // COLOCA A SEPARAÇÃO DA DATA
                  formData.p_doc_dh_sai_ent += ':'
      
                  // SETA OS SEGUNDOS
                  formData.p_doc_dh_sai_ent += '00'
                }
                break
            }

            // REMOVE O CAMPO SE ELE EXISTIR
            if ([ undefined ].indexOf(formData.p_id_ven_cfg_intermediador) === -1 && this.demEdiProDocMostarIntermediador === false) {
              delete formData.p_id_ven_cfg_intermediador
            }

            // IMPORA A FUNÇÃO CALCULA A FOR DA LETRA
            const FUN_PEGAR_CHAVE_DEMANDA = require('@/assets/js/Funcoes-Gerais.js').FUN_PEGAR_CHAVE_DEMANDA

            // PEGA A CHAVE REFERENCIA
            var chaveD = FUN_PEGAR_CHAVE_DEMANDA(this.cpntDemanda)

            // SETA A IDENTIFICAÇÃO DA DEMANDA
            formData[chaveD] = this.cpntDemandaId

            // SETA A ROTA QUE DEVE CHAMAR
            formData = { lot: [ formData ] }

            // REMOVE AS CHAVES QUE SERÁ ATUALIZADA
            delete vetor[chave]

            // VERIFICA SE TEM ROTA PARA SALVAR
            if (router !== '') {
              this.$store.state.comunicaAPI(router, method, formData, (retorno) => {
                // PEGA O VALOR RECEBIDO
                retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
      
                // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
                if (retorno.code !== '200') {
                  this.demEdiProDocTratarValidacao(retorno.message, retorno.code)
                } else {
                  // APRESENTA A MENSAGEM DE SUCESSO
                  this.$store.state.TRATAR_RET_LOT_API(retorno)
      
                  // MANDA ATUALIZAR OS DADOS DA DEMANDA
                  this.demEdiProDocDemandaSalvar(callback, vetor, volume)
                }
              }, this.demEdiProDocSetarStatusGeral, this.demEdiProDocTratarValidacao)
            } else {
              // eslint-disable-next-line
              console.error('WEB [500]: Rota não implementada para atualização do campo', this.cpntDemanda, chave, vetor)

              // eslint-disable-next-line
              this.$store.state.msgWarn('WEB [500]: Rota não implementada para atualização do campo (Demanda: ' + this.cpntDemanda + ' Campo: ' + chave + ').', 'danger')
            }
          }
        }
      },
      demEdiProDocSalvarDesconto: function (formDataOrig, callback = null) {
        // REMOVE A CHAVE SE NÃO DEVE SER PREENCHIDA
        if (this.demEdiProDocValorTipoDesconto === '%' && formDataOrig.global_produto_valor_des_fixo !== undefined) {
          delete formDataOrig.global_produto_valor_des_fixo
        } 
        if (this.demEdiProDocValorTipoDesconto === 'R$' && formDataOrig.global_produto_valor_des_por !== undefined) {
          delete formDataOrig.global_produto_valor_des_por
        }

        // VERIFICA A DEMANDA RECEBIDA
        if (this.cpntDemanda !== 'compra') {
          callback(formDataOrig)
        } else {
          // INICIA A VARIAVEL
          var formData = { dem_compra: this.cpntDemandaId }

          // SETA O VALOR RECEBIDO
          if (formDataOrig.global_produto_valor_des_fixo !== undefined) {
            formData.global_produto_valor_des_fixo = formDataOrig.global_produto_valor_des_fixo
          }
          if (formDataOrig.global_produto_valor_des_por !== undefined) {
            formData.global_produto_valor_des_por = formDataOrig.global_produto_valor_des_por
          }

          // VERIFICA SE TEM CAMPO PARA ATUALIZAR
          if (Object.keys(formData).length <= 1) {
            callback(formDataOrig)
          } else {
            // QUEBRA SINCRONISMO DO VUE
            formData = JSON.parse(JSON.stringify({ lot: [ formData ] }))

            // REMOVE OS CAMPOS DE DESCONTO PARA CONTINUAR
            delete formDataOrig.global_produto_valor_des_fixo
            delete formDataOrig.global_produto_valor_des_por

            // CHAMA FUNÇÃO PARA COMUNICAR COM API
            this.$store.state.comunicaAPI('/demanda/dem-compra/p-des-global', 'PUT', formData, (retorno) => {
              // PEGA O RETORNO
              retorno = retorno.lot[0]

              // PEGA O VALOR RECEBIDO
              retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }

              // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
              if (retorno.code !== '200') {
                this.demEdiProDocTratarValidacao(retorno.message, retorno.code)
              } else {
                // VERIFICA SE TERÁ MAIS ALGUM CAMPO PARA ATUALIZAR
                if (Object.keys(formDataOrig).length === 0) {
                  // ATUALIZA OS DADOS E DESTRAVA A TELA
                  this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                    // DESTRAVA A TELA
                    this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

                    // SETA A MENSAGEM NA TELA
                    this.$store.state.TRATAR_RET_LOT_API(retorno)

                    // EXECUTA O CALLBACK RECEBIDO
                    callback(formDataOrig)
                  })
                } else {
                  callback(formDataOrig)                
                }
              }
            }, this.demEdiProDocSetarStatusGeral, this.demEdiProDocTratarValidacao)
          }

        }
      },
      demEdiProDocSalvar: function (callback = null) {
        if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1 || (this.cpntDemanda === 'compra' && [ 'NFe', 'NFCe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.cpntPDocTp) !== -1)) {
          this.demEdiProDocDemandaSalvar(callback)
        } else {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar = 'carregando'
          this.botoes.emitir = 'carregando'
  
          // TRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)
  
          // VERIFICA SE DEVE SALVAR O CONTATO
          this.demEdiProDocSalvarContatoNFCe((atualizado = false) => {
            // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            const FUN_MONTAR_FORMDATA_API = require('@/assets/js/Funcoes-Gerais.js').FUN_MONTAR_FORMDATA_API
    
            // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
            FUN_MONTAR_FORMDATA_API(this.campos, { disabled: false }).then((formData) => {
                // CONVERTE O VALOR SE ELE EXISTIR
              if ([ '', null, undefined ].indexOf(formData.j_p_doc_fin_ref_manual) === -1) {
                if (Object.keys(formData.j_p_doc_fin_ref_manual).length === 0) {
                  formData.j_p_doc_fin_ref_manual = null
                } else {
                  // PEGA TODAS AS CHAVES INFORMADAS
                  formData.j_p_doc_fin_ref_manual = JSON.stringify(Object.values(formData.j_p_doc_fin_ref_manual))
      
                  // REMOVE OS ESPAÇOS EXISTENTES
                  while (formData.j_p_doc_fin_ref_manual.indexOf(' ') !== -1) {
                    formData.j_p_doc_fin_ref_manual = formData.j_p_doc_fin_ref_manual.replace(' ', '')
                  }
    
                  // PEGA OS DADOS RECEBIDOS
                  formData.j_p_doc_fin_ref_manual = { mod: '', ca: JSON.parse(formData.j_p_doc_fin_ref_manual)[0] }
    
                  // SETA O MODELO DA NOTA
                  formData.j_p_doc_fin_ref_manual.mod = formData.j_p_doc_fin_ref_manual.ca.substring(20, 22)
                }
              }

              // LIMPA O VALOR SELECIONADO
              if (this.campos.informar_p_doc_dh_sai_ent.value !== this.campos.informar_p_doc_dh_sai_ent.valueIni && this.campos.informar_p_doc_dh_sai_ent.value === false) {
                formData.p_doc_dh_sai_ent = null
              } else if ((this.campos.informar_p_doc_dh_sai_ent.value !== this.campos.informar_p_doc_dh_sai_ent.valueIni && this.campos.informar_p_doc_dh_sai_ent.value === true) || (JSON.stringify(this.campos.p_doc_dh_sai_ent.value) !== JSON.stringify(this.campos.p_doc_dh_sai_ent.valueIni)) || (JSON.stringify(this.campos.p_doc_dh_sai_ent_hora.value) !== JSON.stringify(this.campos.p_doc_dh_sai_ent_hora.valueIni)) || (JSON.stringify(this.campos.p_doc_dh_sai_ent_minuto.value) !== JSON.stringify(this.campos.p_doc_dh_sai_ent_minuto.valueIni))) {
                formData.p_doc_dh_sai_ent = this.campos.p_doc_dh_sai_ent.value
              }
  
              // VERIFICA SE DEVE MONTAR A DATA E HORA
              if ([ '', null, undefined ].indexOf(formData.p_doc_dh_sai_ent) === -1) {
                // PREPARA PARA COLOCAR A DATA E HORA
                formData.p_doc_dh_sai_ent += ' '
                  
                // ADICIONA A HORA NO CAMPO
                formData.p_doc_dh_sai_ent += [ '', null, undefined, 'Invalid date' ].indexOf(this.campos.p_doc_dh_sai_ent_hora.value) !== -1 ? '00' : this.campos.p_doc_dh_sai_ent_hora.value.id
                
                // COLOCA A SEPARAÇÃO DA DATA
                formData.p_doc_dh_sai_ent += ':'
    
                // ADICIONA OS MINUTOS NO CAMPO
                formData.p_doc_dh_sai_ent += [ '', null, undefined, 'Invalid date' ].indexOf(this.campos.p_doc_dh_sai_ent_minuto.value) !== -1 ? '00' : this.campos.p_doc_dh_sai_ent_minuto.value.id
    
                // COLOCA A SEPARAÇÃO DA DATA
                formData.p_doc_dh_sai_ent += ':'
    
                // SETA OS SEGUNDOS
                formData.p_doc_dh_sai_ent += '00'
              }
  
              // REMOVE O CAMPO SE ELE EXISTIR
              if ([ undefined ].indexOf(formData.p_id_ven_cfg_intermediador) === -1 && this.demEdiProDocMostarIntermediador === false) {
                delete formData.p_id_ven_cfg_intermediador
              }
  
              // REMOVE O CAMPO SE ELE EXISTIR
              if (this.demEdiProDocMostarTransportadora === false) {
                if ([ undefined ].indexOf(formData.p_doc_fre_id) === -1) {
                  delete formData.p_doc_fre_id
                }
                if ([ undefined ].indexOf(formData.p_doc_fre_placa_uf) === -1) {
                  delete formData.p_doc_fre_placa_uf
                }
                if ([ undefined ].indexOf(formData.p_doc_fre_placa) === -1) {
                  delete formData.p_doc_fre_placa
                }
              }
  
              // DEIXA APENAS NUMEROS
              if ([ '', null, undefined ].indexOf(formData.p_doc_ca) === -1) {
                formData.p_doc_ca = formData.p_doc_ca.toString().match(/[0-9]+/g).join('')
              }
  
              // VERIFICA SE DEVE ATUALIZAR OS VOLUMES
              if ([ '', null, undefined ].indexOf(this.campos.p_doc_fre_volumes.value) === -1 && (this.campos.informar_p_doc_fre_volumes.value !== this.campos.informar_p_doc_fre_volumes.valueIni || JSON.stringify(this.campos.p_doc_fre_volumes.value) !== JSON.stringify(this.campos.p_doc_fre_volumes.valueIni))) {
              // if ([ '', null, undefined ].indexOf(this.campos.p_doc_fre_volumes.value) === -1 && this.campos.p_doc_fre_volumes.value.length >= 1) {
                if (this.campos.p_doc_fre_volumes.value.length >= 1) {
                  // SETA QUE TERÁ VOLUME PARA INSERIR
                  formData.p_doc_fre_vol = '1'

                  // PEGA OS DADOS DO VOLUME RECEBIDO
                  var volume = JSON.parse(JSON.stringify(this.campos.p_doc_fre_volumes.value[0]))
    
                  // DELETA AS CHAVES NÃO UTILIZADAS
                  delete volume.chave
                  delete volume.index
                  delete volume.nome
    
                  // ADICIONA OS VALORES PARA ATUALIZAÇÃO
                  formData = Object.assign(formData, volume)
                } else {
                  formData.p_doc_fre_vol = '0'
                }
              }

              // // VERIFICA SE DEVE MANDAR O CAMPO
              if ([ '', null, undefined ].indexOf(this.campos.p_doc_loc_embarque_cidade.value) === -1 && JSON.stringify(this.campos.p_doc_loc_embarque_cidade.value) !== JSON.stringify(this.campos.p_doc_loc_embarque_cidade.valueIni)) {
                formData.p_doc_exp_xLocExporta_id_cidade = (typeof this.campos.p_doc_loc_embarque_cidade.value === "string" ? this.campos.p_doc_loc_embarque_cidade.value : this.campos.p_doc_loc_embarque_cidade.value.id) 
              }
      
              this.demEdiProDocSalvarDesconto(formData, (_formDataEnvio) => {
                // VERIFICA SE TEM ALGUMA CAMPO PARA ATUALIZAR
                if (Object.keys(_formDataEnvio).length === 0) {
                  // APRESENTA A MENSAGEM
                  if (atualizado === false && callback === null) {
                    this.$store.state.msgWarn('WEB [406]: ' + 'Nenhum alteração foi realizada.', 'warning')
                  }
    
                  // SETA O STATUS DE CARREGANDO DO BOTÃO
                  this.botoes.salvar = ''
                  this.botoes.emitir = ''
    
                  // DESTRAVA A TELA
                  this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
    
                  // EXECUTA O CALLBACK RECEBIDO
                  if (callback !== null && typeof callback === 'function') {
                    callback()
                  }
                } else {
                  // INICIA A VARIAVEL DE ROTA
                  var router = ''

                  // FAZ A VERIFICAÇÃO DA ROTA QUE DEVE CHAMAR
                  switch (this.cpntDemanda) {
                    case 'venda':
                      
                      
                      // SETA O ID DA DEMANDA QUE DEVE ALTERAR
                      _formDataEnvio.cod_venda = this.cpntDemandaId

                      // SETA A ROTA QUE DEVE CHAMAR
                      router = '/venda'
                      break

                    case 'compra':
                      // SETA O ID DA DEMANDA QUE DEVE ALTERAR
                      _formDataEnvio.dem_compra = this.cpntDemandaId

                      // SETA A ROTA QUE DEVE CHAMAR
                      router = '/demanda/dem-compra/p-doc-manual'

                      // CONVERTE O VALOR EM LOT
                      _formDataEnvio = { lot: [ _formDataEnvio ] }
                      break
                  }

                  // CHAMA FUNÇÃO PARA COMUNICAR COM API
                  this.$store.state.comunicaAPI(router, 'PUT', _formDataEnvio, (retorno) => {
                    // PEGA O VALOR RECEBIDO
                    retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
        
                    // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
                    if (retorno.code !== '200') {
                      this.demEdiProDocTratarValidacao(retorno.message, retorno.code)
                    } else {
                      // ATUALIZA OS DADOS E DESTRAVA A TELA
                      this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => {
                        // DESTRAVA A TELA
                        this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
    
                        // EXECUTA O CALLBACK RECEBIDO
                        if (callback !== null && typeof callback === 'function') {
                          callback()
                        } else {
                          // APRESENTA A MENSAGEM DE SUCESSO
                          this.$store.state.TRATAR_RET_LOT_API(retorno)
    
                          // SETA O STATUS DE CARREGANDO DO BOTÃO
                          this.botoes.salvar = ''
                          this.botoes.emitir = ''
    
                          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                          this.time = new Date().getTime()
                        }
                      })
                    }
                  }, this.demEdiProDocSetarStatusGeral, this.demEdiProDocTratarValidacao)
                }  
              })
            }).catch(this.demEdiProDocSetarStatusGeral)
          })
        }
      },
      demEdiProDocTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => {
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar = ''
          this.botoes.emitir = ''

          // DESTRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
          
          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null && typeof callback === 'function') {
            callback()
          }
        })
      },
      demEdiProDocMostrarFormularioCartaCorrecao: function (atualizar = false) {
        // VERIFICA SE DEVE ABRIR OU FECHAR
        this.mostrarCartaCorrecao = !this.mostrarCartaCorrecao

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE ATUALIZAR OS DADOS
        if (atualizar === true) {
          // DESTRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

          // ATUALIZA OS DADOS E DESTRAVA A TELA
          this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { setTimeout(() => { this.demEdiProDocIniciar() }, 500) })
        }
      },
      demEdiProDocMostrarFormularioPagamento: function (chamarApi = false) {
        this.demEdiProDocSalvar(() => {
          // VERIFICA SE TEM O BOTÃO CONSULTAR
          if (this.cpntPDocAcoes.consultar === '1' || [ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1 || this.cpntPDV === true) {
            chamarApi = true
          }
  
          // SETA O STATUS DE CARREGANDO DO BOTÃO
          this.botoes.salvar = 'carregando'
          this.botoes.emitir = 'carregando'
  
          // SETA A FUNÇÃO DE FINALIZAÇÃO
          var finalizacao = () => {
            // DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
  
            // ATUALIZA OS DADOS E DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { setTimeout(() => { this.demEdiProDocIniciar() }, 500) })
  
            // SETA O STATUS DE CARREGANDO DO BOTÃO
            this.botoes.salvar = ''
            this.botoes.emitir = ''
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
  
          // VERIFICA SE A JANELA FOI FECHADA E SE DEVE EMITIR A NOTA
          if (chamarApi === false) {
            // SETA A FUNÇÃO QUE DEVE CHAMAR
            finalizacao = () => {
              // VERIFICA SE DEVE ABRIR OU FECHAR
              this.mostrarPagamentos = !this.mostrarPagamentos
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
    
              // SETA O STATUS DE CARREGANDO DO BOTÃO
              this.botoes.salvar = ''
              this.botoes.emitir = ''
    
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
  
              // DESTRAVA A TELA
              this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
            }
  
            // // VERIFICA SE DEVE SALVAR OU NÃO OS DADOS DA VENDA
            // if (this.mostrarPagamentos === false) {
            //   this.demEdiProDocSalvar(finalizacao)
            // } else {
            //   finalizacao()
            // }
            
            if (this.$store.state.mobile === true) {
              this.$router.push({ name: 'venda_numero_pgto', params: { cpntDemanda: this.cpntDemanda, cpntDemandaId: this.cpntDemandaId } })
            } else {
              finalizacao()
            }
          } else if (chamarApi === true) {
            // VERIFICA SE DEVE ABRIR OU FECHAR
            this.mostrarPagamentos = false
  
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
  
            // INICIA AS VARIAVEIS
            var router = ''
            var method = ''
            var formData = {}
  
            // VERIFICA SE DEVE REEMITIR OU EMITIR
            if (this.cpntPDocAcoes.emitir === '1') {
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/df/emitir'
  
              // SETA O METHOD QUE DEVE CHAMAR
              method = 'POST'
  
              // VERIFICA A DEMANDA QUE ESTÁ SENDO ENVIADA
              switch (this.cpntDemanda) {
                case 'venda':
                  formData = { j_ref: JSON.stringify([ { tp: 'p', m: '10', id: this.cpntDemandaId } ]) }
                  break
              
                case 'dev_cliente':
                  formData = { j_ref: JSON.stringify([ { tp: 'p', m: '59', id: this.cpntDemandaId } ]) }
                  break
  
                case 'dev_fornecedor':
                  formData = { j_ref: JSON.stringify([ { tp: 'p', m: '60', id: this.cpntDemandaId } ]) }
                  break
  
                case 'compra':
                  formData = { j_ref: JSON.stringify([ { tp: 'p', m: '11', id: this.cpntDemandaId } ]) }
                  break
              }
            } else if (this.cpntPDocAcoes.reemitir === '1') {
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/df/reemitir'
  
              // SETA O METHOD QUE DEVE CHAMAR
              method = 'PUT'
  
              // SETA O ID DO DOC_FISCAL
              formData = { j_df: JSON.stringify([ this.cpntPDocDocs ]) }
            } else if (this.cpntPDocAcoes.consultar === '1') {
              // SETA A ROTA QUE DEVE CHAMAR
              router = '/df/consultar'
  
              // SETA O METHOD QUE DEVE CHAMAR
              method = 'PUT'
  
              // SETA O ID DO DOC_FISCAL
              formData = { j_df: JSON.stringify([ this.cpntPDocDocs ]) }
            }
            
            // CHAMA FUNÇÃO PARA COMUNICAR COM API
            this.$store.state.comunicaAPI(router, method, formData, (retorno) => {
              // PEGA O VALOR RECEBIDO
              retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
  
              // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
              if (retorno.code !== '200') {
                this.demEdiProDocTratarValidacao(retorno.message, retorno.code, finalizacao)
              } else {
                // SETA O CAMPO COMO FALSE
                this.mostrarDetalhes = false
  
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(retorno)
  
                // FINALIZA O PROCESSO
                finalizacao()
              }
            }, this.demEdiProDocSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiProDocTratarValidacao(apiValid, apiStatus, finalizacao) })
          }
        })
      },
      demEdiProDocAtualizarLogs: function () {
        // CHAMA A FUNÇÃO PARA ATUALIZAR OS LOG DE COMUNICAÇÃO
        this.demEdiProDocAtualizarLogsTipo('log_comunicacao')

        // CHAMA A FUNÇÃO PARA ATUALIZAR OS LOG DE EMAIL
        this.demEdiProDocAtualizarLogsTipo('log_email')
      },
      demEdiProDocAtualizarLogsTipo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.demEdiProDocAtualizarLogsTipo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]
            
            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.dfLogsBuscarDados) === -1 && typeof elemento.dfLogsBuscarDados === 'function') {
              elemento.dfLogsBuscarDados()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      demEdiProDocConsultarChaveReferenciada: function (chave) {
        // IMPORA A FUNÇÃO
        const FUN_ABRIR_CONSULTA_CHAVE_ACESSO_SEFAZ = require('@/assets/js/Funcoes-Gerais.js').FUN_ABRIR_CONSULTA_CHAVE_ACESSO_SEFAZ
        
        // SOLICITA A ABERTURA DA CHAVE DE ACESSO
        FUN_ABRIR_CONSULTA_CHAVE_ACESSO_SEFAZ(chave)
      },
      demEdiProDocAdicionarChaveReferenciada: function () {
        // CHAVE DE RECEPÇÃO
        var chaveRec = this.campos.j_p_doc_ref_ca.apiRec
        if ([ '', null, undefined ].indexOf(chaveRec) === -1 && this.original[chaveRec] === undefined) {
          this.original[chaveRec] = this[chaveRec]
        }

        // INICIA O VETOR QUE SERÁ SETADO
        var vetor = JSON.parse(JSON.stringify(this.campos.j_p_doc_ref_ca.value))

        // INICIA A CHAVE QUE VAI SER ADICIONADA
        var chave = ''

        // INICIA O CONTADOR
        var contador = 0

        // MONTA A CHAVE PARA O VETOR
        while (chave === '') {
          // VERIFICA SE A CHAVE JÁ EXISTE
          if (vetor['_' + contador] === undefined) {
            chave = '_' + contador
          }

          // SOMA O CONTADOR DA CHAVE
          contador++
        }

        // INICIA UM NOVO INPUT
        vetor[chave] = ''

        // SETA O VALOR ATUALIZADO DO CAMPO
        this.$set(this.campos.j_p_doc_ref_ca, 'value', vetor)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocRemoverChaveReferenciada: function (index) {
        // CHAVE DE RECEPÇÃO
        var chaveRec = this.campos.j_p_doc_ref_ca.apiRec
        if ([ '', null, undefined ].indexOf(chaveRec) === -1 && this.original[chaveRec] === undefined) {
          this.original[chaveRec] = this[chaveRec]
        }

        // INICIA O VETOR QUE SERÁ SETADO
        var vetor = JSON.parse(JSON.stringify(this.campos.j_p_doc_ref_ca.value))

        // REMOVE A CHAVE SOLICITADA
        delete vetor[index]

        // INICIA O VETOR
        if (Object.keys(vetor).length === 0) {
          this.demEdiProDocOnChangeValue(false, this.campos.referenciar_j_p_doc_ref_ca.id)
        } else {
          // SETA O VALOR ATUALIZADO DO CAMPO
          this.$set(this.campos.j_p_doc_ref_ca, 'value', vetor)
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()
        }
      },
      demEdiProDocOnNovaTransportadora: function (nome) {
        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'contato', editar: true, id: 0, nome: nome }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar, id, dados) => {
          if (atualizar === true) {
            this.demEdiProDocOnChangeValue(dados, this.campos.p_doc_fre_id.id)
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      demEdiProDocOnReenviarNota: function () {
        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'REENVIAR_NOTA', id: this.cpntPDocFiscal.id }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = (atualizar) => {
          if (atualizar === true) {
            this.demEdiProDocAtualizarLogsTipo('log_email')
          }
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      demEdiProDocOnAbrirDocumentoFiscal: function (id, acao = '') {
        // VERIFICA AÇÃO QUE DEVE REALIZAR
        var botao = acao === '' ? 'danfe' : acao

        // ALTERA O PARAMETRO RECEBIDO 
        acao = acao === 'cce' ? '' : acao

        // SETA O STATUS PARA BOTÃO
        this.botoes[botao] = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA AÇÃO QUE DEVE REALIZAR
        acao = acao === '' ? this.danfeAcao : acao

        // INICIA A VARIAVEL PARA PARAMETRO
        var params = { tipo: 'ABRIR_DOC_FISCAL', id: id, acao: acao, origem: 'df' }

        // VERIFICA A ORIGEM QUE ESTÁ SENDO SOLICITADA
        if ([ 'compra' ].indexOf(this.cpntDemanda) !== -1 && [ 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.cpntPDocTp) !== -1) {
          // SETA O ID DA COMPRA
          params.id = this.cpntDemandaId.toString()

          // SETA A ORIGEM DA SOLICITAÇÃO
          params.origem = 'compra_dist'
        }

        // SETA O CALLBACK QUE DEVE EXECUTAR
        params.callback = () => {
          setTimeout(() => {
            // SETA O STATUS PARA BOTÃO
            this.botoes[botao] = ''

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, 1000)
        }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params) 
      },
      demEdiProDocAlterarVolumes: function (atualizar, valores) {
        // MANDA ABRIR A DIALOG
        this.campos.informar_p_doc_fre_volumes.dialog = false

        // VERIFICA SE DEVE ATUALIZAR O VALOR
        if (atualizar === true) {
          this.$set(this.campos.p_doc_fre_volumes, 'value', valores)
        }

        // VERIFICA SE DEVE FICAR MARCADO COM SIM O TOGGLES
        if (atualizar === true || this.campos.p_doc_fre_volumes.value.length === 0) {
          this.$set(this.campos.informar_p_doc_fre_volumes, 'value', valores.length >= 1)
        }

        // VERIFICA SE TEM QUE ATUALIZAR OS DADOS DA DEMANDA
        if ([ 'dev_cliente', 'dev_fornecedor' ].indexOf(this.cpntDemanda) !== -1) {
          this.$parent.$emit('DEMANDA_BUSCAR_VALORES')
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      demEdiProDocSugerirNatOpe: function () {
        if ([ '', null, undefined ].indexOf(this.campos.p_doc_nat_ope.value) !== -1 || confirm('Já existe uma Natureza da Operação digitada, deseja alterar para a sugestão do sistema?')) {
          // TRAVA A TELA
          this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)
  
          // REMOVE O FOCUS DE QUALQUER CAMPO
          if (document.activeElement !== document.body) {
            document.activeElement.blur()
          }
  
          // SETA O STATUS DE CARREGANDO NO BOTÃO
          this.campos.sugerirBT.status = 'carregando'
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // SETA O NOME DA ROTA QUE DEVE CHAMAR
          var router = ''

          switch (this.cpntDemanda) {
            case 'dev_cliente':
              router = '/demanda/df-sug-nat-operacao/get/dem_dev_cliente/'
              break

            case 'dev_fornecedor':
              router = '/demanda/df-sug-nat-operacao/get/dem_dev_fornecedor/'
              break
          
            case 'venda':
              router = '/venda/produto/df/sug-nat-ope/get/'
              break

            case 'compra':
              router = '/demanda/df-sug-nat-operacao/get/dem_compra/'
              break
          }

          // COMUNICA COM A API
          this.$store.state.comunicaAPI(router, 'GET', this.cpntDemandaId, (retorno) => {
            // SETA O VALOR RECEBIDO
            if ([ '', null, undefined ].indexOf(retorno.data) === -1) {
              // SETA A NOVA NATUREZA DA OPERAÇÃO
              this.campos.p_doc_nat_ope.value = retorno.data

              // APRESETAN A MENSAGEM QUE A INFORMAÇÃO FOI GERADA
              this.$store.state.msgWarn('WEB [200]: Sugestão para natureza da operação gerada com sucesso.', 'success')
            }

            // TRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)
    
            // SETA O STATUS DE CARREGANDO NO BOTÃO
            this.campos.sugerirBT.status = ''
    
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, (apiError, apiErro) => {
            // VERIFICA A MENSAGEM RECEBIDA
            if (apiErro.message.indexOf('Nenhum produto com CFOP selecionado para fazer uma sugestão.') !== -1) {
              this.demEdiProDocRealizarFocusCampo('p_doc_nat_ope')
            }

            // TRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

            // SETA O STATUS DE CARREGANDO NO BOTÃO
            this.campos.sugerirBT.status = apiError
    
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        }
      },
      demEdiProDocRealizarFocusCampo: function (campo, tentativa = 0) {
        if (tentativa <= 10) {
          // SETA A FUNÇÃO DE REINICIAR
          var reiniciar = () => { setTimeout(() => { this.demEdiProDocRealizarFocusCampo(campo, (tentativa + 1)) }, 100) }

          // VERIFICA SE O CAMPO EXISTE
          if (tentativa >= 2 && [ '', null, undefined ].indexOf(this.$refs[campo]) === -1) {
            // PEGA O ELEMENTO QUE DEVE DAR FOCUS
            var elemento = Array.isArray(this.$refs[campo]) === true ? this.$refs[campo][0] : this.$refs[campo]

            // VERIFICA SE O ELEMENTO EXISTE
            if ([ '', null, undefined ].indexOf(elemento) === -1 && [ '', null, undefined ].indexOf(elemento.cpntRealizarFocus) === -1 && typeof elemento.cpntRealizarFocus === 'function') {
              elemento.cpntRealizarFocus()
            } else {
              reiniciar()
            }
          } else {
            reiniciar()
          }
        }
      },
      demEdiProDocAlterarDesvinculacao: function (value) {
        // SETA O VALOR RECEBIDO
        this.mostrarDesvincular = value

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE FOI ABERTO A TELA DE DESVINCULAÇÃO
        if (value === '') {
          this.demEdiProDocRealizarFocusCampo('motivo')
        }
      },
      demEdiProDocRealizarDesvinculacao: function () {
        // SETA O STATUS DO BOTÃO
        this.demEdiProDocAlterarDesvinculacao('carregando')

        // INICIA AS VARIAVEIS
        var router = ''
        var formData = {}

        // VERIFICA A AÇÃO QUE DEVE EXECUTAR
        switch (this.cpntPDocAcoes.cancelar) {
          case '1':
            // PEGA O NOME DA ROTA QUE DEVE CHAMAR
            router = '/df/cancelar'

            // SETA O FORMULARIO QUE DEVE SER ENVIADO
            formData = { j_df: JSON.stringify([ this.cpntPDocFiscal.id ]) }
            break

          case '0':
            // PEGA O NOME DA ROTA QUE DEVE CHAMAR
            router = '/df/inutilizar'

            // SETA O FORMULARIO QUE DEVE SER ENVIADO
            formData = {
              doc_modelo: this.cpntPDocFiscal.DocModelo,
              doc_num_ini: this.cpntPDocFiscal.DocNumero,
              doc_num_fin: this.cpntPDocFiscal.DocNumero
            }
            break
        }

        // SETA MAIS A JUSTIFICATIVA PREENCHIDA NA TELA
        formData.justificativa = this.campos.motivo.value

        // SETA A FUNÇÃO DE FINALIZAÇÃO
        var finalizacao = () => { this.demEdiProDocAlterarDesvinculacao(null) }

        // // COMUNICA COM A API
        this.$store.state.comunicaAPI(router, 'POST', formData, (retorno) => {
          // PEGA O VALOR RECEBIDO
          retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }

          // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
          if (retorno.code !== '200') {
            this.demEdiProDocTratarValidacao(retorno.message, retorno.code, finalizacao)
          } else {
            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(retorno)

            // FINALIZA O PROCESSO
            finalizacao()

            // DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

            // ATUALIZA OS DADOS E DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { setTimeout(() => { this.demEdiProDocIniciar() }, 500) })
          }
        }, this.demEdiProDocSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiProDocTratarValidacao(apiValid, apiStatus, finalizacao) })
      },
      demEdiProDocConfirmaAlteracaoDoc: function (confirma = false) {
        // CHAMA A FUNÇÃO PARA ATUALIZAR OS DADOS
        if (confirma === true) {
          this.demEdiProDocAlterarDocumento()
        } else if (this.confirmacao === true) {
          this.demEdiProDocSetarValorCampo('p_doc_tp')
        }

        // FECHA A TELA DE CONFIRMAÇÃO DE ALTERAÇÃO
        this.confirmacao = confirma === true ? false : !this.confirmacao

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DA TELA
        this.demEdiProDocSetarStatusGeral('')
      },
      demEdiProDocOnBuscarEmbarqueEstado: function (callback) {
        // SETA OS VALORES RECEBIDOS
        this.$set(this.campos.p_doc_loc_embarque_uf_saida_pais, 'options', this.$store.state.UFs)

        // HABILITA O CAMPO CIDADE
        this.$set(this.campos.p_doc_loc_embarque_cidade, 'disabled', true)
        this.$set(this.campos.p_doc_loc_embarque_cidade, 'options', [])
        this.$set(this.campos.p_doc_loc_embarque_cidade, 'value', '')

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // EXECUTA A FUNÇÃO CALLBACK
        callback()
      },
      demEdiProDocOnBuscarEmbarqueCidade: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, cidade: null }

          // SETA O WHERE DO ESTADO SELECIONADO
          queryGet.where = { f: 'uf', o: '=', v: (typeof this.campos.p_doc_loc_embarque_uf_saida_pais.value === "string" ? this.campos.p_doc_loc_embarque_uf_saida_pais.value : this.campos.p_doc_loc_embarque_uf_saida_pais.value.uf) }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/cep-cidade/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProDocOnBuscarEmbarqueCidade(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_doc_loc_embarque_cidade.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_doc_loc_embarque_cidade.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_doc_loc_embarque_cidade.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProDocOnBuscarIntermediador: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null, cnpj: null, usu_intermediador: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'status', o: '=', v: '1' }

          // SETA A ORDENAÇÃO DO CAMPO
          queryGet.order = { nome: 'asc' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/venda/config/intermediador/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.demEdiProDocOnBuscarIntermediador(callback, id, Number(apiSuccess.countAll), registros)
          }, (apiError) => {
            // SETA OS VALORES RECEBIDOS
            this.campos.p_id_ven_cfg_intermediador.status = apiError

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          })
        } else if (total === 0) {
          // SETA OS VALORES RECEBIDOS
          this.campos.p_id_ven_cfg_intermediador.onBuscarOptions = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        } else {
          // FORMATA OS CNPJ RECEBIDOS
          for (var indexR in registros) {
            if ([ '', null, undefined ].indexOf(registros[indexR].cnpj) === -1 && registros[indexR].cnpj.length === 14) {
              registros[indexR]._cnpj = registros[indexR].cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
            }
          }

          // SETA OS VALORES RECEBIDOS
          this.campos.p_id_ven_cfg_intermediador.options = registros

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA A FUNÇÃO CALLBACK
          callback()
        }
      },
      demEdiProDocPreVisualizar: function () {
        // SETA O STATUS DE CARREGANDO DO BOTÃO
        this.botoes.salvar = 'carregando'
        this.botoes.emitir = 'carregando'

        // TRAVA A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

        // INICIA AS VARIAVEIS
        var router = ''
        var method = ''
        var formData = {}

        // VERIFICA SE DEVE REEMITIR OU EMITIR
        switch (this.cpntPDocAcoes.emitir === '1') {
          case true:
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/df/emitir'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'POST'

            // VERIFICA A DEMANDA QUE ESTÁ SENDO ENVIADA
            switch (this.cpntDemanda) {
              case 'venda':
                formData = { j_ref: JSON.stringify([ { tp: 'p', m: '10', id: this.cpntDemandaId } ]) }
                break
            
              case 'dev_cliente':
                formData = { j_ref: JSON.stringify([ { tp: 'p', m: '59', id: this.cpntDemandaId } ]) }
                break
            
              case 'dev_fornecedor':
                formData = { j_ref: JSON.stringify([ { tp: 'p', m: '60', id: this.cpntDemandaId } ]) }
                break

              case 'compra':
                formData = { j_ref: JSON.stringify([ { tp: 'p', m: '11', id: this.cpntDemandaId } ]) }
                break
            }
            break

          default:
            // SETA A ROTA QUE DEVE CHAMAR
            router = '/df/reemitir'

            // SETA O METHOD QUE DEVE CHAMAR
            method = 'PUT'

            // SETA O ID DO DOC_FISCAL
            formData = { j_df: JSON.stringify([ this.cpntPDocDocs ]) }
            break
        }

        // SETA O LAG QUE DEVE SER PREVISUALIZAÇÃO
        formData.pre_visualizar = 'sim'
        
        // CHAMA FUNÇÃO PARA COMUNICAR COM API
        this.$store.state.comunicaAPI(router, method, formData, (retorno) => {
          // PEGA O VALOR RECEBIDO
          retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : Object.assign({ code: '200', message: retorno.message }, retorno)

          // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
          if (retorno.code !== '200') {
            this.demEdiProDocTratarValidacao(retorno.message, retorno.code)
          } else {
            // SETA OS VALORES RECEBIDOS
            this.previsualizar = retorno.data

            // SETA O STATUS DE CARREGANDO DO BOTÃO
            this.botoes.salvar = ''
            this.botoes.emitir = ''

            // DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        }, this.demEdiProDocSetarStatusGeral, (apiValid, apiStatus) => { this.demEdiProDocTratarValidacao(apiValid, apiStatus) })
      },
      demEdiProDocExcluirTodosVolumes: function (callback) {
        if (([ '', null, undefined ].indexOf(this.cpntPDocFreVolumes) !== -1 || Array.isArray(this.cpntPDocFreVolumes) === false || this.cpntPDocFreVolumes.length === 0) === false) {
          // INICIA O FORMULARIO QUE SERÁ ENVAIDO PARA API
          var formData = []
  
          // MONTA O VETOR QUE DEVE ENVIAR PARA EXCLUIR
          for (var index in this.cpntPDocFreVolumes) {
            formData.push({ id: this.cpntPDocFreVolumes[index].id })
          }
  
          // CONVERTE O VALOR EM LOT
          formData = { lot: formData }
  
          // INICIA A VARIAVEL DE ROTA
          var router = ''
  
          // VERIFICA A ROTA QUE DEVE CHAMAR
          switch (this.cpntDemanda) {
            case 'dev_cliente':
              router = '/demanda/dem-dev-cliente/dem-df-volume'
              break
  
            case 'dev_fornecedor':
              router = '/demanda/dem-dev-fornecedor/dem-df-volume'
              break
  
            case 'compra':
              router = '/demanda/dem-compra/dem-df-volume'
              break
          }
  
          // FAZ A COMUNICAÇÃO COM A API
  
          // FAZ A COMUNICAÇÃO COM A API
          this.$store.state.comunicaAPI(router, 'DELETE', formData, (retorno) => {
            // PEGA O VALOR RECEBIDO
            retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }
  
            // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
            if (retorno.code !== '200') {
              this.demEdiProDocTratarValidacao(retorno.message, retorno.code)
            } else {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)
              
              // MANDA EXCLUIR A ABA
              callback()
            }
          }, this.demEdiProDocSetarStatusGeral, this.demEdiProDocTratarValidacao)
        } else {
          callback()
        }
      },
      demEdiProAtualizarAliquotaAplicavel: function () {
        // DESTRAVA A TELA
        this.$parent.$emit('DEMANDA_TRAVAR_TELA', true)

        // INICIA O FORMULARIO QUE SERÁ ENVAIDO PARA API
        var formData = {}  

        // CONVERTE O VALOR EM LOT
        formData = { p_doc_icms_aa_flag: '1' }

        // INICIA A VARIAVEL DE ROTA
        var router = ''

        // VERIFICA A ROTA QUE DEVE CHAMAR
        switch (this.cpntDemanda) {
          case 'venda':
            // SETA O ID DA DEMANDA QUE DEVE ALTERAR
            formData.cod_venda = this.cpntDemandaId

            // SETA A ROTA QUE DEVE CHAMAR
            router = '/venda'
            break
        }

        // FAZ A COMUNICAÇÃO COM A API

        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI(router, 'PUT', formData, (retorno) => {
          // PEGA O VALOR RECEBIDO
          retorno = [ '', null, undefined ].indexOf(retorno.lot) === -1 ? retorno.lot[0] : { code: '200', message: retorno.message }

          // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
          if (retorno.code !== '200') {
            this.demEdiProDocTratarValidacao(retorno.message, retorno.code)
          } else {
            // DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_TRAVAR_TELA', false)

            // ATUALIZA OS DADOS E DESTRAVA A TELA
            this.$parent.$emit('DEMANDA_BUSCAR_VALORES', () => { })

            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(retorno)
          }
        }, this.demEdiProDocSetarStatusGeral, this.demEdiProDocTratarValidacao)
      }
    },
    computed: {
      demEdiProDocVerificarCampoNFe: function () {
        return [ 'NFe', 'NFeFornecedor' ].indexOf(this.cpntPDocTp) !== -1
      },
      demEdiProDocVerificarNotaFiscal: function () {
        return [ 'NFe', 'NFCe', 'NFeFornecedor', 'NFCeFornecedor' ].indexOf(this.cpntPDocTp) !== -1
      },
      demEdiProDocDisabilitarExclusaoReferencia: function () {
        return [ '4' ].indexOf(this.campos.p_doc_fin.value) !== -1 && Object.values(this.campos.j_p_doc_ref_ca.value).length === 1
      },
      demEdiProDocMontarValorReferenciar: function () {
        return this.demEdiProDocVerificarCampoNFe === true && (([ '', null, undefined ].indexOf(this.campos.p_doc_fin.value) === -1 && [ '4' ].indexOf(this.campos.p_doc_fin.value.id) !== -1) || this.campos.referenciar_j_p_doc_ref_ca.value === true)
      },
      demEdiProDocMostarReferenciar: function () {
        return this.demEdiProDocVerificarCampoNFe === true && ([ '', null, undefined ].indexOf(this.campos.p_doc_fin.value) === -1 && [ '1' ].indexOf(this.campos.p_doc_fin.value.id) !== -1)
      },
      demEdiProDocMostarPlacaTransporte: function () {
        return [ '', null, undefined ].indexOf(this.campos.p_doc_fre_placa_uf.value) === -1 && [ '', null, undefined ].indexOf(this.campos.p_doc_fre_placa_uf.value.uf) === -1
      },
      demEdiProDocMostarTransportadora: function () {
        return [ '', null, undefined ].indexOf(this.campos.p_doc_fre_tp.value) === -1 && [ '0', '1', '2' ].indexOf(this.campos.p_doc_fre_tp.value.id) !== -1
      },
      demEdiProDocMostarIntermediador: function () {
        return this.cpntDemanda !== 'compra' && [ '', null, undefined ].indexOf(this.campos.p_doc_ind_pres.value) === -1 && [ '1', '2', '3', '4', '9' ].indexOf(this.campos.p_doc_ind_pres.value.id) !== -1
      },
      demEdiProDocValorTipoDesconto: function () {
        return (typeof this.campos.p_doc_des_t.value === 'string' ? this.campos.p_doc_des_t.value : this.campos.p_doc_des_t.value.id)
      }
    },
    watch: {
      cpntPDocRefChave: function () {
        this.demEdiProDocSetarValorCampo('j_p_doc_ref_ca', false, true)
      },
      cpntIdConCnpjCpf: function () {
        this.demEdiProDocSetarValorCampo('cnpj_cpf', false, true)
      },
      cpntPDocTpOptions: function () {
        this.demEdiProDocSetarValorCampo('p_doc_tp', false, true)
      },
      cpntPDocTp: function () {
        this.demEdiProDocIniciar()
      },
      cpntPDocOpe: function () {
        this.demEdiProDocSetarValorCampo('p_doc_ope', false, true)
      },
      cpntPDocNatOpe: function () {
        this.demEdiProDocSetarValorCampo('p_doc_nat_ope', false, true)
      },
      cpntPDocFin: function () {
        this.demEdiProDocSetarValorCampo('p_doc_fin', false, true)
      },
      cpntPDocIndPres: function () {
        this.demEdiProDocSetarValorCampo('p_doc_ind_pres', false, true)
      },
      cpntPDocIntermediador: function () {
        this.demEdiProDocSetarValorCampo('p_id_ven_cfg_intermediador', false, true)
      },
      cpntPDocFreTp: function () {
        this.demEdiProDocSetarValorCampo('p_doc_fre_tp', false, true)
      },
      cpntPDocFrePlacaUf: function () {
        this.demEdiProDocSetarValorCampo('p_doc_fre_placa_uf', false, true)
      },
      cpntPDocFrePlaca: function () {
        this.demEdiProDocSetarValorCampo('p_doc_fre_placa', false, true)
      },
      cpntPDocFreVolumes: function () {
        this.demEdiProDocSetarValorCampo('p_doc_fre_volumes', false, true)
        this.demEdiProDocSetarValorCampo('informar_p_doc_fre_volumes', false, true)
      },
      cpntPDocEstadoEmbarque: function () {
        this.demEdiProDocSetarValorCampo('p_doc_loc_embarque_uf_saida_pais', false, true)
      },
      cpntPDocCidadeEmbarque: function () {
        this.demEdiProDocSetarValorCampo('p_doc_loc_embarque_cidade', false, true)
      },
      cpntPDocLocalDespacho: function () {
        this.demEdiProDocSetarValorCampo('p_doc_loc_embarque_despacho', false, true)
      },
      cpntPDocRetPrevA: function () {
        this.demEdiProDocSetarValorCampo('p_doc_ret_prev_a', false, true)
      },
      cpntPDocDataHoraSaiEnt: function () {
        this.demEdiProDocSetarValorCampo('p_doc_dh_sai_ent', false, true)
        this.demEdiProDocSetarValorCampo('p_doc_dh_sai_ent_hora', false, true)
        this.demEdiProDocSetarValorCampo('p_doc_dh_sai_ent_minuto', false, true)
      },
      cpntPDocManualDes: function () {
        this.demEdiProDocSetarValorCampo('p_doc_des', false, true)
      },
      '$store.state.cluNfEntrada': function () {
        this.demEdiProDocSetarValorCampo('p_doc_ope', false, true)
      },
      cpntPDocManualDataEmissao: function () {
        this.demEdiProDocSetarValorCampo('p_doc_emi', false, true)
      },
      cpntPDocManualChaveAcesso: function () {
        this.demEdiProDocSetarValorCampo('p_doc_ca', false, true)
      },
      cpntPDocManualNumero: function () {
        this.demEdiProDocSetarValorCampo('p_doc_n', false, true)
      },
      cpntPDocManualSerie: function () {
        this.demEdiProDocSetarValorCampo('p_doc_s', false, true)
      },
      cpntPDocManualFrete: function () {
        this.demEdiProDocSetarValorCampo('p_doc_vf', false, true)
      },
      cpntPDocManualSeguro: function () {
        this.demEdiProDocSetarValorCampo('p_doc_vs', false, true)
      },
      // cpntPDocDesconto: function () {
      //   this.demEdiProDocSetarValorCampo('p_doc_des_t', false, true)
      //   this.demEdiProDocSetarValorCampo('p_doc_des_v', false, true)
      //   this.demEdiProDocSetarValorCampo('p_doc_des_p', false, true)
      // },
      'cpntPDocDesconto.global_valor': function () {
        this.demEdiProDocSetarValorCampo('p_doc_des_t', false, true)
        this.demEdiProDocSetarValorCampo('p_doc_des_v', false, true)
        this.demEdiProDocSetarValorCampo('p_doc_des_p', false, true)
      },
      cpntPDocManualOda: function () {
        this.demEdiProDocSetarValorCampo('p_doc_od', false, true)
      }
    }
  }
</script>
